(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebda6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebda6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aNHqn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VNode = void 0;

var $7WkDo = parcelRequire("7WkDo");

var $e5wYp = parcelRequire("e5wYp");
var $7dd02a2fa38a0298$var$VNode = /** @class */ function() {
    function VNode(_b) {
        var e_1, _c;
        var children = _b.children, meta = $7WkDo.__rest(_b, [
            "children"
        ]);
        Object.assign(this, meta);
        try {
            for(var _d = $7WkDo.__values(children || []), _e = _d.next(); !_e.done; _e = _d.next()){
                var vNode = _e.value;
                if (_a.isFragment(vNode)) this.children = $7WkDo.__spreadArray($7WkDo.__spreadArray([], $7WkDo.__read(this.children || []), false), $7WkDo.__read(vNode.children || []), false);
                else this.children = $7WkDo.__spreadArray($7WkDo.__spreadArray([], $7WkDo.__read(this.children || []), false), [
                    vNode
                ], false);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var tagName = meta.tagName, is = meta.is, props = meta.props;
        if (!tagName && !(props === null || props === void 0 ? void 0 : props.className) && !is) return;
        this.selector = [
            tagName === null || tagName === void 0 ? void 0 : tagName.toLowerCase(),
            (props === null || props === void 0 ? void 0 : props.className) && ".".concat(props.className.trim().replace(/\s+/, ".")),
            is && '[is="'.concat(is, '"]')
        ].filter(Boolean).join("");
    }
    VNode.isFragment = function(_b) {
        var key = _b.key, node = _b.node, children = _b.children, rest = $7WkDo.__rest(_b, [
            "key",
            "node",
            "children"
        ]);
        for(var key_1 in rest)if (!(0, $e5wYp.isEmpty)(rest[key_1])) return false;
        return true;
    };
    VNode.fromDOM = function(node) {
        var _this = this;
        if (node instanceof Text) return new _a({
            node: node,
            text: node.nodeValue
        });
        if (!(node instanceof Element)) return new _a({
            node: node
        });
        var _b = node, tagName = _b.tagName, attributes = _b.attributes, style = _b.style, childNodes = _b.childNodes;
        var vNode = {
            node: node,
            tagName: tagName.toLowerCase(),
            is: node.getAttribute("is")
        };
        var props = Array.from(attributes, function(_b) {
            var name = _b.name, value = _b.value;
            return name !== "style" && [
                _this.attrsMap[name] || name,
                value
            ];
        }).filter(Boolean);
        if (props[0]) vNode.props = Object.fromEntries(props);
        var styles = Array.from(style, function(key) {
            return [
                key,
                style[key]
            ];
        });
        if (styles[0]) vNode.style = Object.fromEntries(styles);
        var children = Array.from(childNodes, function(node) {
            return _a.fromDOM(node);
        });
        if (children[0]) vNode.children = children;
        return new _a(vNode);
    };
    var _a;
    _a = VNode;
    VNode.propsMap = {
        className: "class",
        htmlFor: "for"
    };
    VNode.attrsMap = Object.fromEntries(Object.entries(_a.propsMap).map(function(item) {
        return item.reverse();
    }));
    return VNode;
}();
module.exports.VNode = $7dd02a2fa38a0298$var$VNode;

});
parcelRegister("7WkDo", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $5c7df4bf87d79539$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $5c7df4bf87d79539$export$3c9a16f847548506; });
$parcel$export(module.exports, "__generator", function () { return $5c7df4bf87d79539$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $5c7df4bf87d79539$export$f33643c0debef087; });
$parcel$export(module.exports, "__values", function () { return $5c7df4bf87d79539$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $5c7df4bf87d79539$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $5c7df4bf87d79539$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $8OALW = parcelRequire("8OALW");
var $5c7df4bf87d79539$var$extendStatics = function extendStatics1(d, b) {
    $5c7df4bf87d79539$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c7df4bf87d79539$var$extendStatics(d, b);
};
function $5c7df4bf87d79539$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c7df4bf87d79539$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c7df4bf87d79539$export$18ce0697a983be9b = function __assign1() {
    $5c7df4bf87d79539$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c7df4bf87d79539$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c7df4bf87d79539$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c7df4bf87d79539$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c7df4bf87d79539$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c7df4bf87d79539$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c7df4bf87d79539$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c7df4bf87d79539$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $8OALW._)(x)) === "symbol" ? x : "".concat(x);
}
function $5c7df4bf87d79539$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c7df4bf87d79539$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c7df4bf87d79539$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c7df4bf87d79539$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c7df4bf87d79539$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c7df4bf87d79539$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c7df4bf87d79539$export$45d3717a4c69092e(o, m, p);
}
function $5c7df4bf87d79539$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c7df4bf87d79539$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c7df4bf87d79539$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c7df4bf87d79539$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c7df4bf87d79539$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c7df4bf87d79539$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c7df4bf87d79539$export$10c90e4f7922046c(v) {
    return this instanceof $5c7df4bf87d79539$export$10c90e4f7922046c ? (this.v = v, this) : new $5c7df4bf87d79539$export$10c90e4f7922046c(v);
}
function $5c7df4bf87d79539$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c7df4bf87d79539$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c7df4bf87d79539$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c7df4bf87d79539$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c7df4bf87d79539$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c7df4bf87d79539$export$19a8beecd37a4c45 === "function" ? $5c7df4bf87d79539$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c7df4bf87d79539$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c7df4bf87d79539$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c7df4bf87d79539$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c7df4bf87d79539$export$45d3717a4c69092e(result, mod, k);
    }
    $5c7df4bf87d79539$var$__setModuleDefault(result, mod);
    return result;
}
function $5c7df4bf87d79539$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c7df4bf87d79539$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c7df4bf87d79539$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c7df4bf87d79539$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c7df4bf87d79539$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c7df4bf87d79539$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c7df4bf87d79539$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c7df4bf87d79539$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c7df4bf87d79539$export$2e2bcd8739ae039 = {
    __extends: $5c7df4bf87d79539$export$a8ba968b8961cb8a,
    __assign: $5c7df4bf87d79539$export$18ce0697a983be9b,
    __rest: $5c7df4bf87d79539$export$3c9a16f847548506,
    __decorate: $5c7df4bf87d79539$export$29e00dfd3077644b,
    __param: $5c7df4bf87d79539$export$d5ad3fd78186038f,
    __metadata: $5c7df4bf87d79539$export$f1db080c865becb9,
    __awaiter: $5c7df4bf87d79539$export$1050f835b63b671e,
    __generator: $5c7df4bf87d79539$export$67ebef60e6f28a6,
    __createBinding: $5c7df4bf87d79539$export$45d3717a4c69092e,
    __exportStar: $5c7df4bf87d79539$export$f33643c0debef087,
    __values: $5c7df4bf87d79539$export$19a8beecd37a4c45,
    __read: $5c7df4bf87d79539$export$8d051b38c9118094,
    __spread: $5c7df4bf87d79539$export$afc72e2116322959,
    __spreadArrays: $5c7df4bf87d79539$export$6388937ca91ccae8,
    __spreadArray: $5c7df4bf87d79539$export$1216008129fb82ed,
    __await: $5c7df4bf87d79539$export$10c90e4f7922046c,
    __asyncGenerator: $5c7df4bf87d79539$export$e427f37a30a4de9b,
    __asyncDelegator: $5c7df4bf87d79539$export$bbd80228419bb833,
    __asyncValues: $5c7df4bf87d79539$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c7df4bf87d79539$export$4fb47efe1390b86f,
    __importStar: $5c7df4bf87d79539$export$c21735bcef00d192,
    __importDefault: $5c7df4bf87d79539$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c7df4bf87d79539$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c7df4bf87d79539$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c7df4bf87d79539$export$81fdc39f203e4e04,
    __addDisposableResource: $5c7df4bf87d79539$export$88ac25d8e944e405,
    __disposeResources: $5c7df4bf87d79539$export$8f076105dc360e92
};

});
parcelRegister("8OALW", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $66af847259ac47af$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $66af847259ac47af$export$5f0017c582d45a2d; });
function $66af847259ac47af$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("e5wYp", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $a41b1c278196f7ae$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "toHyphenCase", function () { return $a41b1c278196f7ae$export$3f34ca2fef821bbd; });
$parcel$export(module.exports, "toCamelCase", function () { return $a41b1c278196f7ae$export$86f54f62aa7a7514; });
$parcel$export(module.exports, "uniqueID", function () { return $a41b1c278196f7ae$export$89912e019eef22aa; });
$parcel$export(module.exports, "DiffStatus", function () { return $a41b1c278196f7ae$export$2ddabb89308e1a22; });
$parcel$export(module.exports, "diffKeys", function () { return $a41b1c278196f7ae$export$14527669107aa301; });
$parcel$export(module.exports, "groupBy", function () { return $a41b1c278196f7ae$export$3f063810d7bf01bd; });
$parcel$export(module.exports, "splitArray", function () { return $a41b1c278196f7ae$export$697c3df919c0e61a; });
$parcel$export(module.exports, "Day", function () { return $a41b1c278196f7ae$export$7a9a31a911eb9a20; });
$parcel$export(module.exports, "formatDate", function () { return $a41b1c278196f7ae$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "changeMonth", function () { return $a41b1c278196f7ae$export$62ad822b3a5fd9a0; });
$parcel$export(module.exports, "parseJSON", function () { return $a41b1c278196f7ae$export$27924e57e9afff7f; });
$parcel$export(module.exports, "templateOf", function () { return $a41b1c278196f7ae$export$2ee022bbbc550b25; });
$parcel$export(module.exports, "elementTypeOf", function () { return $a41b1c278196f7ae$export$a549dd5cef7f8327; });
$parcel$export(module.exports, "isHTMLElementClass", function () { return $a41b1c278196f7ae$export$8eece510bcb9c62c; });
$parcel$export(module.exports, "tagNameOf", function () { return $a41b1c278196f7ae$export$b8a1af58c024fefd; });
$parcel$export(module.exports, "stringifyDOM", function () { return $a41b1c278196f7ae$export$b0709844452f8b6b; });
$parcel$export(module.exports, "importCSS", function () { return $a41b1c278196f7ae$export$7cd14c57bbb84350; });
$parcel$export(module.exports, "delegate", function () { return $a41b1c278196f7ae$export$10b1921597150314; });
$parcel$export(module.exports, "documentReady", function () { return $a41b1c278196f7ae$export$3e2b244719956741; });

var $hP6lv = parcelRequire("hP6lv");

var $kL1BW = parcelRequire("kL1BW");

var $cc1Ug = parcelRequire("cc1Ug");

var $gmv3D = parcelRequire("gmv3D");

var $kbtRr = parcelRequire("kbtRr");

var $kZtbK = parcelRequire("kZtbK");

var $aPY27 = parcelRequire("aPY27");

var $f9EKS = parcelRequire("f9EKS");

var $jjggo = parcelRequire("jjggo");

var $hzAa9 = parcelRequire("hzAa9");

var $fIpBC = parcelRequire("fIpBC");

var $kVAOt = parcelRequire("kVAOt");

var $7sqYf = parcelRequire("7sqYf");

var $SZ4bt = parcelRequire("SZ4bt");

var $7WkDo = parcelRequire("7WkDo");

var $7WkDo = parcelRequire("7WkDo");
function $a41b1c278196f7ae$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $a41b1c278196f7ae$var$$9b05bcda60cc529c$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $a41b1c278196f7ae$export$61cc6ed0f143570b;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $a41b1c278196f7ae$export$dd1bc94b04021eeb;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $a41b1c278196f7ae$export$a09f818797e212c4;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $a41b1c278196f7ae$export$170f4e08cad8229d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $a41b1c278196f7ae$export$2a489b3f92f4996a;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $a41b1c278196f7ae$export$67a6ce548ae77071;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $a41b1c278196f7ae$export$a48f0734ac7c2329;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $a41b1c278196f7ae$export$3f34ca2fef821bbd;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $a41b1c278196f7ae$export$86f54f62aa7a7514;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $a41b1c278196f7ae$export$89912e019eef22aa;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $a41b1c278196f7ae$export$1c8ba402144543e5;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $a41b1c278196f7ae$export$2ddabb89308e1a22;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $a41b1c278196f7ae$export$14527669107aa301;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $a41b1c278196f7ae$export$3f063810d7bf01bd;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $a41b1c278196f7ae$export$b5a4d6f439a5044d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $a41b1c278196f7ae$export$b119cc7e1840e59c;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $a41b1c278196f7ae$export$7b85fd78dd236198;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $a41b1c278196f7ae$export$697c3df919c0e61a;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $a41b1c278196f7ae$export$e6b5ff3168b5942b;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $a41b1c278196f7ae$export$1d012a0dff3dab06;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $a41b1c278196f7ae$export$69a3209f1a06c04d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $a41b1c278196f7ae$export$86c18c6347f4a8c4;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $a41b1c278196f7ae$export$dce9414bed0662c;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $a41b1c278196f7ae$export$271f7c16f175f804;
});
var $a41b1c278196f7ae$var$$6a9944941b4c1893$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "sum", function() {
    return $a41b1c278196f7ae$export$8a63f25cc62965f1;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $a41b1c278196f7ae$export$e1f36757ecda301d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $a41b1c278196f7ae$export$8e694e1eafd55acb;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $a41b1c278196f7ae$export$57d7c52a66287430;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $a41b1c278196f7ae$export$2b4693832ca3ce16;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $a41b1c278196f7ae$export$5b784e078da1ce6;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $a41b1c278196f7ae$export$17ec9c9f4f23588c;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $a41b1c278196f7ae$export$595dbf49c602a1f;
});
function $a41b1c278196f7ae$export$8a63f25cc62965f1() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return data.reduce(function(sum, item) {
        return sum + item;
    }, 0);
}
function $a41b1c278196f7ae$export$e1f36757ecda301d() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return $a41b1c278196f7ae$export$8a63f25cc62965f1.apply(void 0, (0, $kVAOt._)(data)) / data.length;
}
function $a41b1c278196f7ae$export$8e694e1eafd55acb(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var average = $a41b1c278196f7ae$export$e1f36757ecda301d.apply(void 0, (0, $kVAOt._)(data));
    var summary = $a41b1c278196f7ae$export$8a63f25cc62965f1.apply(void 0, (0, $kVAOt._)(data.map(function(item) {
        return Math.pow(item - average, 2);
    })));
    return summary / (data.length - (sample ? 1 : 0));
}
function $a41b1c278196f7ae$export$57d7c52a66287430(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Math.sqrt($a41b1c278196f7ae$export$8e694e1eafd55acb(data, sample));
}
function $a41b1c278196f7ae$export$2b4693832ca3ce16() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return Math.sqrt($a41b1c278196f7ae$export$8a63f25cc62965f1.apply(void 0, (0, $kVAOt._)(data.map(function(item) {
        return Math.pow(item, 2);
    }))));
}
function $a41b1c278196f7ae$export$5b784e078da1ce6(raw, length) {
    var text = raw.toFixed(length + 2);
    var offset = text.indexOf(".") + length + 1;
    var cut = function(text) {
        return text.slice(0, offset - (length ? 0 : 1));
    };
    if (!+text.slice(offset)) return cut(text);
    var result = cut((+cut(text) + Math.pow(10, -length)).toFixed(length));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
function $a41b1c278196f7ae$export$17ec9c9f4f23588c(raw) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var text = raw.toFixed(length + 2);
    var floatOffset = text.indexOf(".");
    if (floatOffset < 0) return length ? "".concat(text, ".").concat("0".repeat(length)) : text;
    var offset = floatOffset + length + 1;
    var before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    var carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $a41b1c278196f7ae$export$5b784e078da1ce6(raw, length);
    var result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
var $a41b1c278196f7ae$export$595dbf49c602a1f = /*#__PURE__*/ function() {
    "use strict";
    function $6a9944941b4c1893$export$595dbf49c602a1f(value) {
        (0, $cc1Ug._)(this, $6a9944941b4c1893$export$595dbf49c602a1f);
        this.value = value;
    }
    (0, $gmv3D._)($6a9944941b4c1893$export$595dbf49c602a1f, [
        {
            key: "valueOf",
            value: function valueOf() {
                return this.value;
            }
        },
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
                var _this = this, units = _this.units, value = _this.value;
                var _ref = (0, $kVAOt._)(units).reverse().find(function(param) {
                    var base = param.base;
                    return Math.abs(value) >= base;
                }) || units[0], base = _ref.base, name = _ref.name;
                return "".concat((value / base).toFixed(fractionDigits), " ").concat(name);
            }
        }
    ], [
        {
            key: "distanceOf",
            value: function distanceOf(a, b) {
                return Reflect.construct(this, [
                    a - b
                ]);
            }
        }
    ]);
    return $6a9944941b4c1893$export$595dbf49c602a1f;
}();
function $a41b1c278196f7ae$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $a41b1c278196f7ae$export$dd1bc94b04021eeb(value) {
    return $a41b1c278196f7ae$export$61cc6ed0f143570b(value) || (typeof value === "object" ? !Object.keys(value).length : value === "");
}
var $a41b1c278196f7ae$export$a09f818797e212c4 = function(data) {
    return Object.prototype.toString.call(data).slice(8, -1);
};
function $a41b1c278196f7ae$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $a41b1c278196f7ae$export$2a489b3f92f4996a(target, dataStore, setter) {
    var prototype = Object.getPrototypeOf(target);
    var prototypeProxy = new Proxy(prototype, {
        set: function(_, key, value, receiver) {
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter === null || setter === void 0 ? void 0 : setter(key, value);
            return true;
        },
        get: function(prototype, key, receiver) {
            return key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver);
        }
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
function $a41b1c278196f7ae$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + "", undefined, {
        numeric: true
    }) > 0;
}
function $a41b1c278196f7ae$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, "xx").length;
}
function $a41b1c278196f7ae$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return "".concat(offset ? "-" : "").concat((match[1] || match[0]).toLowerCase());
    });
}
function $a41b1c278196f7ae$export$86f54f62aa7a7514(raw) {
    var large = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase();
    });
}
function $a41b1c278196f7ae$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + "").slice(2))).toString(36);
}
function $a41b1c278196f7ae$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map(function(value, index) {
        return [
            keys[index],
            value
        ];
    }));
}
var $a41b1c278196f7ae$export$2ddabb89308e1a22;
(function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
})($a41b1c278196f7ae$export$2ddabb89308e1a22 || ($a41b1c278196f7ae$export$2ddabb89308e1a22 = {}));
function $a41b1c278196f7ae$export$14527669107aa301(oldList, newList) {
    var map = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = oldList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            map[item] = -1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = newList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            var _map, _item;
            (_map = map)[_item = item1] || (_map[_item] = 0);
            map[item1] += 1;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        map: map,
        group: $a41b1c278196f7ae$export$3f063810d7bf01bd(Object.entries(map), function(param) {
            var _param = (0, $fIpBC._)(param, 2), key = _param[0], status = _param[1];
            return status;
        })
    };
}
function $a41b1c278196f7ae$export$b5a4d6f439a5044d(data) {
    if ($a41b1c278196f7ae$export$61cc6ed0f143570b(data)) return false;
    var length = data.length;
    return typeof length === "number" && length >= 0 && ~~length === length;
}
var $a41b1c278196f7ae$export$b119cc7e1840e59c = function(data) {
    return data instanceof Object.getPrototypeOf(Int8Array);
};
function $a41b1c278196f7ae$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($a41b1c278196f7ae$export$61cc6ed0f143570b(data)) return [];
    if ($a41b1c278196f7ae$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
var $a41b1c278196f7ae$export$697c3df919c0e61a = function(array, unitLength) {
    return array.reduce(function(grid, item, index) {
        var _grid, _ref;
        ((_grid = grid)[_ref = ~~(index / unitLength)] || (_grid[_ref] = []))[index % unitLength] = item;
        return grid;
    }, []);
};
function $a41b1c278196f7ae$export$e6b5ff3168b5942b(list, subKey, handler) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (handler(item)) return [
                item
            ];
            if (item[subKey] instanceof Array) {
                var result = $a41b1c278196f7ae$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
                if (result.length) return [
                    item
                ].concat((0, $kVAOt._)(result));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
}
function $a41b1c278196f7ae$export$3f063810d7bf01bd(list, iteratee) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
            if (!(keys instanceof Array)) keys = [
                keys
            ];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = new Set(keys.filter(function(key) {
                    return key != null;
                }))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key = _step1.value;
                    (data[key] = data[key] || []).push(item);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
function $a41b1c278196f7ae$export$1d012a0dff3dab06(list, iteratee) {
    var group = $a41b1c278196f7ae$export$3f063810d7bf01bd(list, iteratee);
    var sortedList = Object.entries(group).map(function(param) {
        var _param = (0, $fIpBC._)(param, 2), key = _param[0], _param_ = _param[1], length = _param_.length;
        return [
            key,
            length
        ];
    });
    return Object.fromEntries(sortedList);
}
function $a41b1c278196f7ae$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function() {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
            data[_key] = arguments[_key];
        }
        var _executor;
        if (cacheData != null) return cacheData;
        console.trace("[Cache] execute: ".concat(title));
        cacheData = (_executor = executor).call.apply(_executor, [
            this,
            function() {
                return cacheData = undefined;
            }
        ].concat((0, $kVAOt._)(data)));
        Promise.resolve(cacheData).then(function(data) {
            return console.log("[Cache] refreshed: ".concat(title, " => ").concat(data));
        }, function(error) {
            return console.error("[Cache] failed: ".concat((error === null || error === void 0 ? void 0 : error.message) || error));
        });
        return cacheData;
    };
}
function $a41b1c278196f7ae$export$86c18c6347f4a8c4(executor) {
    return $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4() {
    $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4 = (0, $7sqYf._)(function(executor) {
        var _Promise_withResolvers, promise, resolve, reject, doneSymbol, done, disposer, value, ref;
        return (0, $7WkDo.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _Promise_withResolvers = Promise.withResolvers(), promise = _Promise_withResolvers.promise, resolve = _Promise_withResolvers.resolve, reject = _Promise_withResolvers.reject;
                    doneSymbol = Symbol("done"), done = Promise.withResolvers();
                    disposer = executor({
                        next: function(value) {
                            return resolve(value);
                        },
                        error: function(error) {
                            reject(error);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        },
                        complete: function() {
                            done.resolve(doneSymbol);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        }
                    });
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $kL1BW._)(Promise.race([
                            promise,
                            done.promise
                        ]))
                    ];
                case 2:
                    value = _state.sent();
                    if (value === doneSymbol) return [
                        2
                    ];
                    return [
                        4,
                        value
                    ];
                case 3:
                    _state.sent();
                    ref = Promise.withResolvers(), promise = ref.promise, resolve = ref.resolve, reject = ref.reject, ref;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4.apply(this, arguments);
}
function $a41b1c278196f7ae$export$dce9414bed0662c() {
    return $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$dce9414bed0662c.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$dce9414bed0662c() {
    $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$dce9414bed0662c = (0, $7sqYf._)(function() {
        var _loop, _len, sources, _key, iterators;
        var _arguments = arguments;
        return (0, $7WkDo.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function() {
                        var dones, i, iterator, _ref, done, value;
                        return (0, $7WkDo.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dones = [];
                                    i = 0, iterator = void 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(iterator = iterators[i])) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        (0, $kL1BW._)(iterator.next())
                                    ];
                                case 2:
                                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                    if (!!done) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        value
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    dones.push(i);
                                    _state.label = 5;
                                case 5:
                                    i++;
                                    return [
                                        3,
                                        1
                                    ];
                                case 6:
                                    iterators = iterators.filter(function(_, i) {
                                        return !dones.includes(i);
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    for(_len = _arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
                        sources[_key] = _arguments[_key];
                    }
                    iterators = sources.map(function(item) {
                        return item();
                    });
                    _state.label = 1;
                case 1:
                    if (!iterators[0]) return [
                        3,
                        3
                    ];
                    return [
                        5,
                        (0, $7WkDo.__values)(_loop())
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$dce9414bed0662c.apply(this, arguments);
}
var $a41b1c278196f7ae$export$271f7c16f175f804 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $aPY27._)($9b05bcda60cc529c$export$271f7c16f175f804, $6a9944941b4c1893$export$595dbf49c602a1f);
    var _super = (0, $SZ4bt._)($9b05bcda60cc529c$export$271f7c16f175f804);
    function $9b05bcda60cc529c$export$271f7c16f175f804() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $cc1Ug._)(this, $9b05bcda60cc529c$export$271f7c16f175f804);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $kVAOt._)(args)));
        _this.units = [
            "",
            "K",
            "M",
            "G",
            "T",
            "P",
            "E",
            "Z",
            "Y"
        ].map(function(name, i) {
            return {
                base: Math.pow(1024, i),
                name: name + "B"
            };
        });
        return _this;
    }
    return $9b05bcda60cc529c$export$271f7c16f175f804;
}($a41b1c278196f7ae$export$595dbf49c602a1f);
var $a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $a41b1c278196f7ae$export$c489aa6f7fd82b1a;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $a41b1c278196f7ae$export$cbd942915f33be50;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $a41b1c278196f7ae$export$9b886f8493244014;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $a41b1c278196f7ae$export$e99cbb807a5bb10d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $a41b1c278196f7ae$export$7a9a31a911eb9a20;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $a41b1c278196f7ae$export$fca4f8121099df57;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $a41b1c278196f7ae$export$6ce2f08d515512;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $a41b1c278196f7ae$export$951c8378cdfec6e6;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $a41b1c278196f7ae$export$1a4097b876a13bf7;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $a41b1c278196f7ae$export$d9bcbd5e1ff81430;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $a41b1c278196f7ae$export$506c8e8f8c8edda;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $a41b1c278196f7ae$export$3ae94a2503e890a1;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $a41b1c278196f7ae$export$62ad822b3a5fd9a0;
});
var $a41b1c278196f7ae$export$c489aa6f7fd82b1a = 1000;
var $a41b1c278196f7ae$export$cbd942915f33be50 = $a41b1c278196f7ae$export$c489aa6f7fd82b1a * 60;
var $a41b1c278196f7ae$export$9b886f8493244014 = $a41b1c278196f7ae$export$cbd942915f33be50 * 15;
var $a41b1c278196f7ae$export$e99cbb807a5bb10d = $a41b1c278196f7ae$export$9b886f8493244014 * 4;
var $a41b1c278196f7ae$export$7a9a31a911eb9a20 = $a41b1c278196f7ae$export$e99cbb807a5bb10d * 24;
var $a41b1c278196f7ae$export$fca4f8121099df57 = $a41b1c278196f7ae$export$7a9a31a911eb9a20 * 7;
var $a41b1c278196f7ae$export$6ce2f08d515512 = $a41b1c278196f7ae$export$7a9a31a911eb9a20 * 365;
var $a41b1c278196f7ae$export$951c8378cdfec6e6 = $a41b1c278196f7ae$export$6ce2f08d515512 / 12;
var $a41b1c278196f7ae$export$1a4097b876a13bf7 = $a41b1c278196f7ae$export$951c8378cdfec6e6 * 3;
var $a41b1c278196f7ae$export$d9bcbd5e1ff81430 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $aPY27._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, $6a9944941b4c1893$export$595dbf49c602a1f);
    var _super = (0, $SZ4bt._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430);
    function $f872d8bba1c0f79f$export$d9bcbd5e1ff81430() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $cc1Ug._)(this, $f872d8bba1c0f79f$export$d9bcbd5e1ff81430);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $kVAOt._)(args)));
        _this.units = [
            {
                base: $a41b1c278196f7ae$export$c489aa6f7fd82b1a,
                name: "s"
            },
            {
                base: $a41b1c278196f7ae$export$cbd942915f33be50,
                name: "m"
            },
            {
                base: $a41b1c278196f7ae$export$e99cbb807a5bb10d,
                name: "H"
            },
            {
                base: $a41b1c278196f7ae$export$7a9a31a911eb9a20,
                name: "D"
            },
            {
                base: $a41b1c278196f7ae$export$fca4f8121099df57,
                name: "W"
            },
            {
                base: $a41b1c278196f7ae$export$951c8378cdfec6e6,
                name: "M"
            },
            {
                base: $a41b1c278196f7ae$export$6ce2f08d515512,
                name: "Y"
            }
        ];
        return _this;
    }
    (0, $gmv3D._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, [
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return (0, $kbtRr._)((0, $kZtbK._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430.prototype), "toShortString", this).call(this, fractionDigits);
            }
        }
    ]);
    return $f872d8bba1c0f79f$export$d9bcbd5e1ff81430;
}($a41b1c278196f7ae$export$595dbf49c602a1f);
function $a41b1c278196f7ae$export$506c8e8f8c8edda(end) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var timeDistance = $a41b1c278196f7ae$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    var _timeDistance_toShortString_split = (0, $fIpBC._)(timeDistance.toShortString().split(/\s+/), 2), value = _timeDistance_toShortString_split[0], unit = _timeDistance_toShortString_split[1];
    return {
        distance: +value,
        unit: unit
    };
}
function $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + "";
    return function(template) {
        return (value.length < template.length ? value.padStart(template.length, "0") : value).slice(-Math.max(template.length, 2));
    };
}
function $a41b1c278196f7ae$export$3ae94a2503e890a1() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date(), template = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "YYYY-MM-DD HH:mm:ss";
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $a41b1c278196f7ae$export$cbd942915f33be50);
    var _time_toJSON_split = (0, $fIpBC._)(time.toJSON().split(/\D/), 7), year = _time_toJSON_split[0], month = _time_toJSON_split[1], day = _time_toJSON_split[2], hour = _time_toJSON_split[3], minute = _time_toJSON_split[4], second = _time_toJSON_split[5], millisecond = _time_toJSON_split[6];
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $a41b1c278196f7ae$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    var month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $a41b1c278196f7ae$var$$ba0e5dc395660a7c$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $a41b1c278196f7ae$export$27924e57e9afff7f;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $a41b1c278196f7ae$export$7ea17d45ecdcf634;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $a41b1c278196f7ae$export$bb8626e4916f587b;
});
function $a41b1c278196f7ae$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === "string" && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            var date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    var value = parseItem(raw);
    if (typeof value !== "string" || $a41b1c278196f7ae$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, function(key, value) {
            return parseItem(value);
        });
    } catch (e) {
        return raw;
    }
}
function $a41b1c278196f7ae$export$7ea17d45ecdcf634(raw) {
    var parsed = $a41b1c278196f7ae$export$27924e57e9afff7f(raw);
    if (typeof parsed !== "string") return parsed;
    var number = +parsed;
    return Number.isNaN(number) || number + "" !== parsed ? parsed : number;
}
function $a41b1c278196f7ae$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    var quote = raw[0];
    var index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError("A ".concat(quote, " is missing"));
    return raw.slice(1, index);
}
function $a41b1c278196f7ae$export$bb8626e4916f587b(raw, header) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var data = raw.trim().split(/[\r\n]+/).map(function(row) {
        var list = [];
        do {
            var value = void 0;
            if (row[0] === '"' || row[0] === "'") {
                value = $a41b1c278196f7ae$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                var index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = "";
                }
            }
            list.push($a41b1c278196f7ae$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map(function(row) {
        return row.reduce(function(object, item, index) {
            object[data[0][index]] = item;
            return object;
        }, {});
    });
}
var $a41b1c278196f7ae$var$$083124ac4b1a50a0$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $a41b1c278196f7ae$export$71e6483fc2b024eb;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $a41b1c278196f7ae$export$eb9b2aadbe449a20;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $a41b1c278196f7ae$export$13397a83aa5915d6;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $a41b1c278196f7ae$export$fd89523fba250fa4;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $a41b1c278196f7ae$export$504fbde693c1771c;
});
function $a41b1c278196f7ae$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $a41b1c278196f7ae$export$eb9b2aadbe449a20() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.search, toBuiltIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var list = raw.split(/\?|#/);
    var data = new URLSearchParams(list[1] || list[0]);
    return Object.fromEntries((0, $kVAOt._)(data.keys()).map(function(key) {
        var list = toBuiltIn ? data.getAll(key).map($a41b1c278196f7ae$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
var $a41b1c278196f7ae$var$$083124ac4b1a50a0$var$stringify = function(value) {
    return typeof value === "string" ? value : $a41b1c278196f7ae$export$b5a4d6f439a5044d(value) ? $a41b1c278196f7ae$export$7b85fd78dd236198(value) + "" : JSON.stringify(value);
};
function $a41b1c278196f7ae$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    var list = map.map(function(param) {
        var _param = (0, $fIpBC._)(param, 2), key = _param[0], value = _param[1];
        return !$a41b1c278196f7ae$export$dd1bc94b04021eeb(value) && [
            key,
            $a41b1c278196f7ae$var$$083124ac4b1a50a0$var$stringify(value)
        ];
    }).filter(Boolean);
    return new URLSearchParams(list);
}
function $a41b1c278196f7ae$export$fd89523fba250fa4(URI) {
    return $a41b1c278196f7ae$var$_$083124ac4b1a50a0$export$fd89523fba250fa4.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$083124ac4b1a50a0$export$fd89523fba250fa4() {
    $a41b1c278196f7ae$var$_$083124ac4b1a50a0$export$fd89523fba250fa4 = (0, $hP6lv._)(function(URI) {
        return (0, $7WkDo.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(URI + "")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().blob()
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$083124ac4b1a50a0$export$fd89523fba250fa4.apply(this, arguments);
}
var $a41b1c278196f7ae$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $a41b1c278196f7ae$export$504fbde693c1771c(URI) {
    var _ref = (0, $fIpBC._)($a41b1c278196f7ae$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [], 5), _ = _ref[0], type = _ref[1], __ = _ref[2], base64 = _ref[3], data = _ref[4];
    data = base64 ? atob(data) : data;
    var aBuffer = new ArrayBuffer(data.length);
    var uBuffer = new Uint8Array(aBuffer);
    for(var i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $a41b1c278196f7ae$var$$50872bf213056663$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $a41b1c278196f7ae$export$1b9ac4d3de3ffd2e;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$50872bf213056663$exports, "makeSHA", function() {
    return $a41b1c278196f7ae$export$d51f3b55e8d1aa73;
});
var $a41b1c278196f7ae$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), function(_, cell) {
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $a41b1c278196f7ae$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = raw[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            value = value >> 8 & 0x00ffffff ^ $a41b1c278196f7ae$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "0x" + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === "object") {
    if ("msCrypto" in globalThis) {
        var $a41b1c278196f7ae$var$_loop = function(key) {
            var origin = $a41b1c278196f7ae$var$subtle[key];
            if (origin instanceof Function) $a41b1c278196f7ae$var$subtle[key] = function() {
                var observer = origin.apply(this, arguments);
                return new Promise(function(resolve, reject) {
                    observer.oncomplete = function(param) {
                        var target = param.target;
                        return resolve(target.result);
                    };
                    observer.onabort = observer.onerror = reject;
                });
            };
        };
        // @ts-ignore
        var $a41b1c278196f7ae$var$_ref = globalThis.crypto = globalThis.msCrypto, $a41b1c278196f7ae$var$subtle = $a41b1c278196f7ae$var$_ref.subtle;
        for(var $a41b1c278196f7ae$var$key in $a41b1c278196f7ae$var$subtle)$a41b1c278196f7ae$var$_loop($a41b1c278196f7ae$var$key);
    }
    var $a41b1c278196f7ae$var$crypto1 = globalThis.crypto;
    if (!($a41b1c278196f7ae$var$crypto1 === null || $a41b1c278196f7ae$var$crypto1 === void 0 ? void 0 : $a41b1c278196f7ae$var$crypto1.subtle) && ($a41b1c278196f7ae$var$crypto1 === null || $a41b1c278196f7ae$var$crypto1 === void 0 ? void 0 : $a41b1c278196f7ae$var$crypto1["webkitSubtle"])) $a41b1c278196f7ae$var$crypto1.subtle = $a41b1c278196f7ae$var$crypto1["webkitSubtle"];
}
function $a41b1c278196f7ae$export$d51f3b55e8d1aa73(raw) {
    return $a41b1c278196f7ae$var$_$50872bf213056663$export$d51f3b55e8d1aa73.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$50872bf213056663$export$d51f3b55e8d1aa73() {
    $a41b1c278196f7ae$var$_$50872bf213056663$export$d51f3b55e8d1aa73 = (0, $hP6lv._)(function(raw) {
        var algorithm, buffer;
        var _arguments = arguments;
        return (0, $7WkDo.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    algorithm = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "SHA-1";
                    return [
                        4,
                        crypto.subtle.digest(algorithm, new TextEncoder().encode(raw))
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        2,
                        Array.from(new Uint8Array(buffer), function(byte) {
                            return byte.toString(16).padStart(2, "0");
                        }).join("")
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$50872bf213056663$export$d51f3b55e8d1aa73.apply(this, arguments);
}
var $a41b1c278196f7ae$var$$93a3089d2937b23f$exports = {};
var $a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $a41b1c278196f7ae$export$2ee022bbbc550b25;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $a41b1c278196f7ae$export$a549dd5cef7f8327;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $a41b1c278196f7ae$export$8eece510bcb9c62c;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $a41b1c278196f7ae$export$b8a1af58c024fefd;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $a41b1c278196f7ae$export$a2cf0d4bb6e06de4;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $a41b1c278196f7ae$export$d66b332881d9723f;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $a41b1c278196f7ae$export$b0709844452f8b6b;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $a41b1c278196f7ae$export$5118471ee5d5453b;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $a41b1c278196f7ae$export$be4650432daa84fd;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $a41b1c278196f7ae$export$578e38b4a3e0b255;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $a41b1c278196f7ae$export$7cd14c57bbb84350;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $a41b1c278196f7ae$export$5100419dfae0456d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $a41b1c278196f7ae$export$28d9d24a8cd0ffc2;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $a41b1c278196f7ae$export$3f99968195accfaf;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $a41b1c278196f7ae$export$eafdbaa868ea9975;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $a41b1c278196f7ae$export$36a0c1ca2ae264fa;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $a41b1c278196f7ae$export$86d7c59254d6a2c9;
});
var $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$templateMap = {};
function $a41b1c278196f7ae$export$2ee022bbbc550b25(tagName) {
    if ($a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    var spawn = document.createElement("template");
    spawn.innerHTML = "<".concat(tagName, " />");
    return $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $a41b1c278196f7ae$export$a549dd5cef7f8327(tagName) {
    var node = $a41b1c278196f7ae$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? "html" : "xml";
}
function $a41b1c278196f7ae$export$8eece510bcb9c62c(Class) {
    return $a41b1c278196f7ae$export$170f4e08cad8229d(Class, HTMLElement);
}
var $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $a41b1c278196f7ae$export$b8a1af58c024fefd(Class) {
    var name = $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var _ref = new Class(), tagName = _ref.tagName;
    $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $a41b1c278196f7ae$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ var ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                "sizes"
            ]
        ],
        [
            HTMLIFrameElement,
            [
                "sandbox"
            ]
        ],
        [
            HTMLObjectElement,
            [
                "form"
            ]
        ],
        [
            HTMLInputElement,
            [
                "form",
                "list"
            ]
        ],
        [
            HTMLButtonElement,
            [
                "form"
            ]
        ],
        [
            HTMLSelectElement,
            [
                "form"
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                "form"
            ]
        ],
        [
            HTMLOutputElement,
            [
                "form"
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                "form"
            ]
        ]
    ];
    var template = $a41b1c278196f7ae$export$2ee022bbbc550b25(tagName);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ReadOnly_Properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $fIpBC._)(_step.value, 2), Class = _step_value[0], keys = _step_value[1];
            if (template instanceof Class && keys.includes(propertyName)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $a41b1c278196f7ae$export$d66b332881d9723f(HTML) {
    var spawn = document.createElement("template");
    spawn.innerHTML = HTML;
    return (0, $kVAOt._)(spawn.content.childNodes).map(function(node) {
        node.remove();
        return node;
    });
}
function $a41b1c278196f7ae$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "");
}
function $a41b1c278196f7ae$export$5118471ee5d5453b(root, type) {
    var children, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node, err;
    return (0, $7WkDo.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                children = (0, $kVAOt._)(root.childNodes);
                if (!($a41b1c278196f7ae$export$dd1bc94b04021eeb(type) || type === root.nodeType)) return [
                    3,
                    2
                ];
                return [
                    4,
                    root
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    8,
                    9,
                    10
                ]);
                _iterator = children[Symbol.iterator]();
                _state.label = 4;
            case 4:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    7
                ];
                node = _step.value;
                return [
                    5,
                    (0, $7WkDo.__values)($a41b1c278196f7ae$export$5118471ee5d5453b(node, type))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    4
                ];
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    10
                ];
            case 9:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function $a41b1c278196f7ae$export$be4650432daa84fd(root) {
    var text = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a41b1c278196f7ae$export$5118471ee5d5453b(root)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, nodeType = _step_value.nodeType, parentElement = _step_value.parentElement, nodeValue = _step_value.nodeValue;
            if (nodeType === Node.TEXT_NODE && parentElement.getAttribute("aria-hidden") !== "true") {
                var _parentElement_getBoundingClientRect = parentElement.getBoundingClientRect(), width = _parentElement_getBoundingClientRect.width, height = _parentElement_getBoundingClientRect.height;
                if (width && height) text += nodeValue.trim().replace(/\s+/g, " ");
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return text;
}
function $a41b1c278196f7ae$export$578e38b4a3e0b255(param) {
    var offsetWidth = param.offsetWidth, children = param.children, pageHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 841.89, pageWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 595.28;
    var scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return (0, $kVAOt._)(children).reduce(function(pages, node) {
        var _pages, _bottomIndex;
        var top = node.offsetTop, height = node.offsetHeight;
        top += offset;
        var bottom = top + height;
        var bottomOffset = bottom / scrollHeight;
        var topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        ((_pages = pages)[_bottomIndex = bottomIndex] || (_pages[_bottomIndex] = [])).push(node);
        return pages;
    }, []);
}
function $a41b1c278196f7ae$export$7cd14c57bbb84350(URI) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var alternate = _param.alternate, options = (0, $hzAa9._)(_param, [
        "alternate"
    ]);
    var style = (0, $kVAOt._)(document.styleSheets).find(function(param) {
        var href = param.href;
        return href === URI;
    });
    if (style) return Promise.resolve(style);
    var link = document.createElement("link");
    return new Promise(function(resolve, reject) {
        link.onload = function() {
            return resolve(link.sheet);
        };
        link.onerror = function(_1, _2, _3, _4, error) {
            return reject(error);
        };
        Object.assign(link, options);
        link.rel = (alternate ? "alternate " : "") + "stylesheet";
        link.href = URI;
        document.head.append(link);
    });
}
function $a41b1c278196f7ae$export$5100419dfae0456d(data) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, indent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "    ";
    var padding = indent.repeat(depth);
    return Object.entries(data).map(function(param) {
        var _param = (0, $fIpBC._)(param, 2), key = _param[0], value = _param[1];
        return typeof value !== "object" ? "".concat(padding).concat($a41b1c278196f7ae$export$3f34ca2fef821bbd(key), ": ").concat(value, ";") : "".concat(padding).concat(key, " {\n").concat($a41b1c278196f7ae$export$5100419dfae0456d(value, depth + 1, indent), "\n").concat(padding, "}");
    }).join("\n");
}
function $a41b1c278196f7ae$export$28d9d24a8cd0ffc2() {
    for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++){
        nodes[_key] = arguments[_key];
    }
    var _fragment, _node;
    var fragment = document.createDocumentFragment();
    (_fragment = fragment).append.apply(_fragment, (0, $kVAOt._)(nodes));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a41b1c278196f7ae$export$5118471ee5d5453b(fragment)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (![
                1,
                3,
                11
            ].includes(node.nodeType) || [
                "meta",
                "title",
                "link",
                "script"
            ].includes(node.nodeName.toLowerCase())) (_node = node).replaceWith.apply(_node, (0, $kVAOt._)(node.childNodes));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var selection = globalThis.getSelection();
    if (!selection) return;
    var range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $a41b1c278196f7ae$export$3f99968195accfaf(selector, root, align, justify) {
    var _querySelector;
    var _ref = (0, $fIpBC._)(/^#(.+)/.exec(selector) || [], 2), _ = _ref[0], ID = _ref[1];
    if (ID === "top") window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
    else (_querySelector = (root || document).querySelector(ID ? '[id="'.concat(ID, '"]') : selector)) === null || _querySelector === void 0 ? void 0 : _querySelector.scrollIntoView({
        behavior: "smooth",
        block: align,
        inline: justify
    });
}
function $a41b1c278196f7ae$export$eafdbaa868ea9975(box, handler) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), function(_, index) {
        return "h".concat(++index);
    }) + ""), function(header) {
        new IntersectionObserver(function(param) {
            var _param = (0, $fIpBC._)(param, 1), item = _param[0];
            if (!item.isIntersecting) return;
            var target = item.target;
            handler({
                target: target,
                links: (0, $kVAOt._)(target.ownerDocument.querySelectorAll('[href="#'.concat(target.id, '"]')))
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, "-");
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $a41b1c278196f7ae$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === "visible" ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(function(param) {
        var _param = (0, $fIpBC._)(param, 1), _param_ = _param[0], isIntersecting = _param_.isIntersecting;
        return change(isIntersecting ? last | 2 : last & 1);
    }).observe(root);
    document.addEventListener("visibilitychange", function() {
        return change(document.visibilityState === "visible" ? last | 1 : last & 2);
    });
}
function $a41b1c278196f7ae$export$86d7c59254d6a2c9(form) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = form.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            var type = field.type, name = field.name, value = field.value, checked = field.checked, defaultValue = field.defaultValue, selectedOptions = field.selectedOptions, files = field.files;
            if (!name || value === "") continue;
            var box = type !== "fieldset" && field.closest("fieldset");
            if (box && box !== form) continue;
            var parsedValue = value;
            switch(type){
                case "radio":
                case "checkbox":
                    if (checked) parsedValue = defaultValue ? $a41b1c278196f7ae$export$7ea17d45ecdcf634(defaultValue) : true;
                    else continue;
                    break;
                case "select-multiple":
                    parsedValue = Array.from(selectedOptions, function(param) {
                        var value = param.value;
                        return $a41b1c278196f7ae$export$7ea17d45ecdcf634(value);
                    });
                    break;
                case "fieldset":
                    parsedValue = $a41b1c278196f7ae$export$86d7c59254d6a2c9(field);
                    break;
                case "file":
                    parsedValue = files && Array.from(files);
                    break;
                case "date":
                case "datetime-local":
                case "month":
                case "hidden":
                case "number":
                case "range":
                case "select-one":
                    parsedValue = $a41b1c278196f7ae$export$7ea17d45ecdcf634(value);
            }
            if (name in data) data[name] = [].concat(data[name], parsedValue);
            else data[name] = !(parsedValue instanceof Array) || !$a41b1c278196f7ae$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
var $a41b1c278196f7ae$var$$bb23e0c794fefbef$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $a41b1c278196f7ae$export$e772c8ff12451969;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $a41b1c278196f7ae$export$57207d71b8c929c8;
});
function $a41b1c278196f7ae$export$e772c8ff12451969() {
    var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return new Promise(function(resolve) {
        return setTimeout(resolve, seconds * 1000);
    });
}
function $a41b1c278196f7ae$export$57207d71b8c929c8(executor) {
    var seconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var stop = false;
    (0, $hP6lv._)(function() {
        var result;
        return (0, $7WkDo.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!stop) return [
                        3,
                        4
                    ];
                    result = executor();
                    if (!(result instanceof Promise)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        result
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        $a41b1c278196f7ae$export$e772c8ff12451969(seconds)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        0
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
    return function() {
        return stop = true;
    };
}
var $a41b1c278196f7ae$var$$19ed8aeb7905a045$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $a41b1c278196f7ae$export$10b1921597150314;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $a41b1c278196f7ae$export$3e2b244719956741;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $a41b1c278196f7ae$export$1d1d2ed6b55cf67f;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $a41b1c278196f7ae$export$2155c0b5a4b77fb8;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $a41b1c278196f7ae$export$9d97473344489dfc;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $a41b1c278196f7ae$export$d635d04af3887bbe;
});
function $a41b1c278196f7ae$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
var $a41b1c278196f7ae$export$3e2b244719956741 = typeof window !== "undefined" ? new Promise(function(resolve) {
    var _document;
    function done() {
        var _document;
        (_document = document) === null || _document === void 0 ? void 0 : _document.removeEventListener("DOMContentLoaded", done);
        window.removeEventListener("load", done);
        resolve();
    }
    (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener("DOMContentLoaded", done);
    window.addEventListener("load", done);
    setTimeout(function check() {
        var _document;
        ((_document = document) === null || _document === void 0 ? void 0 : _document.readyState) === "complete" ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $a41b1c278196f7ae$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise(function(resolve, reject) {
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + "end", end);
            element.removeEventListener(scope + "cancel", cancel);
        }
        element.addEventListener(scope + "end", end);
        element.addEventListener(scope + "cancel", cancel);
    });
}
function $a41b1c278196f7ae$export$2155c0b5a4b77fb8(handlers) {
    function server(_param) {
        return _server.apply(this, arguments);
    }
    function _server() {
        _server = (0, $hP6lv._)(function(_param) {
            var _param_data, type, id, source, origin, data, _handlers_type, result;
            return (0, $7WkDo.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param_data = _param.data, type = _param_data.type, id = _param_data.id, source = _param.source, origin = _param.origin, data = (0, $hzAa9._)(_param.data, [
                            "type",
                            "id"
                        ]);
                        result = (_handlers_type = handlers[type]) === null || _handlers_type === void 0 ? void 0 : _handlers_type.call(handlers, data);
                        if (!(result instanceof Promise)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            result
                        ];
                    case 1:
                        result = _state.sent();
                        _state.label = 2;
                    case 2:
                        // @ts-ignore
                        source.postMessage((0, $jjggo._)((0, $f9EKS._)({}, result), {
                            id: id
                        }), origin);
                        return [
                            2
                        ];
                }
            });
        });
        return _server.apply(this, arguments);
    }
    globalThis.addEventListener("message", server);
    return function() {
        return globalThis.removeEventListener("message", server);
    };
}
function $a41b1c278196f7ae$export$9d97473344489dfc(target) {
    var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "*";
    return function(type, data) {
        return new Promise(function(resolve) {
            var UID = $a41b1c278196f7ae$export$89912e019eef22aa();
            function handler(_param) {
                var _param_data = _param.data, id = _param_data.id, _$data = (0, $hzAa9._)(_param.data, [
                    "id"
                ]);
                if (id !== UID) return;
                resolve(_$data);
                globalThis.removeEventListener("message", handler);
            }
            globalThis.addEventListener("message", handler);
            // @ts-ignore
            target.postMessage((0, $f9EKS._)({
                id: UID,
                type: type
            }, data), origin);
        });
    };
}
function $a41b1c278196f7ae$export$d635d04af3887bbe(registration) {
    return new Promise(function(resolve) {
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = function() {
            var _registration_installing;
            return (_registration_installing = registration.installing) === null || _registration_installing === void 0 ? void 0 : _registration_installing.addEventListener("statechange", function() {
                if (this.state === "installed" && navigator.serviceWorker.controller) resolve(this);
            });
        };
    });
}
var $a41b1c278196f7ae$var$$7a08303ce13c49c5$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $a41b1c278196f7ae$export$1b88f6b6d432a52a;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $a41b1c278196f7ae$export$b70f6380221b1350;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $a41b1c278196f7ae$export$75d6cbe4503e149;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $a41b1c278196f7ae$export$b2618d51188815c2;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $a41b1c278196f7ae$export$490814474ddbb428;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $a41b1c278196f7ae$export$3ea201dffb50dfef;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $a41b1c278196f7ae$export$d1012c7198c6b460;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $a41b1c278196f7ae$export$a35a418b7b17958e;
});
var $a41b1c278196f7ae$export$1b88f6b6d432a52a = /*#__PURE__*/ function() {
    "use strict";
    function $7a08303ce13c49c5$export$1b88f6b6d432a52a(from, to) {
        (0, $cc1Ug._)(this, $7a08303ce13c49c5$export$1b88f6b6d432a52a);
        this.from = from;
        this.to = to;
    }
    (0, $gmv3D._)($7a08303ce13c49c5$export$1b88f6b6d432a52a, [
        {
            key: "length",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
            }
        },
        {
            key: "direction",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                var XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
                var XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
                switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
                    case XL:
                        return XD > 0 ? "right" : "left";
                    case YL:
                        return YD > 0 ? "forward" : "backward";
                    case ZL:
                        return ZD > 0 ? "up" : "down";
                }
            }
        }
    ]);
    return $7a08303ce13c49c5$export$1b88f6b6d432a52a;
}();
function $a41b1c278196f7ae$export$b70f6380221b1350(from, to) {
    var threshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : parseInt(getComputedStyle(document.body).fontSize) * 6;
    var _getSelection;
    var vector = new $a41b1c278196f7ae$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.toString().trim())) return vector;
}
function $a41b1c278196f7ae$export$75d6cbe4503e149(type, element) {
    var _getComputedStyle = getComputedStyle(element), transitionDuration = _getComputedStyle.transitionDuration, animationDuration = _getComputedStyle.animationDuration;
    var duration = type === "animation" ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === "ms" ? 1 : 1000);
}
function $a41b1c278196f7ae$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $a41b1c278196f7ae$export$1d1d2ed6b55cf67f(type, element).catch(function(event) {
            return Promise.resolve(event);
        }),
        new Promise(function(resolve) {
            return setTimeout(resolve, $a41b1c278196f7ae$export$75d6cbe4503e149(type, element));
        })
    ]);
}
function $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    var end = $a41b1c278196f7ae$export$b2618d51188815c2(type, element);
    return new Promise(function(resolve) {
        return requestAnimationFrame(function() {
            element.classList.add(className);
            end.then(resolve);
        });
    });
}
function $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    return $a41b1c278196f7ae$var$_$7a08303ce13c49c5$var$fadeOut.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$7a08303ce13c49c5$var$fadeOut() {
    $a41b1c278196f7ae$var$_$7a08303ce13c49c5$var$fadeOut = (0, $hP6lv._)(function(type, element, className, remove) {
        var end;
        return (0, $7WkDo.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = $a41b1c278196f7ae$export$b2618d51188815c2(type, element);
                    element.classList.remove(className);
                    return [
                        4,
                        end
                    ];
                case 1:
                    _state.sent();
                    if (remove) element.remove();
                    else element.style.display = "none";
                    return [
                        2
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$7a08303ce13c49c5$var$fadeOut.apply(this, arguments);
}
function $a41b1c278196f7ae$export$490814474ddbb428(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "block";
    return $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeIn("transition", element, className, display);
}
function $a41b1c278196f7ae$export$3ea201dffb50dfef(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "block";
    return $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeIn("animation", element, className, display);
}
function $a41b1c278196f7ae$export$d1012c7198c6b460(element, className, remove) {
    return $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeOut("transition", element, className, remove);
}
function $a41b1c278196f7ae$export$a35a418b7b17958e(element, className, remove) {
    return $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeOut("animation", element, className, remove);
}
var $a41b1c278196f7ae$var$$69bd9f0117925302$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$69bd9f0117925302$exports, "describe", function() {
    return $a41b1c278196f7ae$export$cd5450f3a47e3789;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$69bd9f0117925302$exports, "it", function() {
    return $a41b1c278196f7ae$export$3486a10f30cf1ee4;
});
function $a41b1c278196f7ae$export$cd5450f3a47e3789(title, cases) {
    return $a41b1c278196f7ae$var$_$69bd9f0117925302$export$cd5450f3a47e3789.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$69bd9f0117925302$export$cd5450f3a47e3789() {
    $a41b1c278196f7ae$var$_$69bd9f0117925302$export$cd5450f3a47e3789 = (0, $hP6lv._)(function(title, cases) {
        return (0, $7WkDo.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log(title);
                    console.time(title);
                    return [
                        4,
                        cases()
                    ];
                case 1:
                    _state.sent();
                    console.timeEnd(title);
                    return [
                        2
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$69bd9f0117925302$export$cd5450f3a47e3789.apply(this, arguments);
}
function $a41b1c278196f7ae$export$3486a10f30cf1ee4(title, userCase) {
    return $a41b1c278196f7ae$var$_$69bd9f0117925302$export$3486a10f30cf1ee4.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$69bd9f0117925302$export$3486a10f30cf1ee4() {
    $a41b1c278196f7ae$var$_$69bd9f0117925302$export$3486a10f30cf1ee4 = (0, $hP6lv._)(function(title, userCase) {
        var secondsOut;
        var _arguments = arguments;
        function timeOut() {
            return _timeOut.apply(this, arguments);
        }
        function _timeOut() {
            _timeOut = (0, $hP6lv._)(function() {
                return (0, $7WkDo.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                $a41b1c278196f7ae$export$e772c8ff12451969(secondsOut)
                            ];
                        case 1:
                            _state.sent();
                            throw new RangeError("Timed out");
                    }
                });
            });
            return _timeOut.apply(this, arguments);
        }
        return (0, $7WkDo.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    secondsOut = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 3;
                    title = "    " + title;
                    console.time(title);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        Promise.race([
                            userCase(function(status) {
                                return console.assert(status, title);
                            }),
                            timeOut()
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    console.timeEnd(title);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$69bd9f0117925302$export$3486a10f30cf1ee4.apply(this, arguments);
}

});
parcelRegister("hP6lv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $03593a4f76efe603$export$7c398597f8905a1; });
function $03593a4f76efe603$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $03593a4f76efe603$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $03593a4f76efe603$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $03593a4f76efe603$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("kL1BW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f1c9725503fcf23f$export$491e832825b6666e; });

var $c2aUb = parcelRequire("c2aUb");
function $f1c9725503fcf23f$export$491e832825b6666e(value) {
    return new (0, $c2aUb._await_value)(value);
}

});
parcelRegister("c2aUb", function(module, exports) {

$parcel$export(module.exports, "_await_value", function () { return $8c2e2180319769c5$export$14d68ad33f8c0242; });
function $8c2e2180319769c5$export$14d68ad33f8c0242(value) {
    this.wrapped = value;
}

});


parcelRegister("cc1Ug", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8e08159c8a382ad8$export$2996f80ef42b8419; });
function $8e08159c8a382ad8$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("gmv3D", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $be96cad0a1942847$export$d60067ff2358eee8; });
function $be96cad0a1942847$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $be96cad0a1942847$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $be96cad0a1942847$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $be96cad0a1942847$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("kbtRr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $eb1bff81c03e80ec$export$afb3516d9d608401; });

var $79cjq = parcelRequire("79cjq");
function $eb1bff81c03e80ec$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $eb1bff81c03e80ec$export$afb3516d9d608401 = Reflect.get;
    else $eb1bff81c03e80ec$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $79cjq._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $eb1bff81c03e80ec$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRegister("79cjq", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $5342eca55b382c2b$export$e4187255aefbc259; });

var $kZtbK = parcelRequire("kZtbK");
function $5342eca55b382c2b$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $kZtbK._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});
parcelRegister("kZtbK", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $f480256114240132$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $f480256114240132$export$f09211a7d3c496a1; });
function $f480256114240132$export$f09211a7d3c496a1(o) {
    $f480256114240132$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f480256114240132$export$f09211a7d3c496a1(o);
}

});



parcelRegister("aPY27", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7e3d3c29fcad254e$export$7e4530ad35d3bb8; });

var $f7Ioy = parcelRequire("f7Ioy");
function $7e3d3c29fcad254e$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $f7Ioy._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("f7Ioy", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $b029f268ad075390$export$c2c98ac76e997b63; });
function $b029f268ad075390$export$c2c98ac76e997b63(o, p) {
    $b029f268ad075390$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b029f268ad075390$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("f9EKS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b0874f60b5cbd965$export$581ff339ea0ba762; });

var $fNF6R = parcelRequire("fNF6R");
function $b0874f60b5cbd965$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $fNF6R._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("fNF6R", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $b80b5222e64b3fac$export$1e71eb4bef00f6b0; });
function $b80b5222e64b3fac$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("jjggo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e0ec683bdaa2032c$export$4fa2f4023c9cbda5; });
function $e0ec683bdaa2032c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e0ec683bdaa2032c$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $e0ec683bdaa2032c$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("hzAa9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ccb1c1b370f7ab4a$export$69fdd232f62cde60; });

var $dTAPL = parcelRequire("dTAPL");
function $ccb1c1b370f7ab4a$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $dTAPL._object_without_properties_loose)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("dTAPL", function(module, exports) {

$parcel$export(module.exports, "_object_without_properties_loose", function () { return $a1dcfbe047bf2c59$export$7a4a7e38737aceb4; });
function $a1dcfbe047bf2c59$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("fIpBC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b70ed3dd69f33cc7$export$fdf2a89c76341bbf; });

var $d86XO = parcelRequire("d86XO");

var $jM8Iy = parcelRequire("jM8Iy");

var $rdy1V = parcelRequire("rdy1V");

var $ani6Y = parcelRequire("ani6Y");
function $b70ed3dd69f33cc7$export$fdf2a89c76341bbf(arr, i) {
    return (0, $d86XO._array_with_holes)(arr) || (0, $jM8Iy._iterable_to_array_limit)(arr, i) || (0, $ani6Y._unsupported_iterable_to_array)(arr, i) || (0, $rdy1V._non_iterable_rest)();
}

});
parcelRegister("d86XO", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $98f16c96195ed965$export$e6256bf45c68d561; });
function $98f16c96195ed965$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("jM8Iy", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $e659432c9c89cdab$export$2fd15edff6687200; });
function $e659432c9c89cdab$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("rdy1V", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $051d080e69ffb819$export$60dbc22abd7da546; });
function $051d080e69ffb819$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ani6Y", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $78da19f36e5fc5a6$export$a5be06335b3a083c; });

var $l205R = parcelRequire("l205R");
function $78da19f36e5fc5a6$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $l205R._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $l205R._array_like_to_array)(o, minLen);
}

});
parcelRegister("l205R", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $f4f9db73d4997464$export$79e617b1955a2616; });
function $f4f9db73d4997464$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("kVAOt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3c5afd1d930435c$export$1b5e630bc3aea29f; });

var $cm3rn = parcelRequire("cm3rn");

var $97167 = parcelRequire("97167");

var $fsBQg = parcelRequire("fsBQg");

var $ani6Y = parcelRequire("ani6Y");
function $f3c5afd1d930435c$export$1b5e630bc3aea29f(arr) {
    return (0, $cm3rn._array_without_holes)(arr) || (0, $97167._iterable_to_array)(arr) || (0, $ani6Y._unsupported_iterable_to_array)(arr) || (0, $fsBQg._non_iterable_spread)();
}

});
parcelRegister("cm3rn", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $8fea35547fb32bec$export$7e0947b5ad3404e2; });

var $l205R = parcelRequire("l205R");
function $8fea35547fb32bec$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $l205R._array_like_to_array)(arr);
}

});

parcelRegister("97167", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $6a259e7bfc27a067$export$1eb58a6e75231000; });
function $6a259e7bfc27a067$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("fsBQg", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $b416d3303c45bade$export$e6f3c4780d19eb2b; });
function $b416d3303c45bade$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("7sqYf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $56e011c22c21bb9e$export$a1b373fcf543ed3a; });

var $cs8ea = parcelRequire("cs8ea");
function $56e011c22c21bb9e$export$a1b373fcf543ed3a(fn) {
    return function() {
        return new (0, $cs8ea._async_generator)(fn.apply(this, arguments));
    };
}

});
parcelRegister("cs8ea", function(module, exports) {

$parcel$export(module.exports, "_async_generator", function () { return $0256f179335cc199$export$f6ee6a12e55075bb; });

var $c2aUb = parcelRequire("c2aUb");
function $0256f179335cc199$export$f6ee6a12e55075bb(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof (0, $c2aUb._await_value);
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
if (typeof Symbol === "function" && Symbol.asyncIterator) $0256f179335cc199$export$f6ee6a12e55075bb.prototype[Symbol.asyncIterator] = function() {
    return this;
};
$0256f179335cc199$export$f6ee6a12e55075bb.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$0256f179335cc199$export$f6ee6a12e55075bb.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$0256f179335cc199$export$f6ee6a12e55075bb.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

});


parcelRegister("SZ4bt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0a5469cabd84498e$export$8dd05c13f5255580; });

var $kZtbK = parcelRequire("kZtbK");

var $lMAqV = parcelRequire("lMAqV");

var $5ZuKU = parcelRequire("5ZuKU");
function $0a5469cabd84498e$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $lMAqV._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $kZtbK._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $kZtbK._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $5ZuKU._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("lMAqV", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $fdba578abfbb4086$export$685354647fba1516; });
function $fdba578abfbb4086$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("5ZuKU", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $45ca81a7c90fe0fc$export$ef97c660ca164e52; });

var $dOF8f = parcelRequire("dOF8f");

var $8OALW = parcelRequire("8OALW");
function $45ca81a7c90fe0fc$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $8OALW._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $dOF8f._assert_this_initialized)(self);
}

});
parcelRegister("dOF8f", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $a0efd9db6f45b0ba$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $a0efd9db6f45b0ba$export$f3b8ed2e4a5d10b8; });
function $a0efd9db6f45b0ba$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});





parcelRegister("buWta", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOMRenderer = void 0;

var $7WkDo = parcelRequire("7WkDo");

var $e5wYp = parcelRequire("e5wYp");

var $aNHqn = parcelRequire("aNHqn");
var $85efd9e17fd6be0e$var$DOMRenderer = /** @class */ function() {
    function DOMRenderer() {
        var _this = this;
        this.eventPattern = /^on[A-Z]/;
        this.ariaPattern = /^aira[A-Z]/;
        this.treeCache = new WeakMap();
        this.keyOf = function(_a, index) {
            var key = _a.key, text = _a.text, props = _a.props, selector = _a.selector;
            return (key === null || key === void 0 ? void 0 : key.toString()) || (props === null || props === void 0 ? void 0 : props.id) || (text || selector || "") + index;
        };
        this.vNodeOf = function(list, key) {
            return list.find(function(vNode, index) {
                return "".concat(_this.keyOf(vNode, index)) === String(key);
            });
        };
        this.propsKeyOf = function(key) {
            return key.startsWith("aria-") ? (0, $e5wYp.toCamelCase)(key) : _this.eventPattern.test(key) ? key.toLowerCase() : key;
        };
    }
    DOMRenderer.prototype.updateProps = function(node, oldProps, newProps, onDelete, onAdd) {
        var e_1, _a, e_2, _b;
        if (oldProps === void 0) oldProps = {};
        if (newProps === void 0) newProps = {};
        var group = (0, $e5wYp.diffKeys)(Object.keys(oldProps), Object.keys(newProps)).group;
        try {
            for(var _c = $7WkDo.__values(group[$e5wYp.DiffStatus.Old] || []), _d = _c.next(); !_d.done; _d = _c.next()){
                var _e = $7WkDo.__read(_d.value, 1), key = _e[0];
                onDelete === null || onDelete === void 0 || onDelete(node, key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _f = $7WkDo.__values($7WkDo.__spreadArray($7WkDo.__spreadArray([], $7WkDo.__read(group[$e5wYp.DiffStatus.Same] || []), false), $7WkDo.__read(group[$e5wYp.DiffStatus.New] || []), false)), _g = _f.next(); !_g.done; _g = _f.next()){
                var _h = $7WkDo.__read(_g.value, 1), key = _h[0];
                if (oldProps[key] !== newProps[key]) {
                    if (onAdd instanceof Function) onAdd(node, key, newProps[key]);
                    else Reflect.set(node, key, newProps[key]);
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    DOMRenderer.prototype.createNode = function(vNode, reusedVNodes) {
        var _a, _b;
        if (vNode.text) return vNode.node = document.createTextNode(vNode.text);
        var reusedVNode = vNode.selector && ((_a = reusedVNodes === null || reusedVNodes === void 0 ? void 0 : reusedVNodes[vNode.selector]) === null || _a === void 0 ? void 0 : _a.shift());
        vNode.node = vNode.tagName ? (reusedVNode === null || reusedVNode === void 0 ? void 0 : reusedVNode.node) || document.createElement(vNode.tagName, {
            is: vNode.is
        }) : document.createDocumentFragment();
        var node = this.patch(reusedVNode || {
            tagName: vNode.tagName,
            node: vNode.node
        }, vNode).node;
        if (node) (_b = vNode.ref) === null || _b === void 0 || _b.call(vNode, node);
        return node;
    };
    DOMRenderer.prototype.deleteNode = function(_a) {
        var ref = _a.ref, node = _a.node, children = _a.children;
        if (node instanceof DocumentFragment) children === null || children === void 0 || children.forEach(this.deleteNode);
        else if (node) {
            node.remove();
            ref === null || ref === void 0 || ref();
        }
    };
    DOMRenderer.prototype.commitChildren = function(root, newNodes) {
        var e_3, _a;
        try {
            for(var _b = $7WkDo.__values($7WkDo.__spreadArray([], $7WkDo.__read(root.childNodes), false)), _c = _b.next(); !_c.done; _c = _b.next()){
                var oldNode = _c.value;
                var index = newNodes.indexOf(oldNode);
                if (index < 0) continue;
                else if (index === 0) {
                    newNodes.shift();
                    continue;
                }
                var beforeNodes = newNodes.slice(0, index);
                if (!beforeNodes[0]) continue;
                oldNode.before.apply(oldNode, $7WkDo.__spreadArray([], $7WkDo.__read(beforeNodes), false));
                newNodes = newNodes.slice(index + 1);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (newNodes[0]) root.append.apply(root, $7WkDo.__spreadArray([], $7WkDo.__read(newNodes), false));
    };
    DOMRenderer.prototype.updateChildren = function(node, oldList, newList) {
        var e_4, _a;
        var _this = this;
        var _b = (0, $e5wYp.diffKeys)(oldList.map(this.keyOf), newList.map(this.keyOf)), map = _b.map, group = _b.group;
        var deletingGroup = group[$e5wYp.DiffStatus.Old] && (0, $e5wYp.groupBy)(group[$e5wYp.DiffStatus.Old].map(function(_a) {
            var _b = $7WkDo.__read(_a, 1), key = _b[0];
            return _this.vNodeOf(oldList, key);
        }), function(_a) {
            var selector = _a.selector;
            return selector + "";
        });
        var newNodes = newList.map(function(vNode, index) {
            var key = _this.keyOf(vNode, index);
            if (map[key] !== $e5wYp.DiffStatus.Same) return _this.createNode(vNode, deletingGroup);
            var oldVNode = _this.vNodeOf(oldList, key);
            return vNode.text != null ? vNode.node = oldVNode.node : _this.patch(oldVNode, vNode).node;
        });
        for(var selector in deletingGroup)try {
            for(var _c = (e_4 = void 0, $7WkDo.__values(deletingGroup[selector])), _d = _c.next(); !_d.done; _d = _c.next()){
                var vNode = _d.value;
                this.deleteNode(vNode);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        this.commitChildren(node, newNodes);
    };
    DOMRenderer.prototype.handleCustomEvent = function(node, event) {
        var handler;
        Object.defineProperty(node, "on".concat(event), {
            set: function set(value) {
                if (handler) node.removeEventListener(event, handler);
                node.addEventListener(event, handler = value);
            },
            get: function get() {
                return handler;
            }
        });
    };
    DOMRenderer.prototype.patch = function(oldVNode, newVNode) {
        var _this = this;
        var tagName = oldVNode.tagName;
        var isXML = (0, $e5wYp.templateOf)(tagName) && (0, $e5wYp.elementTypeOf)(tagName) === "xml";
        this.updateProps(oldVNode.node, oldVNode.props, newVNode.props, function(node, key) {
            return _this.eventPattern.test(key) ? node[key.toLowerCase()] = null : node.removeAttribute(_this.ariaPattern.test(key) ? (0, $e5wYp.toHyphenCase)(key) : $aNHqn.VNode.propsMap[key] || key);
        }, function(node, key, value) {
            if (isXML || key.includes("-")) node.setAttribute(key, value);
            else try {
                var name_1 = _this.propsKeyOf(key);
                if (_this.eventPattern.test(key) && !(name_1 in node)) _this.handleCustomEvent(node, name_1.slice(2));
                node[name_1] = value;
            } catch (_a) {
                node.setAttribute(key, value);
            }
        });
        this.updateProps(oldVNode.node.style, oldVNode.style, newVNode.style, function(node, key) {
            return node.removeProperty(key);
        });
        this.updateChildren(oldVNode.node, oldVNode.children || [], newVNode.children || []);
        newVNode.node = oldVNode.node;
        return newVNode;
    };
    DOMRenderer.prototype.render = function(vNode, node) {
        if (node === void 0) node = document.body;
        var root = this.treeCache.get(node) || $aNHqn.VNode.fromDOM(node);
        root = this.patch(root, new $aNHqn.VNode($7WkDo.__assign($7WkDo.__assign({}, root), {
            children: [
                vNode
            ]
        })));
        this.treeCache.set(node, root);
        return root;
    };
    DOMRenderer.prototype.renderToStaticMarkup = function(tree) {
        var body = document.implementation.createHTMLDocument().body;
        this.render(tree, body);
        return body.innerHTML;
    };
    return DOMRenderer;
}();
module.exports.DOMRenderer = $85efd9e17fd6be0e$var$DOMRenderer;

});

parcelRegister("b0lSM", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "autorun", function () { return autorun; });
$parcel$export(module.exports, "reaction", function () { return reaction; });

var $8OALW = parcelRequire("8OALW");
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value === "undefined" ? "undefined" : (0, $8OALW._)(value);
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function ownKeys(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if ((typeof key === "undefined" ? "undefined" : (0, $8OALW._)(key)) === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $8OALW._)(key)) === "symbol" ? key : String(key);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.isPendingUnobservation = false;
        this.isBeingObserved = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    // Backwards/Legacy behavior, expects makeObservable(this)
    if (kind == "field") {
        addInitializer(function() {
            storeAnnotation(this, name, ann);
        });
        return;
    }
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    _inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ _Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        }
    ]);
    return ComputedValue;
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            startBatch();
            this.isScheduled_ = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning_ = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts2$signal, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2$signal = _opts2.signal) != null && _opts2$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts4$signal, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4$signal = _opts4.signal) != null && _opts4$signal.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed_) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null ? void 0 : (_opts$signal3 = opts.signal) == null ? void 0 : _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (other.constructor !== Map) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[_Symbol$iterator$1] = function() {
        return this.values();
    };
    _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray, _Symbol$toStringTag, _Symbol$iterator) {
    _inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _assertThisInitialized(_this);
            addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_assertThisInitialized(_this), "0", ENTRY_0);
        });
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[_Symbol$iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a === "undefined" ? "undefined" : (0, $8OALW._)(a);
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

var $85f08a9b324875d4$exports = {};
"use strict";
Object.defineProperty($85f08a9b324875d4$exports, "__esModule", {
    value: true
});
$85f08a9b324875d4$exports.Fragment = $85f08a9b324875d4$exports.jsxDEV = $85f08a9b324875d4$exports.jsxs = $85f08a9b324875d4$exports.jsx = void 0;

var $7WkDo = parcelRequire("7WkDo");

var $e5wYp = parcelRequire("e5wYp");

var $aNHqn = parcelRequire("aNHqn");
/**
 * @see {@link https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md}
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx}
 */ function $85f08a9b324875d4$var$jsx(type, _a, key) {
    var ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $7WkDo.__rest(_a, [
        "ref",
        "is",
        "style",
        "children"
    ]);
    if (typeof type === "function" && (0, $e5wYp.isHTMLElementClass)(type)) type = (0, $e5wYp.tagNameOf)(type);
    children = [
        children
    ].flat(Infinity).map(function(node) {
        return node instanceof Object ? new $aNHqn.VNode(node) : node === 0 || node ? new $aNHqn.VNode({
            text: node.toString()
        }) : undefined;
    }).filter(Boolean);
    var commonProps = {
        key: key,
        ref: ref,
        is: is,
        style: style,
        children: children
    };
    return typeof type === "string" ? new $aNHqn.VNode($7WkDo.__assign($7WkDo.__assign({}, commonProps), {
        tagName: type,
        props: props
    })) : type($7WkDo.__assign($7WkDo.__assign({}, commonProps), props));
}
$85f08a9b324875d4$exports.jsx = $85f08a9b324875d4$var$jsx;
$85f08a9b324875d4$exports.jsxs = $85f08a9b324875d4$var$jsx;
$85f08a9b324875d4$exports.jsxDEV = $85f08a9b324875d4$var$jsx;
/**
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx#react-automatic-runtime-1}
 */ var $85f08a9b324875d4$var$Fragment = function Fragment(_a) {
    var key = _a.key, ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $7WkDo.__rest(_a, [
        "key",
        "ref",
        "is",
        "style",
        "children"
    ]);
    return new $aNHqn.VNode({
        key: key,
        ref: ref,
        is: is,
        props: (0, $e5wYp.isEmpty)(props) ? undefined : props,
        style: style,
        children: children
    });
};
$85f08a9b324875d4$exports.Fragment = $85f08a9b324875d4$var$Fragment;


var $e43ab9b9c825724a$exports = {};
"use strict";
Object.defineProperty($e43ab9b9c825724a$exports, "__esModule", {
    value: true
});

var $7WkDo = parcelRequire("7WkDo");

$7WkDo.__exportStar((parcelRequire("aNHqn")), $e43ab9b9c825724a$exports);

$7WkDo.__exportStar((parcelRequire("buWta")), $e43ab9b9c825724a$exports);



var $e5wYp = parcelRequire("e5wYp");

var $f9EKS = parcelRequire("f9EKS");


var $dOF8f = parcelRequire("dOF8f");

var $cc1Ug = parcelRequire("cc1Ug");

var $gmv3D = parcelRequire("gmv3D");

var $aPY27 = parcelRequire("aPY27");

var $fIpBC = parcelRequire("fIpBC");

var $kVAOt = parcelRequire("kVAOt");

var $8OALW = parcelRequire("8OALW");

var $lMAqV = parcelRequire("lMAqV");

var $f7Ioy = parcelRequire("f7Ioy");
function $a936de2092d28b69$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $lMAqV._is_native_reflect_construct)()) $a936de2092d28b69$export$2d841144c5f8c4ab = Reflect.construct;
    else $a936de2092d28b69$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $f7Ioy._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $a936de2092d28b69$export$2d841144c5f8c4ab.apply(null, arguments);
}



var $kZtbK = parcelRequire("kZtbK");
function $50f86d3bdfd9f9f2$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



var $f7Ioy = parcelRequire("f7Ioy");
function $42e2719c89ddd56d$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $42e2719c89ddd56d$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $50f86d3bdfd9f9f2$export$514eda94019f4334)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $a936de2092d28b69$export$2d841144c5f8c4ab)(Class, arguments, (0, $kZtbK._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $f7Ioy._set_prototype_of)(Wrapper, Class);
    };
    return $42e2719c89ddd56d$export$2466d533fda16e33(Class);
}



var $SZ4bt = parcelRequire("SZ4bt");

var $8bd163097a5514bf$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $8bd163097a5514bf$exports) {
        classNames.default = classNames;
        $8bd163097a5514bf$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $e5wYp = parcelRequire("e5wYp");

var $b0lSM = parcelRequire("b0lSM");

var $dOF8f = parcelRequire("dOF8f");

var $hP6lv = parcelRequire("hP6lv");

var $cc1Ug = parcelRequire("cc1Ug");

var $gmv3D = parcelRequire("gmv3D");

var $kbtRr = parcelRequire("kbtRr");

var $kZtbK = parcelRequire("kZtbK");

var $aPY27 = parcelRequire("aPY27");

var $fIpBC = parcelRequire("fIpBC");

var $kVAOt = parcelRequire("kVAOt");

var $8OALW = parcelRequire("8OALW");

var $SZ4bt = parcelRequire("SZ4bt");

var $7WkDo = parcelRequire("7WkDo");


var $b0lSM = parcelRequire("b0lSM");

var $e5wYp = parcelRequire("e5wYp");

function $e67e4bd0d5ef9fd4$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $e67e4bd0d5ef9fd4$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$exports = {};
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$exports, "observer", function() {
    return $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149;
});
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$exports, "attribute", function() {
    return $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434;
});
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$exports, "reaction", function() {
    return $e67e4bd0d5ef9fd4$export$7203b476385689ae;
});
var $e67e4bd0d5ef9fd4$var$$552a56cc5ff3f479$exports = {};
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$552a56cc5ff3f479$exports, "Defer", function() {
    return $e67e4bd0d5ef9fd4$export$c7e91f8aec23ae14;
});
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$552a56cc5ff3f479$exports, "getMobxData", function() {
    return $e67e4bd0d5ef9fd4$export$b06b4c21253e26e2;
});
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$552a56cc5ff3f479$exports, "animated", function() {
    return $e67e4bd0d5ef9fd4$export$4077c0dfbe9c3861;
});
var $e67e4bd0d5ef9fd4$export$c7e91f8aec23ae14 = function $552a56cc5ff3f479$export$c7e91f8aec23ae14() {
    "use strict";
    var _this = this;
    (0, $cc1Ug._)(this, $552a56cc5ff3f479$export$c7e91f8aec23ae14);
    Object.defineProperty(this, "resolve", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: void 0
    });
    Object.defineProperty(this, "reject", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: void 0
    });
    Object.defineProperty(this, "promise", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        })
    });
};
function $e67e4bd0d5ef9fd4$export$b06b4c21253e26e2(observable) {
    var _a;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.getOwnPropertySymbols(observable)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var store = (_a = observable[key]) === null || _a === void 0 ? void 0 : _a.values_;
            if (store instanceof Map) return Object.fromEntries(Array.from(store, function(param) {
                var _param = (0, $fIpBC._)(param, 2), key = _param[0], _param_ = _param[1], value_ = _param_.value_;
                return [
                    key,
                    value_
                ];
            }));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var $e67e4bd0d5ef9fd4$export$4077c0dfbe9c3861 = function(root, targetSelector) {
    return new Promise(function(resolve) {
        var ended = (0, $e5wYp.delegate)(targetSelector, function(event) {
            root.removeEventListener("animationend", ended);
            root.removeEventListener("animationcancel", ended);
            resolve(event);
        });
        root.addEventListener("animationend", ended);
        root.addEventListener("animationcancel", ended);
    });
};
var $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$var$__classPrivateFieldGet = function $0c03e47eb1097734$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
function $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$var$wrapFunction(func) {
    return function(props) {
        var tree = func(props), renderer = new (0, $e43ab9b9c825724a$exports.DOMRenderer)();
        var disposer = (0, $b0lSM.autorun)(function() {
            var newTree = func(props);
            if (tree.node) Object.assign(tree, renderer.patch(tree, newTree));
        });
        var ref = tree.ref;
        tree.ref = function(node) {
            if (node) tree.node = node;
            else disposer();
            ref === null || ref === void 0 || ref(node);
        };
        return tree;
    };
}
var $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$var$reactionMap = new WeakMap();
function $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$var$wrapClass(Component) {
    var _ObserverComponent_instances, _ObserverComponent_boot;
    var ObserverComponent = /*#__PURE__*/ function(Component) {
        "use strict";
        (0, $aPY27._)(ObserverComponent, Component);
        var _super = (0, $SZ4bt._)(ObserverComponent);
        function ObserverComponent() {
            (0, $cc1Ug._)(this, ObserverComponent);
            var _this;
            _this = _super.call(this);
            _ObserverComponent_instances.add((0, $dOF8f._)(_this));
            Object.defineProperty((0, $dOF8f._)(_this), "disposers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty((0, $dOF8f._)(_this), "update", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    var _Object_getPrototypeOf = Object.getPrototypeOf((0, $dOF8f._)(_this)), update = _Object_getPrototypeOf.update;
                    return new Promise(function(resolve) {
                        return _this.disposers.push((0, $b0lSM.autorun)(function() {
                            return update.call(_this).then(resolve);
                        }));
                    });
                }
            });
            Promise.resolve().then(function() {
                return $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$var$__classPrivateFieldGet(_this, _ObserverComponent_instances, "m", _ObserverComponent_boot).call((0, $dOF8f._)(_this));
            });
            return _this;
        }
        (0, $gmv3D._)(ObserverComponent, [
            {
                key: "props",
                get: function get() {
                    return $e67e4bd0d5ef9fd4$export$b06b4c21253e26e2(this);
                }
            },
            {
                key: "disconnectedCallback",
                value: function disconnectedCallback() {
                    var _a;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.disposers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var disposer = _step.value;
                            disposer();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.disposers.length = 0;
                    (_a = (0, $kbtRr._)((0, $kZtbK._)(ObserverComponent.prototype), "disconnectedCallback", this)) === null || _a === void 0 || _a.call(this);
                }
            },
            {
                key: "setAttribute",
                value: function setAttribute(name, value) {
                    var old = (0, $kbtRr._)((0, $kZtbK._)(ObserverComponent.prototype), "getAttribute", this).call(this, name), names = this.constructor["observedAttributes"];
                    (0, $kbtRr._)((0, $kZtbK._)(ObserverComponent.prototype), "setAttribute", this).call(this, name, value);
                    if (names.includes(name)) this.attributeChangedCallback(name, old, value);
                }
            },
            {
                key: "attributeChangedCallback",
                value: function attributeChangedCallback(name, old, value) {
                    var _a;
                    this[(0, $e5wYp.toCamelCase)(name)] = (0, $e5wYp.parseJSON)(value);
                    (_a = (0, $kbtRr._)((0, $kZtbK._)(ObserverComponent.prototype), "attributeChangedCallback", this)) === null || _a === void 0 || _a.call(this, name, old, value);
                }
            },
            {
                key: "syncPropAttr",
                value: function syncPropAttr(name) {
                    var _a;
                    var value = this[(0, $e5wYp.toCamelCase)(name)];
                    if (!(value != null) || value === false) return this.removeAttribute(name);
                    value = value === true ? name : value;
                    if (typeof value === "object") {
                        value = (_a = value.toJSON) === null || _a === void 0 ? void 0 : _a.call(value);
                        value = typeof value === "object" ? JSON.stringify(value) : value;
                    }
                    (0, $kbtRr._)((0, $kZtbK._)(ObserverComponent.prototype), "setAttribute", this).call(this, name, value);
                }
            }
        ]);
        return ObserverComponent;
    }(Component);
    _ObserverComponent_instances = new WeakSet(), _ObserverComponent_boot = function _ObserverComponent_boot() {
        var _this = this;
        var _this_disposers;
        var names = this.constructor["observedAttributes"] || [], reactions = $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$var$reactionMap.get(this) || [];
        (_this_disposers = this.disposers).push.apply(_this_disposers, (0, $kVAOt._)(names.map(function(name) {
            return (0, $b0lSM.autorun)(function() {
                return _this.syncPropAttr(name);
            });
        })).concat((0, $kVAOt._)(reactions.map(function(param) {
            var expression = param.expression, effect = param.effect;
            return (0, $b0lSM.reaction)(function(reaction) {
                return expression(_this, reaction);
            }, effect.bind(_this));
        }))));
    };
    Object.defineProperty(ObserverComponent, "observedAttributes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: []
    });
    return ObserverComponent;
}
function $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149(func, _) {
    return (0, $e5wYp.isHTMLElementClass)(func) ? $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$var$wrapClass(func) : $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$var$wrapFunction(func);
}
function $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434(_, param) {
    var name = param.name, addInitializer = param.addInitializer;
    addInitializer(function() {
        var names = this.constructor["observedAttributes"], attribute = (0, $e5wYp.toHyphenCase)(name.toString());
        if (!names.includes(attribute)) names.push(attribute);
    });
}
function $e67e4bd0d5ef9fd4$export$7203b476385689ae(expression) {
    return function(effect, param) {
        var addInitializer = param.addInitializer;
        return addInitializer(function() {
            var reactions = $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $e67e4bd0d5ef9fd4$var$$0c03e47eb1097734$var$reactionMap.set(this, reactions);
        });
    };
}
var $e67e4bd0d5ef9fd4$var$$317b1f21909c74b8$exports = {};
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$317b1f21909c74b8$exports, "component", function() {
    return $e67e4bd0d5ef9fd4$export$d8556a2a8f973135;
});
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$317b1f21909c74b8$exports, "on", function() {
    return $e67e4bd0d5ef9fd4$export$af631764ddc44097;
});
var $e67e4bd0d5ef9fd4$var$$317b1f21909c74b8$var$eventMap = new WeakMap();
function $e67e4bd0d5ef9fd4$export$d8556a2a8f973135(meta) {
    return function(Class, param) {
        var addInitializer = param.addInitializer;
        var RendererComponent = /*#__PURE__*/ function(Class) {
            "use strict";
            (0, $aPY27._)(RendererComponent, Class);
            var _super = (0, $SZ4bt._)(RendererComponent);
            function RendererComponent() {
                (0, $cc1Ug._)(this, RendererComponent);
                var _this;
                _this = _super.call(this);
                Object.defineProperty((0, $dOF8f._)(_this), "internals", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: _this.attachInternals()
                });
                Object.defineProperty((0, $dOF8f._)(_this), "renderer", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: new (0, $e43ab9b9c825724a$exports.DOMRenderer)()
                });
                Object.defineProperty((0, $dOF8f._)(_this), "mounted", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: false
                });
                if (meta.mode && !_this.internals.shadowRoot) _this.attachShadow(meta);
                return _this;
            }
            (0, $gmv3D._)(RendererComponent, [
                {
                    key: "root",
                    get: function get() {
                        return this.internals.shadowRoot || this;
                    }
                },
                {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this = this;
                        var _this1 = this, _superprop_get = function(_prop) {
                            return (0, $kbtRr._)((0, $kZtbK._)(RendererComponent.prototype), _prop, _this);
                        };
                        return (0, $hP6lv._)(function() {
                            var _a, _b, mode, renderChildren, root, events, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, type, selector, handler;
                            return (0, $7WkDo.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        mode = meta.mode;
                                        renderChildren = !(mode != null);
                                        root = _this1.root, events = $e67e4bd0d5ef9fd4$var$$317b1f21909c74b8$var$eventMap.get(_this1) || [];
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = events[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                _step_value = _step.value, type = _step_value.type, selector = _step_value.selector, handler = _step_value.handler;
                                                if (renderChildren && /^:host/.test(selector)) console.warn('[WebCell] DOM Event delegation of "'.concat(selector, '" won\'t work if you don\'t invoke "this.attachShadow()" manually.'));
                                                root.addEventListener(type, handler);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        (_a = _superprop_get("connectedCallback")) === null || _a === void 0 || _a.call(_this1);
                                        if (_this1.mounted) return [
                                            2
                                        ];
                                        return [
                                            4,
                                            _this1.update()
                                        ];
                                    case 1:
                                        _state.sent();
                                        _this1.mounted = true;
                                        (_b = _this1.mountedCallback) === null || _b === void 0 || _b.call(_this1);
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }
                },
                {
                    key: "update",
                    value: function update() {
                        var _this = this;
                        return (0, $hP6lv._)(function() {
                            var _a, vNode, content, render, _document_startViewTransition, updateCallbackDone, finished, _b;
                            return (0, $7WkDo.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        vNode = (_a = _this.render) === null || _a === void 0 ? void 0 : _a.call(_this);
                                        content = (0, $e5wYp.isEmpty)(vNode) ? meta.mode ? (0, $85f08a9b324875d4$exports.jsx)("slot", {}) : null : vNode;
                                        if (!(content != null)) return [
                                            2
                                        ];
                                        render = function() {
                                            var _a;
                                            _this.renderer.render(content, _this.root);
                                            (_a = _this.updatedCallback) === null || _a === void 0 || _a.call(_this);
                                        };
                                        if (!meta.transitible || typeof document.startViewTransition !== "function") return [
                                            2,
                                            render()
                                        ];
                                        _document_startViewTransition = document.startViewTransition(render), updateCallbackDone = _document_startViewTransition.updateCallbackDone, finished = _document_startViewTransition.finished;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            finished
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        _b = _state.sent();
                                        return [
                                            2,
                                            updateCallbackDone
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }
                },
                {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        var _a;
                        var _this = this, root = _this.root, events = $e67e4bd0d5ef9fd4$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, type = _step_value.type, handler = _step_value.handler;
                                root.removeEventListener(type, handler);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        (_a = (0, $kbtRr._)((0, $kZtbK._)(RendererComponent.prototype), "disconnectedCallback", this)) === null || _a === void 0 || _a.call(this);
                    }
                },
                {
                    key: "emit",
                    value: function emit(event, detail) {
                        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, cancelable = _ref.cancelable, bubbles = _ref.bubbles, composed = _ref.composed;
                        return this.dispatchEvent(new CustomEvent(event, {
                            detail: detail,
                            cancelable: cancelable,
                            bubbles: bubbles,
                            composed: composed
                        }));
                    }
                },
                {
                    key: "toString",
                    value: function toString() {
                        return (0, $e5wYp.stringifyDOM)(this.root);
                    }
                }
            ]);
            return RendererComponent;
        }(Class);
        addInitializer(function() {
            var _a;
            (_a = globalThis.customElements) === null || _a === void 0 || _a.define(meta.tagName, this, meta);
        });
        return RendererComponent;
    };
}
function $e67e4bd0d5ef9fd4$export$af631764ddc44097(type, selector) {
    return function(method, param) {
        var addInitializer = param.addInitializer;
        return addInitializer(function() {
            var events = $e67e4bd0d5ef9fd4$var$$317b1f21909c74b8$var$eventMap.get(this) || [], handler = (0, $e5wYp.delegate)(selector, method.bind(this));
            events.push({
                type: type,
                selector: selector,
                handler: handler
            });
            $e67e4bd0d5ef9fd4$var$$317b1f21909c74b8$var$eventMap.set(this, events);
        });
    };
}
var $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$exports = {};
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$exports, "formField", function() {
    return $e67e4bd0d5ef9fd4$export$2a668e8d088a0667;
});
var $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers = function $29675797ddd6c4f7$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__esDecorate = function $29675797ddd6c4f7$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet = function $29675797ddd6c4f7$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet = function $29675797ddd6c4f7$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
function $e67e4bd0d5ef9fd4$export$2a668e8d088a0667(Class, _) {
    var FormFieldComponent = function() {
        var _a, _FormFieldComponent_name_accessor_storage, _FormFieldComponent_value_accessor_storage, _FormFieldComponent_required_accessor_storage, _FormFieldComponent_disabled_accessor_storage, _FormFieldComponent_autofocus_accessor_storage;
        var _classSuper = Class;
        var _instanceExtraInitializers = [];
        var _setValue_decorators;
        var _name_decorators;
        var _name_initializers = [];
        var _name_extraInitializers = [];
        var _value_decorators;
        var _value_initializers = [];
        var _value_extraInitializers = [];
        var _required_decorators;
        var _required_initializers = [];
        var _required_extraInitializers = [];
        var _disabled_decorators;
        var _disabled_initializers = [];
        var _disabled_extraInitializers = [];
        var _autofocus_decorators;
        var _autofocus_initializers = [];
        var _autofocus_extraInitializers = [];
        return _a = /*#__PURE__*/ function(_classSuper) {
            "use strict";
            (0, $aPY27._)(FormFieldComponent, _classSuper);
            var _super = (0, $SZ4bt._)(FormFieldComponent);
            function FormFieldComponent() {
                (0, $cc1Ug._)(this, FormFieldComponent);
                var _this;
                _this = _super.call.apply(_super, [
                    this
                ].concat(Array.prototype.slice.call(arguments)));
                _FormFieldComponent_name_accessor_storage.set((0, $dOF8f._)(_this), ($e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _instanceExtraInitializers), $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _name_initializers, void 0)));
                _FormFieldComponent_value_accessor_storage.set((0, $dOF8f._)(_this), ($e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _name_extraInitializers), $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _value_initializers, void 0)));
                _FormFieldComponent_required_accessor_storage.set((0, $dOF8f._)(_this), ($e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _value_extraInitializers), $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _required_initializers, void 0)));
                _FormFieldComponent_disabled_accessor_storage.set((0, $dOF8f._)(_this), ($e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _required_extraInitializers), $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _disabled_initializers, void 0)));
                _FormFieldComponent_autofocus_accessor_storage.set((0, $dOF8f._)(_this), ($e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _disabled_extraInitializers), $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _autofocus_initializers, void 0)));
                $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__runInitializers((0, $dOF8f._)(_this), _autofocus_extraInitializers);
                return _this;
            }
            (0, $gmv3D._)(FormFieldComponent, [
                {
                    key: "setValue",
                    value: function setValue(value) {
                        this.internals.setFormValue(value);
                    }
                },
                {
                    key: "formDisabledCallback",
                    value: function formDisabledCallback(disabled) {
                        this.disabled = disabled;
                    }
                },
                {
                    key: "name",
                    get: function get() {
                        return $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_name_accessor_storage, "f");
                    },
                    set: function set(value) {
                        $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_name_accessor_storage, value, "f");
                    }
                },
                {
                    key: "value",
                    get: function get() {
                        return $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_value_accessor_storage, "f");
                    },
                    set: function set(value) {
                        $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_value_accessor_storage, value, "f");
                    }
                },
                {
                    key: "required",
                    get: function get() {
                        return $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_required_accessor_storage, "f");
                    },
                    set: function set(value) {
                        $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_required_accessor_storage, value, "f");
                    }
                },
                {
                    key: "disabled",
                    get: function get() {
                        return $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_disabled_accessor_storage, "f");
                    },
                    set: function set(value) {
                        $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_disabled_accessor_storage, value, "f");
                    }
                },
                {
                    key: "autofocus",
                    get: function get() {
                        return $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_autofocus_accessor_storage, "f");
                    },
                    set: function set(value) {
                        $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_autofocus_accessor_storage, value, "f");
                    }
                },
                {
                    key: "defaultValue",
                    get: function get() {
                        return this.getAttribute("value");
                    },
                    set: function set(raw) {
                        var _b;
                        this.setAttribute("value", raw);
                        (_b = this.value) !== null && _b !== void 0 ? _b : this.value = raw;
                    }
                },
                {
                    key: "form",
                    get: function get() {
                        return this.internals.form;
                    }
                },
                {
                    key: "validity",
                    get: function get() {
                        return this.internals.validity;
                    }
                },
                {
                    key: "validationMessage",
                    get: function get() {
                        return this.internals.validationMessage;
                    }
                },
                {
                    key: "willValidate",
                    get: function get() {
                        return this.internals.willValidate;
                    }
                },
                {
                    key: "checkValidity",
                    value: function checkValidity() {
                        return this.internals.checkValidity();
                    }
                },
                {
                    key: "reportValidity",
                    value: function reportValidity() {
                        return this.internals.reportValidity();
                    }
                }
            ]);
            return FormFieldComponent;
        }(_classSuper), _FormFieldComponent_name_accessor_storage = new WeakMap(), _FormFieldComponent_value_accessor_storage = new WeakMap(), _FormFieldComponent_required_accessor_storage = new WeakMap(), _FormFieldComponent_disabled_accessor_storage = new WeakMap(), _FormFieldComponent_autofocus_accessor_storage = new WeakMap(), function() {
            var _b;
            var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _setValue_decorators = [
                $e67e4bd0d5ef9fd4$export$7203b476385689ae(function(param) {
                    var value = param.value;
                    return value;
                })
            ];
            _name_decorators = [
                $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434,
                (0, $b0lSM.observable)
            ];
            _value_decorators = [
                (0, $b0lSM.observable)
            ];
            _required_decorators = [
                $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434,
                (0, $b0lSM.observable)
            ];
            _disabled_decorators = [
                $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434,
                (0, $b0lSM.observable)
            ];
            _autofocus_decorators = [
                $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434,
                (0, $b0lSM.observable)
            ];
            $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _setValue_decorators, {
                kind: "method",
                name: "setValue",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "setValue" in obj;
                    },
                    get: function(obj) {
                        return obj.setValue;
                    }
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _name_decorators, {
                kind: "accessor",
                name: "name",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "name" in obj;
                    },
                    get: function(obj) {
                        return obj.name;
                    },
                    set: function(obj, value) {
                        obj.name = value;
                    }
                },
                metadata: _metadata
            }, _name_initializers, _name_extraInitializers);
            $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _value_decorators, {
                kind: "accessor",
                name: "value",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "value" in obj;
                    },
                    get: function(obj) {
                        return obj.value;
                    },
                    set: function(obj, value) {
                        obj.value = value;
                    }
                },
                metadata: _metadata
            }, _value_initializers, _value_extraInitializers);
            $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _required_decorators, {
                kind: "accessor",
                name: "required",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "required" in obj;
                    },
                    get: function(obj) {
                        return obj.required;
                    },
                    set: function(obj, value) {
                        obj.required = value;
                    }
                },
                metadata: _metadata
            }, _required_initializers, _required_extraInitializers);
            $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _disabled_decorators, {
                kind: "accessor",
                name: "disabled",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "disabled" in obj;
                    },
                    get: function(obj) {
                        return obj.disabled;
                    },
                    set: function(obj, value) {
                        obj.disabled = value;
                    }
                },
                metadata: _metadata
            }, _disabled_initializers, _disabled_extraInitializers);
            $e67e4bd0d5ef9fd4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _autofocus_decorators, {
                kind: "accessor",
                name: "autofocus",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "autofocus" in obj;
                    },
                    get: function(obj) {
                        return obj.autofocus;
                    },
                    set: function(obj, value) {
                        obj.autofocus = value;
                    }
                },
                metadata: _metadata
            }, _autofocus_initializers, _autofocus_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        }(), Object.defineProperty(_a, "formAssociated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }), _a;
    }();
    return FormFieldComponent;
}
var $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$exports = {};
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$exports, "AsyncCell", function() {
    return $e67e4bd0d5ef9fd4$export$854a54a999c89982;
});
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$exports, "lazy", function() {
    return $e67e4bd0d5ef9fd4$export$488013bae63b21da;
});
var $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__esDecorate = function $8acf79bd061a8fc3$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__runInitializers = function $8acf79bd061a8fc3$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__setFunctionName = function $8acf79bd061a8fc3$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet = function $8acf79bd061a8fc3$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet = function $8acf79bd061a8fc3$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__rest = function $8acf79bd061a8fc3$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e67e4bd0d5ef9fd4$export$854a54a999c89982 = function() {
    var _AsyncCell_component_accessor_storage, _AsyncCell_delegatedProps_accessor_storage;
    var _classDecorators = [
        $e67e4bd0d5ef9fd4$export$d8556a2a8f973135({
            tagName: "async-cell"
        }),
        $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _component_decorators;
    var _component_initializers = [];
    var _component_extraInitializers = [];
    var _delegatedProps_decorators;
    var _delegatedProps_initializers = [];
    var _delegatedProps_extraInitializers = [];
    var AsyncCell = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            Object.defineProperty((0, $dOF8f._)(_this), "loader", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AsyncCell_component_accessor_storage.set((0, $dOF8f._)(_this), $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__runInitializers((0, $dOF8f._)(_this), _component_initializers, void 0));
            _AsyncCell_delegatedProps_accessor_storage.set((0, $dOF8f._)(_this), ($e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__runInitializers((0, $dOF8f._)(_this), _component_extraInitializers), $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__runInitializers((0, $dOF8f._)(_this), _delegatedProps_initializers, void 0)));
            $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__runInitializers((0, $dOF8f._)(_this), _delegatedProps_extraInitializers);
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "component",
                get: function get() {
                    return $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _AsyncCell_component_accessor_storage, "f");
                },
                set: function set(value) {
                    $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _AsyncCell_component_accessor_storage, value, "f");
                }
            },
            {
                key: "delegatedProps",
                get: function get() {
                    return $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _AsyncCell_delegatedProps_accessor_storage, "f");
                },
                set: function set(value) {
                    $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _AsyncCell_delegatedProps_accessor_storage, value, "f");
                }
            },
            {
                key: "connectedCallback",
                value: function connectedCallback() {
                    this.load();
                }
            },
            {
                key: "load",
                value: function load() {
                    var _this = this;
                    return (0, $hP6lv._)(function() {
                        var Tag;
                        return (0, $7WkDo.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this.component = undefined;
                                    return [
                                        4,
                                        _this.loader()
                                    ];
                                case 1:
                                    Tag = _state.sent();
                                    _this.component = function(_a) {
                                        var children = _a.children, props = $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__rest(_a, [
                                            "children"
                                        ]);
                                        return (0, $85f08a9b324875d4$exports.jsx)(Tag, Object.assign({}, props, {
                                            children: children
                                        }));
                                    };
                                    _this.emit("load", _this.component);
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this, Tag = _this.component, props = _this.props, delegatedProps = _this.delegatedProps;
                    var _a = Object.assign(Object.assign({}, props), delegatedProps), children = _a.children, data = $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__rest(_a, [
                        "children"
                    ]);
                    return Tag && (0, $85f08a9b324875d4$exports.jsx)(Tag, Object.assign({}, data, {
                        children: children
                    }));
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _AsyncCell_component_accessor_storage = new WeakMap();
    _AsyncCell_delegatedProps_accessor_storage = new WeakMap();
    $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__setFunctionName(_classThis, "AsyncCell");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _component_decorators = [
            (0, $b0lSM.observable)
        ];
        _delegatedProps_decorators = [
            (0, $b0lSM.observable)
        ];
        $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _component_decorators, {
            kind: "accessor",
            name: "component",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "component" in obj;
                },
                get: function(obj) {
                    return obj.component;
                },
                set: function(obj, value) {
                    obj.component = value;
                }
            },
            metadata: _metadata
        }, _component_initializers, _component_extraInitializers);
        $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _delegatedProps_decorators, {
            kind: "accessor",
            name: "delegatedProps",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "delegatedProps" in obj;
                },
                get: function(obj) {
                    return obj.delegatedProps;
                },
                set: function(obj, value) {
                    obj.delegatedProps = value;
                }
            },
            metadata: _metadata
        }, _delegatedProps_initializers, _delegatedProps_extraInitializers);
        $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AsyncCell = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $e67e4bd0d5ef9fd4$var$$8acf79bd061a8fc3$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AsyncCell = _classThis;
}();
function $e67e4bd0d5ef9fd4$export$488013bae63b21da(loader) {
    return function(props) {
        return (0, $85f08a9b324875d4$exports.jsx)($e67e4bd0d5ef9fd4$export$854a54a999c89982, {
            delegatedProps: props,
            loader: /*#__PURE__*/ (0, $hP6lv._)(function() {
                return (0, $7WkDo.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                loader()
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent().default
                            ];
                    }
                });
            })
        });
    };
}
var $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$exports = {};
$e67e4bd0d5ef9fd4$var$$parcel$export($e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$exports, "AnimateCSS", function() {
    return $e67e4bd0d5ef9fd4$export$2e9a7bb10257a509;
});
var $e67e4bd0d5ef9fd4$var$$819b340f625a29f4$exports = {};
var $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__runInitializers = function $d4436c849e74ae70$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__esDecorate = function $d4436c849e74ae70$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__setFunctionName = function $d4436c849e74ae70$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__classPrivateFieldGet = function $d4436c849e74ae70$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__classPrivateFieldSet = function $d4436c849e74ae70$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e67e4bd0d5ef9fd4$export$2e9a7bb10257a509 = function() {
    var _AnimateCSS_type_accessor_storage, _AnimateCSS_playing_accessor_storage;
    var _classDecorators = [
        $e67e4bd0d5ef9fd4$export$d8556a2a8f973135({
            tagName: "animation-css"
        }),
        $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _instanceExtraInitializers = [];
    var _type_decorators;
    var _type_initializers = [];
    var _type_extraInitializers = [];
    var _playing_decorators;
    var _playing_initializers = [];
    var _playing_extraInitializers = [];
    var _typeChanged_decorators;
    var AnimateCSS = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            _AnimateCSS_type_accessor_storage.set((0, $dOF8f._)(_this), ($e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__runInitializers((0, $dOF8f._)(_this), _instanceExtraInitializers), $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__runInitializers((0, $dOF8f._)(_this), _type_initializers, void 0)));
            _AnimateCSS_playing_accessor_storage.set((0, $dOF8f._)(_this), ($e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__runInitializers((0, $dOF8f._)(_this), _type_extraInitializers), $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__runInitializers((0, $dOF8f._)(_this), _playing_initializers, false)));
            Object.defineProperty((0, $dOF8f._)(_this), "component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__runInitializers((0, $dOF8f._)(_this), _playing_extraInitializers)
            });
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "type",
                get: function get() {
                    return $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_type_accessor_storage, "f");
                },
                set: function set(value) {
                    $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_type_accessor_storage, value, "f");
                }
            },
            {
                key: "playing",
                get: function get() {
                    return $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_playing_accessor_storage, "f");
                },
                set: function set(value) {
                    $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_playing_accessor_storage, value, "f");
                }
            },
            {
                key: "connectedCallback",
                value: function connectedCallback() {
                    var _this = this;
                    return (0, $hP6lv._)(function() {
                        return (0, $7WkDo.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0, $e5wYp.importCSS)("https://unpkg.com/animate.css@4/animate.min.css")
                                    ];
                                case 1:
                                    _state.sent();
                                    _this.typeChanged();
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            },
            {
                key: "typeChanged",
                value: function typeChanged() {
                    var _this = this;
                    return (0, $hP6lv._)(function() {
                        return (0, $7WkDo.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this.playing = true;
                                    return [
                                        4,
                                        $e67e4bd0d5ef9fd4$export$4077c0dfbe9c3861(_this, ".animate__animated")
                                    ];
                                case 1:
                                    _state.sent();
                                    _this.playing = false;
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this, type = _this.type, playing = _this.playing, Tag = _this.component;
                    return playing ? (0, $85f08a9b324875d4$exports.jsx)(Tag, {
                        className: "animate__animated animate__".concat(type)
                    }) : type.includes("Out") ? (0, $85f08a9b324875d4$exports.jsx)((0, $85f08a9b324875d4$exports.Fragment), {}) : (0, $85f08a9b324875d4$exports.jsx)(Tag, {});
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _AnimateCSS_type_accessor_storage = new WeakMap();
    _AnimateCSS_playing_accessor_storage = new WeakMap();
    $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__setFunctionName(_classThis, "AnimateCSS");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [
            $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434,
            (0, $b0lSM.observable)
        ];
        _playing_decorators = [
            $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434,
            (0, $b0lSM.observable)
        ];
        _typeChanged_decorators = [
            $e67e4bd0d5ef9fd4$export$7203b476385689ae(function(param) {
                var type = param.type;
                return type;
            })
        ];
        $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _type_decorators, {
            kind: "accessor",
            name: "type",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "type" in obj;
                },
                get: function(obj) {
                    return obj.type;
                },
                set: function(obj, value) {
                    obj.type = value;
                }
            },
            metadata: _metadata
        }, _type_initializers, _type_extraInitializers);
        $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _playing_decorators, {
            kind: "accessor",
            name: "playing",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "playing" in obj;
                },
                get: function(obj) {
                    return obj.playing;
                },
                set: function(obj, value) {
                    obj.playing = value;
                }
            },
            metadata: _metadata
        }, _playing_initializers, _playing_extraInitializers);
        $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _typeChanged_decorators, {
            kind: "method",
            name: "typeChanged",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "typeChanged" in obj;
                },
                get: function(obj) {
                    return obj.typeChanged;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AnimateCSS = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AnimateCSS = _classThis;
}();
$e67e4bd0d5ef9fd4$var$$parcel$exportWildcard($e67e4bd0d5ef9fd4$var$$d4436c849e74ae70$exports, $e67e4bd0d5ef9fd4$var$$819b340f625a29f4$exports);


function $b43d7d4f6a3d643f$export$adaf682ac3edfe45(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $b43d7d4f6a3d643f$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $b43d7d4f6a3d643f$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $b43d7d4f6a3d643f$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $b43d7d4f6a3d643f$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $b43d7d4f6a3d643f$var$AsyncFromSyncIterator(s);
}



var $hP6lv = parcelRequire("hP6lv");

var $cc1Ug = parcelRequire("cc1Ug");

var $gmv3D = parcelRequire("gmv3D");

var $7sqYf = parcelRequire("7sqYf");

var $7WkDo = parcelRequire("7WkDo");
function $7f023510481d8142$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $7f023510481d8142$var$$22de11b45b0eeb97$exports = {};
$7f023510481d8142$var$$parcel$export($7f023510481d8142$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $7f023510481d8142$export$c7e91f8aec23ae14;
});
$7f023510481d8142$var$$parcel$export($7f023510481d8142$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $7f023510481d8142$export$51ca94569b882c51;
});
var $7f023510481d8142$export$c7e91f8aec23ae14 = function $22de11b45b0eeb97$export$c7e91f8aec23ae14() {
    "use strict";
    var _this = this;
    (0, $cc1Ug._)(this, $22de11b45b0eeb97$export$c7e91f8aec23ae14);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
var $7f023510481d8142$export$51ca94569b882c51 = function() {
    return new $7f023510481d8142$export$c7e91f8aec23ae14();
};
var $7f023510481d8142$var$$e3640f413e0c36e7$exports = {};
$7f023510481d8142$var$$parcel$export($7f023510481d8142$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $7f023510481d8142$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, "observable", Symbol("observable"));
var $7f023510481d8142$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    "use strict";
    function $e3640f413e0c36e7$export$77cea355fa80b5f4(subscriber) {
        (0, $cc1Ug._)(this, $e3640f413e0c36e7$export$77cea355fa80b5f4);
        this.subscriber = subscriber;
    }
    (0, $gmv3D._)($e3640f413e0c36e7$export$77cea355fa80b5f4, [
        {
            key: Symbol.observable,
            value: function value() {
                return this;
            }
        },
        {
            key: Symbol.asyncIterator,
            value: function value() {
                var _this = this;
                return (0, $7sqYf._)(function() {
                    var queue, canceler, done, observer;
                    return (0, $7WkDo.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                queue = [
                                    new $7f023510481d8142$export$c7e91f8aec23ae14()
                                ], done = false;
                                observer = {
                                    next: function(value) {
                                        if (done) return;
                                        queue[queue.length - 1].resolve(value);
                                        queue.push(new $7f023510481d8142$export$c7e91f8aec23ae14());
                                    },
                                    error: function(reason) {
                                        if (!done) queue[queue.length - 1].reject(reason), done = true;
                                        if (canceler) canceler();
                                    },
                                    complete: function() {
                                        if (!done) queue[queue.length - 1].resolve(), done = true;
                                        if (canceler) canceler();
                                    }
                                };
                                canceler = _this.subscriber(observer);
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    queue[0].promise
                                ];
                            case 2:
                                _state.sent();
                                queue.shift();
                                _state.label = 3;
                            case 3:
                                if (queue[0]) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                var _this = this;
                return (0, $hP6lv._)(function() {
                    var stack, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err;
                    return (0, $7WkDo.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                stack = [];
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    12
                                ]);
                                _iterator = (0, $b43d7d4f6a3d643f$export$adaf682ac3edfe45)(_this);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    5
                                ];
                                _value = _step.value;
                                item = _value;
                                stack.push(item);
                                if (stack.length > 2) stack.shift();
                                _state.label = 4;
                            case 4:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    12
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 7:
                                _state.trys.push([
                                    7,
                                    ,
                                    10,
                                    11
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    2,
                                    stack[0]
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "subscribe",
            value: function subscribe(onNext, onError, onComplete) {
                var stop = false;
                var _this = this;
                (0, $hP6lv._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err, error;
                    return (0, $7WkDo.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    13,
                                    ,
                                    14
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    12
                                ]);
                                _iterator = (0, $b43d7d4f6a3d643f$export$adaf682ac3edfe45)(_this);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    5
                                ];
                                _value = _step.value;
                                item = _value;
                                if (!stop) onNext(item);
                                else return [
                                    3,
                                    5
                                ];
                                _state.label = 4;
                            case 4:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    12
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 7:
                                _state.trys.push([
                                    7,
                                    ,
                                    10,
                                    11
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    7
                                ];
                            case 12:
                                if (onComplete instanceof Function) onComplete();
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                error = _state.sent();
                                if (onError instanceof Function) onError(error);
                                return [
                                    3,
                                    14
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                })();
                return {
                    unsubscribe: function() {
                        stop = true;
                    },
                    get closed () {
                        return stop;
                    }
                };
            }
        }
    ], [
        {
            key: "of",
            value: function of() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return new this(function(param) {
                    var next = param.next, complete = param.complete;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var item = _step.value;
                            next(item);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    complete();
                });
            }
        },
        {
            key: "from",
            value: function from(observable) {
                return new this(function(param) {
                    var next = param.next, error = param.error, complete = param.complete;
                    return observable.subscribe(next, error, complete).unsubscribe;
                });
            }
        },
        {
            key: "fromEvent",
            value: function fromEvent(target, name) {
                return new this(function(param) {
                    var next = param.next, error = param.error;
                    if (typeof target.on === "function") target.on(name, next).on("error", error);
                    else {
                        target.addEventListener(name, next);
                        target.addEventListener("error", error);
                    }
                    return function() {
                        if (typeof target.off === "function") target.off(name, next).off("error", error);
                        else {
                            target.removeEventListener(name, next);
                            target.removeEventListener("error", error);
                        }
                    };
                });
            }
        }
    ]);
    return $e3640f413e0c36e7$export$77cea355fa80b5f4;
}();
var $7f023510481d8142$var$$603f33a01a36ab56$exports = {};
$7f023510481d8142$var$$parcel$export($7f023510481d8142$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $7f023510481d8142$export$d16acf4b6e75743d;
});
function $7f023510481d8142$export$d16acf4b6e75743d() {
    var feedNext, stop;
    var observable = new $7f023510481d8142$export$77cea355fa80b5f4(function(param) {
        var next = param.next, complete = param.complete;
        feedNext = next, stop = complete;
    });
    return {
        process: function(data) {
            var defer = new $7f023510481d8142$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy: function() {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}


function $23b04808d9219184$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $23b04808d9219184$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var $23b04808d9219184$var$$63d86f11b44ac799$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$63d86f11b44ac799$exports, "Status", function() {
    return $23b04808d9219184$export$96e9906d6d93a972;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$63d86f11b44ac799$exports, "Theme", function() {
    return $23b04808d9219184$export$14faa19a0f3bbeb2;
});
var $23b04808d9219184$export$96e9906d6d93a972;
(function(Status) {
    Status["primary"] = "primary";
    Status["secondary"] = "secondary";
    Status["tertiary"] = "tertiary";
    Status["success"] = "success";
    Status["info"] = "info";
    Status["warning"] = "warning";
    Status["danger"] = "danger";
})($23b04808d9219184$export$96e9906d6d93a972 || ($23b04808d9219184$export$96e9906d6d93a972 = {}));
var $23b04808d9219184$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["light"] = "light";
    Theme["dark"] = "dark";
})($23b04808d9219184$export$14faa19a0f3bbeb2 || ($23b04808d9219184$export$14faa19a0f3bbeb2 = {}));
var $23b04808d9219184$var$$63c790b9c4a0fb72$exports = {};
var $23b04808d9219184$var$$bc5b3c994c26f289$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$bc5b3c994c26f289$exports, "Ratio", function() {
    return $23b04808d9219184$export$438ad6fc467f929b;
});
var $23b04808d9219184$var$$bc5b3c994c26f289$var$__rest = function $bc5b3c994c26f289$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$438ad6fc467f929b = function(_a) {
    var className = _a.className, style = _a.style, tmp = _a.aspectRatio, aspectRatio = tmp === void 0 ? "1x1" : tmp, children = _a.children, props = $23b04808d9219184$var$$bc5b3c994c26f289$var$__rest(_a, [
        "className",
        "style",
        "aspectRatio",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("ratio", typeof aspectRatio === "string" && "ratio-".concat(aspectRatio), className),
        style: Object.assign(Object.assign({}, style), typeof aspectRatio === "number" ? {
            "--bs-aspect-ratio": "".concat(aspectRatio * 100, "%")
        } : null)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$var$$72880cb85e950d46$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$72880cb85e950d46$exports, "Container", function() {
    return $23b04808d9219184$export$42a852a2b6b56249;
});
var $23b04808d9219184$var$$72880cb85e950d46$var$__rest = function $72880cb85e950d46$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$42a852a2b6b56249 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, fluid = _a.fluid, children = _a.children, props = $23b04808d9219184$var$$72880cb85e950d46$var$__rest(_a, [
        "className",
        "fluid",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "container".concat(fluid === true ? "-fluid" : fluid ? "-".concat(fluid) : "", " ").concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$var$$f09e7170f0f51b36$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$f09e7170f0f51b36$exports, "ScrollBoundary", function() {
    return $23b04808d9219184$export$d086fcc3bc3f366f;
});
function $23b04808d9219184$var$$f09e7170f0f51b36$var$touch(edge, onTouch) {
    return function(node) {
        return node && new IntersectionObserver(function(param) {
            var _param = (0, $fIpBC._)(param, 1), _param_ = _param[0], isIntersecting = _param_.isIntersecting;
            return isIntersecting && onTouch(edge);
        }).observe(node);
    };
}
var $23b04808d9219184$export$d086fcc3bc3f366f = function(param) {
    var className = param.className, onTouch = param.onTouch, top = param.top, left = param.left, right = param.right, bottom = param.bottom, children = param.children;
    return (0, $85f08a9b324875d4$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("position-relative", className),
        children: [
            (0, $85f08a9b324875d4$exports.jsx)("div", {
                className: "position-absolute top-0 left-0 w-100",
                ref: $23b04808d9219184$var$$f09e7170f0f51b36$var$touch("top", onTouch),
                children: top
            }),
            (0, $85f08a9b324875d4$exports.jsx)("div", {
                className: "position-absolute top-0 left-0 h-100",
                ref: $23b04808d9219184$var$$f09e7170f0f51b36$var$touch("left", onTouch),
                children: left
            }),
            children,
            (0, $85f08a9b324875d4$exports.jsx)("div", {
                className: "position-absolute top-0 right-0 h-100",
                ref: $23b04808d9219184$var$$f09e7170f0f51b36$var$touch("right", onTouch),
                children: right
            }),
            (0, $85f08a9b324875d4$exports.jsx)("div", {
                className: "position-absolute top-100 left-0 w-100",
                ref: $23b04808d9219184$var$$f09e7170f0f51b36$var$touch("bottom", onTouch),
                children: bottom
            })
        ]
    });
};
var $23b04808d9219184$var$$afd912368a35cd9a$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$afd912368a35cd9a$exports, "Collapse", function() {
    return $23b04808d9219184$export$78768a9af065a7b;
});
var $23b04808d9219184$var$$afd912368a35cd9a$var$__rest = function $afd912368a35cd9a$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$78768a9af065a7b = function(_a) {
    var className = _a.className, tmp = _a.dimension, dimension = tmp === void 0 ? "width" : tmp, show = _a.in, children = _a.children, props = $23b04808d9219184$var$$afd912368a35cd9a$var$__rest(_a, [
        "className",
        "dimension",
        "in",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("collapse", {
            "collapse-horizontal": dimension === "height",
            show: show
        }, className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$var$$f01a97a2de8a9291$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$f01a97a2de8a9291$exports, "OffcanvasTitle", function() {
    return $23b04808d9219184$export$1b33297d19c3da30;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$f01a97a2de8a9291$exports, "OffcanvasHeader", function() {
    return $23b04808d9219184$export$b6c1518fb8dc5e75;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$f01a97a2de8a9291$exports, "OffcanvasBody", function() {
    return $23b04808d9219184$export$c324d20ecc5b7dee;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$f01a97a2de8a9291$exports, "Offcanvas", function() {
    return $23b04808d9219184$export$591ca0244c9dfcd4;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$f01a97a2de8a9291$exports, "OffcanvasBox", function() {
    return $23b04808d9219184$export$1de07a2f4bdee270;
});
var $23b04808d9219184$var$$c1c7ccde32bca97a$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$c1c7ccde32bca97a$exports, "Button", function() {
    return $23b04808d9219184$export$353f5b6fc5456de1;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$c1c7ccde32bca97a$exports, "isButton", function() {
    return $23b04808d9219184$export$35a0171ee384c875;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$c1c7ccde32bca97a$exports, "IconButton", function() {
    return $23b04808d9219184$export$c25acd513dcc8062;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$c1c7ccde32bca97a$exports, "CloseButton", function() {
    return $23b04808d9219184$export$de65de8213222d10;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$c1c7ccde32bca97a$exports, "ToggleButton", function() {
    return $23b04808d9219184$export$d2b052e7b4be1756;
});
var $23b04808d9219184$var$$a68e72fb637d83af$exports = {};
var $23b04808d9219184$var$$4927147f477cca2e$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$4927147f477cca2e$exports, "Badge", function() {
    return $23b04808d9219184$export$37acb3580601e69a;
});
var $23b04808d9219184$var$$4927147f477cca2e$var$__rest = function $4927147f477cca2e$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$37acb3580601e69a = function(_a) {
    var className = _a.className, bg = _a.bg, text = _a.text, pill = _a.pill, href = _a.href, children = _a.children, rest = $23b04808d9219184$var$$4927147f477cca2e$var$__rest(_a, [
        "className",
        "bg",
        "text",
        "pill",
        "href",
        "children"
    ]);
    var Class = (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("badge", bg && "text-bg-".concat(bg), text && "text-".concat(text), pill && "rounded-pill", href && "text-decoration-none", className);
    return href ? (0, $85f08a9b324875d4$exports.jsx)("a", Object.assign({}, rest, {
        className: Class,
        href: href,
        children: children
    })) : (0, $85f08a9b324875d4$exports.jsx)("span", Object.assign({}, rest, {
        className: Class,
        children: children
    }));
};
var $23b04808d9219184$var$$6ed7cbf81486b3b8$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$6ed7cbf81486b3b8$exports, "Icon", function() {
    return $23b04808d9219184$export$f04a61298a47a40f;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$6ed7cbf81486b3b8$exports, "BGIcon", function() {
    return $23b04808d9219184$export$af1945c3768d186c;
});
var $23b04808d9219184$var$$6ed7cbf81486b3b8$var$__rest = function $6ed7cbf81486b3b8$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$f04a61298a47a40f = function(_a) {
    var className = _a.className, style = _a.style, color = _a.color, name = _a.name, size = _a.size, children = _a.children, rest = $23b04808d9219184$var$$6ed7cbf81486b3b8$var$__rest(_a, [
        "className",
        "style",
        "color",
        "name",
        "size",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("i", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("bi-".concat(name), color && "text-".concat(color), className),
        style: Object.assign(Object.assign({}, style), {
            fontSize: size ? "".concat(size, "rem") : undefined
        })
    }, rest));
};
var $23b04808d9219184$export$af1945c3768d186c = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, tmp1 = _a.type, type = tmp1 === void 0 ? "square" : tmp1, tmp2 = _a.color, color = tmp2 === void 0 ? "primary" : tmp2, children = _a.children, props = $23b04808d9219184$var$$6ed7cbf81486b3b8$var$__rest(_a, [
        "className",
        "type",
        "color",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("span", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("d-inline-block", "p-3", "bg-".concat(color), "rounded".concat(type === "square" ? "" : "-circle"), className)
    }, props, {
        children: (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$f04a61298a47a40f, Object.assign({
            color: color === "light" ? "dark" : "light"
        }, props))
    }));
};
var $23b04808d9219184$var$$4720465b54b9bde5$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$4720465b54b9bde5$exports, "FAIcon", function() {
    return $23b04808d9219184$export$9151c10c0bcf31d3;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$4720465b54b9bde5$exports, "FABGIcon", function() {
    return $23b04808d9219184$export$bc62d7a28670119b;
});
var $23b04808d9219184$var$$4720465b54b9bde5$var$__rest = function $4720465b54b9bde5$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$9151c10c0bcf31d3 = function(_a) {
    var tmp = _a.group, group = tmp === void 0 ? "solid" : tmp, name = _a.name, size = _a.size, fixedWidth = _a.fixedWidth, color = _a.color, inverse = _a.inverse, border = _a.border, rotate = _a.rotate, flip = _a.flip, animation = _a.animation, pull = _a.pull, stack = _a.stack, listItem = _a.listItem, className = _a.className, children = _a.children, rest = $23b04808d9219184$var$$4720465b54b9bde5$var$__rest(_a, [
        "group",
        "name",
        "size",
        "fixedWidth",
        "color",
        "inverse",
        "border",
        "rotate",
        "flip",
        "animation",
        "pull",
        "stack",
        "listItem",
        "className",
        "children"
    ]);
    var icon = (0, $85f08a9b324875d4$exports.jsx)("span", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("fa" + group[0], "fa-" + name, size && "fa-" + (typeof size === "number" ? size + "x" : size), fixedWidth && "fa-fw", inverse && "fa-inverse", border && "fa-border", rotate && "fa-rotate-" + rotate, flip && "fa-flip-" + flip, animation && "fa-" + animation, pull && "fa-pull-" + pull, stack && "fa-stack-".concat(stack, "x"), color && "text-" + color, className),
        "aria-hidden": "true"
    }, rest));
    return listItem ? (0, $85f08a9b324875d4$exports.jsx)("span", {
        className: "fa-li",
        children: icon
    }) : icon;
};
var $23b04808d9219184$export$bc62d7a28670119b = function(_a) {
    var size = _a.size, color = _a.color, className = _a.className, type = _a.type, rest = $23b04808d9219184$var$$4720465b54b9bde5$var$__rest(_a, [
        "size",
        "color",
        "className",
        "type"
    ]);
    return (0, $85f08a9b324875d4$exports.jsxs)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("fa-stack", size && "fa-" + (typeof size === "number" ? size + "x" : size), color && "text-" + color, className),
        children: [
            (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$9151c10c0bcf31d3, {
                name: type,
                stack: 2
            }),
            (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$9151c10c0bcf31d3, Object.assign({}, rest, {
                stack: 1,
                inverse: true
            }))
        ]
    });
};
var $23b04808d9219184$var$$bdccd8f4843146f6$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$bdccd8f4843146f6$exports, "ProgressBar", function() {
    return $23b04808d9219184$export$c17561cb55d4db30;
});
var $23b04808d9219184$export$c17561cb55d4db30 = function(param) {
    var tmp = param.className, className = tmp === void 0 ? "" : tmp, striped = param.striped, animated = param.animated, tmp1 = param.variant, variant = tmp1 === void 0 ? "primary" : tmp1, tmp2 = param.min, min = tmp2 === void 0 ? 0 : tmp2, tmp3 = param.max, max = tmp3 === void 0 ? 100 : tmp3, tmp4 = param.now, now = tmp4 === void 0 ? min : tmp4, label = param.label, children = param.children;
    return (0, $e5wYp.isEmpty)(children) ? (0, $85f08a9b324875d4$exports.jsx)("div", {
        className: "progress ".concat(className),
        role: "progressbar",
        ariaValueMin: min + "",
        ariaValueMax: max + "",
        ariaValueNow: now + "",
        children: (0, $85f08a9b324875d4$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("progress-bar", "text-bg-".concat(variant), striped && "progress-bar-striped", animated && "progress-bar-animated"),
            style: {
                width: now + "%"
            },
            children: typeof label === "function" ? label(now) : label && "".concat(now, "%")
        })
    }) : (0, $85f08a9b324875d4$exports.jsx)("div", {
        className: "progress-stacked ".concat(className),
        children: children
    });
};
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a68e72fb637d83af$exports, $23b04808d9219184$var$$4927147f477cca2e$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a68e72fb637d83af$exports, $23b04808d9219184$var$$6ed7cbf81486b3b8$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a68e72fb637d83af$exports, $23b04808d9219184$var$$4720465b54b9bde5$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a68e72fb637d83af$exports, $23b04808d9219184$var$$bdccd8f4843146f6$exports);
var $23b04808d9219184$var$$c1c7ccde32bca97a$var$__rest = function $c1c7ccde32bca97a$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$353f5b6fc5456de1 = function(_a) {
    var className = _a.className, href = _a.href, variant = _a.variant, size = _a.size, active = _a.active, children = _a.children, props = $23b04808d9219184$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className",
        "href",
        "variant",
        "size",
        "active",
        "children"
    ]);
    var disabled = props.disabled, tabIndex = props.tabIndex, Class = (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("btn", variant && "btn-".concat(variant), size && "btn-".concat(size), className);
    return href ? (0, $85f08a9b324875d4$exports.jsx)("a", Object.assign({
        role: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(Class, {
            disabled: disabled,
            active: active
        }),
        tabIndex: disabled ? -1 : tabIndex,
        ariaDisabled: disabled === null || disabled === void 0 ? void 0 : disabled.toString(),
        ariaPressed: active === null || active === void 0 ? void 0 : active.toString(),
        href: href
    }, props, {
        children: children
    })) : (0, $85f08a9b324875d4$exports.jsx)("button", Object.assign({
        className: Class
    }, props, {
        ariaPressed: active === null || active === void 0 ? void 0 : active.toString(),
        children: children
    }));
};
function $23b04808d9219184$export$35a0171ee384c875(node) {
    var _a;
    var selector = node.selector, props = node.props;
    return /^(a|input|button)/.test(selector) && ((_a = props === null || props === void 0 ? void 0 : props.className) === null || _a === void 0 ? void 0 : _a.btn);
}
var $23b04808d9219184$export$c25acd513dcc8062 = function(_a) {
    var className = _a.className, name = _a.name, button = $23b04808d9219184$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className",
        "name"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$353f5b6fc5456de1, Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("p-1", className),
        style: {
            lineHeight: "0.8"
        }
    }, button, {
        children: (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$f04a61298a47a40f, {
            name: name
        })
    }));
};
var $23b04808d9219184$export$de65de8213222d10 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, props = $23b04808d9219184$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("button", Object.assign({
        className: "btn-close ".concat(className),
        type: "button",
        ariaLabel: "Close"
    }, props));
};
var $23b04808d9219184$export$d2b052e7b4be1756 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, tmp1 = _a.id, id = tmp1 === void 0 ? (0, $e5wYp.uniqueID)() : tmp1, tmp2 = _a.variant, variant = tmp2 === void 0 ? "primary" : tmp2, children = _a.children, props = $23b04808d9219184$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className",
        "id",
        "variant",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
        children: [
            (0, $85f08a9b324875d4$exports.jsx)("input", Object.assign({
                className: "btn-check",
                id: id,
                autocomplete: "off"
            }, props)),
            (0, $85f08a9b324875d4$exports.jsx)("label", {
                className: "btn btn-".concat(variant, " ").concat(className),
                htmlFor: id,
                children: children
            })
        ]
    });
};
var $23b04808d9219184$var$$f01a97a2de8a9291$var$__rest = function $f01a97a2de8a9291$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$1b33297d19c3da30 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("h5", Object.assign({
        className: "offcanvas-title ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$b6c1518fb8dc5e75 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, closeButton = _a.closeButton, children = _a.children, onHide = _a.onHide, props = $23b04808d9219184$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "closeButton",
        "children",
        "onHide"
    ]);
    return (0, $85f08a9b324875d4$exports.jsxs)("div", Object.assign({
        className: "offcanvas-header ".concat(className)
    }, props, {
        children: [
            children,
            closeButton && (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$de65de8213222d10, {
                onClick: onHide
            })
        ]
    }));
};
var $23b04808d9219184$export$c324d20ecc5b7dee = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "offcanvas-body ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$591ca0244c9dfcd4 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, style = _a.style, tmp1 = _a.backdrop, backdrop = tmp1 === void 0 ? true : tmp1, show = _a.show, onHide = _a.onHide, children = _a.children, props = $23b04808d9219184$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "style",
        "backdrop",
        "show",
        "onHide",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
        children: [
            (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("offcanvas", show ? "offcanvas-end show" : "offcanvas-start", className),
                style: Object.assign({
                    maxWidth: "75vw"
                }, style),
                tabIndex: -1
            }, backdrop === "static" ? {
                "data-bs-backdrop": "static"
            } : {}, props, {
                children: children
            })),
            show && (0, $85f08a9b324875d4$exports.jsx)("div", {
                className: "offcanvas-backdrop show",
                onClick: onHide
            })
        ]
    });
};
var $23b04808d9219184$export$1de07a2f4bdee270 = function(_a) {
    var title = _a.title, tmp = _a.titleId, titleId = tmp === void 0 ? (0, $e5wYp.uniqueID)() : tmp, closeButton = _a.closeButton, onHide = _a.onHide, children = _a.children, props = $23b04808d9219184$var$$f01a97a2de8a9291$var$__rest(_a, [
        "title",
        "titleId",
        "closeButton",
        "onHide",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsxs)($23b04808d9219184$export$591ca0244c9dfcd4, Object.assign({}, props, {
        onHide: onHide,
        "aria-labelledby": titleId,
        children: [
            (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$b6c1518fb8dc5e75, {
                closeButton: closeButton,
                onHide: onHide,
                children: (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$1b33297d19c3da30, {
                    id: titleId,
                    children: title
                })
            }),
            (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$c324d20ecc5b7dee, {
                children: children
            })
        ]
    }));
};
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$63c790b9c4a0fb72$exports, $23b04808d9219184$var$$bc5b3c994c26f289$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$63c790b9c4a0fb72$exports, $23b04808d9219184$var$$72880cb85e950d46$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$63c790b9c4a0fb72$exports, $23b04808d9219184$var$$f09e7170f0f51b36$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$63c790b9c4a0fb72$exports, $23b04808d9219184$var$$afd912368a35cd9a$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$63c790b9c4a0fb72$exports, $23b04808d9219184$var$$f01a97a2de8a9291$exports);
var $23b04808d9219184$var$$a9c2f09022d17944$exports = {};
var $23b04808d9219184$var$$f7c1ec19aba15bac$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$f7c1ec19aba15bac$exports, "ListGroup", function() {
    return $23b04808d9219184$export$9cc9809463a041c4;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$f7c1ec19aba15bac$exports, "ListGroupItem", function() {
    return $23b04808d9219184$export$3175656842a28549;
});
var $23b04808d9219184$var$$f7c1ec19aba15bac$var$__rest = function $f7c1ec19aba15bac$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$9cc9809463a041c4 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, variant = _a.variant, numbered = _a.numbered, horizontal = _a.horizontal, children = _a.children, props = $23b04808d9219184$var$$f7c1ec19aba15bac$var$__rest(_a, [
        "className",
        "variant",
        "numbered",
        "horizontal",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("list-group", variant && "list-group-".concat(variant), numbered && "list-group-numbered", horizontal && "list-group-horizontal".concat(horizontal === true ? "" : "-".concat(horizontal)), className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$3175656842a28549 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, variant = _a.variant, href = _a.href, active = _a.active, disabled = _a.disabled, children = _a.children, props = $23b04808d9219184$var$$f7c1ec19aba15bac$var$__rest(_a, [
        "className",
        "variant",
        "href",
        "active",
        "disabled",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("a", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("list-group-item", variant && "list-group-item-".concat(variant), href && "list-group-item-action", {
            active: active,
            disabled: disabled
        }, disabled && "pe-none", className),
        ariaCurrent: active ? "true" : undefined,
        ariaDisabled: disabled ? "true" : undefined,
        href: href
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$var$$fae440e6475ac9b3$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$fae440e6475ac9b3$exports, "Table", function() {
    return $23b04808d9219184$export$54ec01a60f47d33d;
});
var $23b04808d9219184$var$$fae440e6475ac9b3$var$__rest = function $fae440e6475ac9b3$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$54ec01a60f47d33d = function(_a) {
    var className = _a.className, variant = _a.variant, size = _a.size, responsive = _a.responsive, striped = _a.striped, hover = _a.hover, bordered = _a.bordered, borderless = _a.borderless, caption = _a.caption, children = _a.children, props = $23b04808d9219184$var$$fae440e6475ac9b3$var$__rest(_a, [
        "className",
        "variant",
        "size",
        "responsive",
        "striped",
        "hover",
        "bordered",
        "borderless",
        "caption",
        "children"
    ]);
    var table = (0, $85f08a9b324875d4$exports.jsx)("table", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("table", variant && "table-".concat(variant), size && "table-".concat(size), striped && "table-striped".concat(striped === "columns" ? "-columns" : ""), hover && "table-hover", bordered && "table-bordered", borderless && "table-borderless", caption && "caption-".concat(caption))
    }, props, {
        children: children
    }));
    return responsive ? (0, $85f08a9b324875d4$exports.jsx)("div", {
        className: "table-responsive".concat(responsive === true ? "" : "-".concat(responsive)),
        children: table
    }) : table;
};
var $23b04808d9219184$var$$748e31f0f7788c85$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$748e31f0f7788c85$exports, "Jumbotron", function() {
    return $23b04808d9219184$export$97aba50a380f875b;
});
var $23b04808d9219184$var$$748e31f0f7788c85$var$__rest = function $748e31f0f7788c85$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$97aba50a380f875b = function(_a) {
    var fluid = _a.fluid, tmp = _a.className, className = tmp === void 0 ? "py-5 ".concat(fluid ? "" : "px-5") : tmp, tmp1 = _a.bg, bg = tmp1 === void 0 ? "body-tertiary" : tmp1, tmp2 = _a.rounded, rounded = tmp2 === void 0 ? fluid ? 0 : 3 : tmp2, title = _a.title, description = _a.description, children = _a.children, props = $23b04808d9219184$var$$748e31f0f7788c85$var$__rest(_a, [
        "fluid",
        "className",
        "bg",
        "rounded",
        "title",
        "description",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("header", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(bg && "bg-".concat(bg), rounded && "rounded-".concat(rounded), className)
    }, props, {
        children: (0, $85f08a9b324875d4$exports.jsxs)($23b04808d9219184$export$42a852a2b6b56249, {
            fluid: fluid,
            children: [
                (0, $85f08a9b324875d4$exports.jsx)("h1", {
                    className: "display-4",
                    children: title
                }),
                (0, $85f08a9b324875d4$exports.jsx)("p", {
                    className: "lead",
                    children: description
                }),
                children && (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
                    children: [
                        (0, $85f08a9b324875d4$exports.jsx)("hr", {
                            className: "my-4"
                        }),
                        children
                    ]
                })
            ]
        })
    }));
};
var $23b04808d9219184$var$$478aa14554285d4f$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$478aa14554285d4f$exports, "Card", function() {
    return $23b04808d9219184$export$60332b2344f7fe41;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$478aa14554285d4f$exports, "CardBody", function() {
    return $23b04808d9219184$export$851de33184ecdac4;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$478aa14554285d4f$exports, "CardHeader", function() {
    return $23b04808d9219184$export$5665775b26e26c5d;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$478aa14554285d4f$exports, "CardFooter", function() {
    return $23b04808d9219184$export$e9897d434e0741ee;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$478aa14554285d4f$exports, "CardTitle", function() {
    return $23b04808d9219184$export$474db65c3c394e1c;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$478aa14554285d4f$exports, "CardImg", function() {
    return $23b04808d9219184$export$96c5f37208f78bd7;
});
var $23b04808d9219184$var$$6e5adc7420b5d0fd$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$6e5adc7420b5d0fd$exports, "Image", function() {
    return $23b04808d9219184$export$3e431a229df88919;
});
var $23b04808d9219184$var$$6e5adc7420b5d0fd$var$__rest = function $6e5adc7420b5d0fd$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$3e431a229df88919 = function(_a) {
    var className = _a.className, fluid = _a.fluid, rounded = _a.rounded, roundedCircle = _a.roundedCircle, thumbnail = _a.thumbnail, props = $23b04808d9219184$var$$6e5adc7420b5d0fd$var$__rest(_a, [
        "className",
        "fluid",
        "rounded",
        "roundedCircle",
        "thumbnail"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("img", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(fluid && "img-fluid", thumbnail && "img-thumbnail", {
            rounded: rounded
        }, roundedCircle && "rounded-circle", className)
    }, props));
};
var $23b04808d9219184$var$$478aa14554285d4f$var$__rest = function $478aa14554285d4f$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$60332b2344f7fe41 = function(_a) {
    var className = _a.className, bg = _a.bg, text = _a.text, border = _a.border, body = _a.body, children = _a.children, props = $23b04808d9219184$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "bg",
        "text",
        "border",
        "body",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("card", bg && "text-bg-".concat(bg), text && "text-".concat(text), border && "border-".concat(border), className)
    }, props, {
        children: body ? (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$851de33184ecdac4, {
            children: children
        }) : children
    }));
};
var $23b04808d9219184$export$5665775b26e26c5d = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "card-header ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$851de33184ecdac4 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "card-body ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$e9897d434e0741ee = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "card-footer ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$474db65c3c394e1c = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("h5", Object.assign({
        className: "card-title ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$96c5f37208f78bd7 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, variant = _a.variant, props = $23b04808d9219184$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "variant"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$3e431a229df88919, Object.assign({
        className: "card-img".concat(variant ? "-".concat(variant) : "", " ").concat(className)
    }, props));
};
var $23b04808d9219184$var$$165c2960ea0ef6da$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$165c2960ea0ef6da$exports, "MediaObject", function() {
    return $23b04808d9219184$export$c5be64db09f93414;
});
var $23b04808d9219184$var$$165c2960ea0ef6da$var$__rest = function $165c2960ea0ef6da$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$c5be64db09f93414 = function(_a) {
    var className = _a.className, listItem = _a.listItem, title = _a.title, image = _a.image, tmp = _a.imageRow, imageRow = tmp === void 0 ? "start" : tmp, tmp1 = _a.imageColumn, imageColumn = tmp1 === void 0 ? "start" : tmp1, children = _a.children, rest = $23b04808d9219184$var$$165c2960ea0ef6da$var$__rest(_a, [
        "className",
        "listItem",
        "title",
        "image",
        "imageRow",
        "imageColumn",
        "children"
    ]);
    var start = imageColumn === "start";
    var Tag = listItem ? "li" : "div", Class = (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("d-flex", !start && "flex-row-reverse", className);
    var body = (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
        children: [
            (0, $85f08a9b324875d4$exports.jsx)("div", {
                className: "flex-shrink-0",
                children: typeof image === "string" ? (0, $85f08a9b324875d4$exports.jsx)("img", {
                    className: "align-self-".concat(imageRow),
                    style: {
                        width: "4rem"
                    },
                    src: image,
                    alt: title
                }) : image
            }),
            (0, $85f08a9b324875d4$exports.jsxs)("div", {
                className: "flex-grow-1 ".concat(start ? "ms-3" : "me-3"),
                children: [
                    (0, $85f08a9b324875d4$exports.jsx)("h5", {
                        className: "mt-0",
                        children: title
                    }),
                    children
                ]
            })
        ]
    });
    return (0, $85f08a9b324875d4$exports.jsx)(Tag, Object.assign({}, rest, {
        className: Class,
        children: body
    }));
};
var $23b04808d9219184$var$$c630f4f8ebbb88df$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$c630f4f8ebbb88df$exports, "AccordionItem", function() {
    return $23b04808d9219184$export$d99097c13d4dac9f;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$c630f4f8ebbb88df$exports, "AccordionHeader", function() {
    return $23b04808d9219184$export$5e3e5deaaf81ee41;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$c630f4f8ebbb88df$exports, "AccordionBody", function() {
    return $23b04808d9219184$export$4f68206c92b94e7b;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$c630f4f8ebbb88df$exports, "Accordion", function() {
    return $23b04808d9219184$export$a766cd26d0d69044;
});
var $23b04808d9219184$var$$c630f4f8ebbb88df$var$__runInitializers = function $c630f4f8ebbb88df$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23b04808d9219184$var$$c630f4f8ebbb88df$var$__esDecorate = function $c630f4f8ebbb88df$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23b04808d9219184$var$$c630f4f8ebbb88df$var$__setFunctionName = function $c630f4f8ebbb88df$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23b04808d9219184$var$$c630f4f8ebbb88df$var$__classPrivateFieldGet = function $c630f4f8ebbb88df$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23b04808d9219184$var$$c630f4f8ebbb88df$var$__classPrivateFieldSet = function $c630f4f8ebbb88df$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $23b04808d9219184$var$$c630f4f8ebbb88df$var$__rest = function $c630f4f8ebbb88df$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$d99097c13d4dac9f = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$c630f4f8ebbb88df$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "accordion-item ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$5e3e5deaaf81ee41 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, onClick = _a.onClick, props = $23b04808d9219184$var$$c630f4f8ebbb88df$var$__rest(_a, [
        "className",
        "children",
        "onClick"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("h2", Object.assign({
        className: "accordion-header ".concat(className)
    }, props, {
        children: (0, $85f08a9b324875d4$exports.jsx)("button", {
            className: "accordion-button",
            type: "button",
            onClick: onClick,
            children: children
        })
    }));
};
var $23b04808d9219184$export$4f68206c92b94e7b = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$c630f4f8ebbb88df$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$78768a9af065a7b, Object.assign({
        className: "accordion-collapse ".concat(className)
    }, props, {
        children: (0, $85f08a9b324875d4$exports.jsx)("div", {
            className: "accordion-body",
            children: children
        })
    }));
};
var $23b04808d9219184$export$a766cd26d0d69044 = function() {
    var _Accordion_flush_accessor_storage, _Accordion_alwaysOpen_accessor_storage;
    var _classDecorators = [
        (0, $e67e4bd0d5ef9fd4$export$d8556a2a8f973135)({
            tagName: "accordion-box",
            mode: "open"
        }),
        (0, $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _instanceExtraInitializers = [];
    var _flush_decorators;
    var _flush_initializers = [];
    var _flush_extraInitializers = [];
    var _alwaysOpen_decorators;
    var _alwaysOpen_initializers = [];
    var _alwaysOpen_extraInitializers = [];
    var _handleFlush_decorators;
    var _handleClick_decorators;
    var Accordion = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            _Accordion_flush_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$c630f4f8ebbb88df$var$__runInitializers((0, $dOF8f._)(_this), _instanceExtraInitializers), $23b04808d9219184$var$$c630f4f8ebbb88df$var$__runInitializers((0, $dOF8f._)(_this), _flush_initializers, false)));
            _Accordion_alwaysOpen_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$c630f4f8ebbb88df$var$__runInitializers((0, $dOF8f._)(_this), _flush_extraInitializers), $23b04808d9219184$var$$c630f4f8ebbb88df$var$__runInitializers((0, $dOF8f._)(_this), _alwaysOpen_initializers, false)));
            $23b04808d9219184$var$$c630f4f8ebbb88df$var$__runInitializers((0, $dOF8f._)(_this), _alwaysOpen_extraInitializers);
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "flush",
                get: function get() {
                    return $23b04808d9219184$var$$c630f4f8ebbb88df$var$__classPrivateFieldGet(this, _Accordion_flush_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$c630f4f8ebbb88df$var$__classPrivateFieldSet(this, _Accordion_flush_accessor_storage, value, "f");
                }
            },
            {
                key: "alwaysOpen",
                get: function get() {
                    return $23b04808d9219184$var$$c630f4f8ebbb88df$var$__classPrivateFieldGet(this, _Accordion_alwaysOpen_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$c630f4f8ebbb88df$var$__classPrivateFieldSet(this, _Accordion_alwaysOpen_accessor_storage, value, "f");
                }
            },
            {
                key: "connectedCallback",
                value: function connectedCallback() {
                    this.classList.add("accordion");
                }
            },
            {
                key: "handleFlush",
                value: function handleFlush(flush) {
                    this.classList.toggle("accordion-flush", flush);
                }
            },
            {
                key: "handleClick",
                value: function handleClick(_, param) {
                    var currentCollapse = param.nextElementSibling;
                    if (!this.alwaysOpen) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.querySelectorAll(".accordion-collapse")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var collapse = _step.value;
                                if (collapse !== currentCollapse) {
                                    collapse.classList.remove("show");
                                    collapse.previousElementSibling.querySelector("button").ariaExpanded = "false";
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    currentCollapse.classList.toggle("show");
                    currentCollapse.previousElementSibling.querySelector("button").ariaExpanded = "false";
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $85f08a9b324875d4$exports.jsx)("slot", {});
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _Accordion_flush_accessor_storage = new WeakMap();
    _Accordion_alwaysOpen_accessor_storage = new WeakMap();
    $23b04808d9219184$var$$c630f4f8ebbb88df$var$__setFunctionName(_classThis, "Accordion");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _flush_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _alwaysOpen_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _handleFlush_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$7203b476385689ae)(function(param) {
                var flush = param.flush;
                return flush;
            })
        ];
        _handleClick_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af631764ddc44097)("click", ".accordion-header")
        ];
        $23b04808d9219184$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _flush_decorators, {
            kind: "accessor",
            name: "flush",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "flush" in obj;
                },
                get: function(obj) {
                    return obj.flush;
                },
                set: function(obj, value) {
                    obj.flush = value;
                }
            },
            metadata: _metadata
        }, _flush_initializers, _flush_extraInitializers);
        $23b04808d9219184$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _alwaysOpen_decorators, {
            kind: "accessor",
            name: "alwaysOpen",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "alwaysOpen" in obj;
                },
                get: function(obj) {
                    return obj.alwaysOpen;
                },
                set: function(obj, value) {
                    obj.alwaysOpen = value;
                }
            },
            metadata: _metadata
        }, _alwaysOpen_initializers, _alwaysOpen_extraInitializers);
        $23b04808d9219184$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _handleFlush_decorators, {
            kind: "method",
            name: "handleFlush",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "handleFlush" in obj;
                },
                get: function(obj) {
                    return obj.handleFlush;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _handleClick_decorators, {
            kind: "method",
            name: "handleClick",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "handleClick" in obj;
                },
                get: function(obj) {
                    return obj.handleClick;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$c630f4f8ebbb88df$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Accordion = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23b04808d9219184$var$$c630f4f8ebbb88df$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Accordion = _classThis;
}();
var $23b04808d9219184$var$$d3445d44d351b213$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$d3445d44d351b213$exports, "Tab", function() {
    return $23b04808d9219184$export$3e41faf802a29e71;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$d3445d44d351b213$exports, "Tabs", function() {
    return $23b04808d9219184$export$b2539bed5023c21c;
});
var $23b04808d9219184$var$$ac181fb217a2566a$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ac181fb217a2566a$exports, "NavLink", function() {
    return $23b04808d9219184$export$b0d92dbee9b5b60d;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ac181fb217a2566a$exports, "NavDropdown", function() {
    return $23b04808d9219184$export$461cb598b7fcff7b;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ac181fb217a2566a$exports, "Nav", function() {
    return $23b04808d9219184$export$39140c7d8b0ba7b3;
});
var $23b04808d9219184$var$$ecf67e051fd0aa49$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ecf67e051fd0aa49$exports, "Dropdown", function() {
    return $23b04808d9219184$export$931cbfb6bfb85fc;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ecf67e051fd0aa49$exports, "DropdownToggle", function() {
    return $23b04808d9219184$export$8d5b7ffbb681f107;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ecf67e051fd0aa49$exports, "DropdownMenu", function() {
    return $23b04808d9219184$export$e44a253a59704894;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ecf67e051fd0aa49$exports, "DropdownItem", function() {
    return $23b04808d9219184$export$6648d5fa18559e7f;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ecf67e051fd0aa49$exports, "DropdownButton", function() {
    return $23b04808d9219184$export$181f40ec41159e56;
});
var $23b04808d9219184$var$$ecf67e051fd0aa49$var$__esDecorate = function $ecf67e051fd0aa49$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers = function $ecf67e051fd0aa49$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23b04808d9219184$var$$ecf67e051fd0aa49$var$__setFunctionName = function $ecf67e051fd0aa49$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet = function $ecf67e051fd0aa49$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet = function $ecf67e051fd0aa49$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $23b04808d9219184$var$$ecf67e051fd0aa49$var$__rest = function $ecf67e051fd0aa49$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$931cbfb6bfb85fc = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "dropdown ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$8d5b7ffbb681f107 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$353f5b6fc5456de1, Object.assign({}, props, {
        className: "dropdown-toggle ".concat(className),
        type: "button",
        children: children
    }));
};
var $23b04808d9219184$export$e44a253a59704894 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("nav", Object.assign({
        className: "dropdown-menu ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$6648d5fa18559e7f = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("a", Object.assign({
        className: "dropdown-item ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$181f40ec41159e56 = function() {
    var _DropdownButton_boxClass_accessor_storage, _DropdownButton_buttonClass_accessor_storage, _DropdownButton_variant_accessor_storage, _DropdownButton_size_accessor_storage, _DropdownButton_caption_accessor_storage, _DropdownButton_disabled_accessor_storage, _DropdownButton_show_accessor_storage;
    var _classDecorators = [
        (0, $e67e4bd0d5ef9fd4$export$d8556a2a8f973135)({
            tagName: "dropdown-button",
            mode: "open"
        }),
        (0, $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _boxClass_decorators;
    var _boxClass_initializers = [];
    var _boxClass_extraInitializers = [];
    var _buttonClass_decorators;
    var _buttonClass_initializers = [];
    var _buttonClass_extraInitializers = [];
    var _variant_decorators;
    var _variant_initializers = [];
    var _variant_extraInitializers = [];
    var _size_decorators;
    var _size_initializers = [];
    var _size_extraInitializers = [];
    var _caption_decorators;
    var _caption_initializers = [];
    var _caption_extraInitializers = [];
    var _disabled_decorators;
    var _disabled_initializers = [];
    var _disabled_extraInitializers = [];
    var _show_decorators;
    var _show_initializers = [];
    var _show_extraInitializers = [];
    var DropdownButton = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            _DropdownButton_boxClass_accessor_storage.set((0, $dOF8f._)(_this), $23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _boxClass_initializers, void 0));
            _DropdownButton_buttonClass_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _boxClass_extraInitializers), $23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _buttonClass_initializers, void 0)));
            _DropdownButton_variant_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _buttonClass_extraInitializers), $23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _variant_initializers, void 0)));
            _DropdownButton_size_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _variant_extraInitializers), $23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _size_initializers, void 0)));
            _DropdownButton_caption_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _size_extraInitializers), $23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _caption_initializers, void 0)));
            _DropdownButton_disabled_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _caption_extraInitializers), $23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _disabled_initializers, false)));
            _DropdownButton_show_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _disabled_extraInitializers), $23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _show_initializers, false)));
            $23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers((0, $dOF8f._)(_this), _show_extraInitializers);
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "boxClass",
                get: function get() {
                    return $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_boxClass_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_boxClass_accessor_storage, value, "f");
                }
            },
            {
                key: "buttonClass",
                get: function get() {
                    return $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_buttonClass_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_buttonClass_accessor_storage, value, "f");
                }
            },
            {
                key: "variant",
                get: function get() {
                    return $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_variant_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_variant_accessor_storage, value, "f");
                }
            },
            {
                key: "size",
                get: function get() {
                    return $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_size_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_size_accessor_storage, value, "f");
                }
            },
            {
                key: "caption",
                get: function get() {
                    return $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_caption_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_caption_accessor_storage, value, "f");
                }
            },
            {
                key: "disabled",
                get: function get() {
                    return $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_disabled_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_disabled_accessor_storage, value, "f");
                }
            },
            {
                key: "show",
                get: function get() {
                    return $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_show_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_show_accessor_storage, value, "f");
                }
            },
            {
                key: "renderContent",
                value: function renderContent() {
                    var _this = this;
                    var _this1 = this, boxClass = _this1.boxClass, buttonClass = _this1.buttonClass, variant = _this1.variant, size = _this1.size, caption = _this1.caption, _this2 = this, disabled = _this2.disabled, show = _this2.show;
                    return (0, $85f08a9b324875d4$exports.jsxs)($23b04808d9219184$export$931cbfb6bfb85fc, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(boxClass, {
                            show: show
                        }),
                        children: [
                            (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$8d5b7ffbb681f107, {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(buttonClass, {
                                    show: show
                                }),
                                variant: variant,
                                size: size,
                                disabled: disabled,
                                onClick: function() {
                                    return _this.show = !show;
                                },
                                children: caption
                            }),
                            (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$e44a253a59704894, {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))({
                                    show: show
                                }),
                                children: (0, $85f08a9b324875d4$exports.jsx)("slot", {})
                            })
                        ]
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
                        children: [
                            (0, $85f08a9b324875d4$exports.jsx)("link", {
                                rel: "stylesheet",
                                href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                            }),
                            (0, $85f08a9b324875d4$exports.jsx)("style", {
                                children: ":host {\n                        display: inline-block;\n                    }"
                            }),
                            this.renderContent()
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _DropdownButton_boxClass_accessor_storage = new WeakMap();
    _DropdownButton_buttonClass_accessor_storage = new WeakMap();
    _DropdownButton_variant_accessor_storage = new WeakMap();
    _DropdownButton_size_accessor_storage = new WeakMap();
    _DropdownButton_caption_accessor_storage = new WeakMap();
    _DropdownButton_disabled_accessor_storage = new WeakMap();
    _DropdownButton_show_accessor_storage = new WeakMap();
    $23b04808d9219184$var$$ecf67e051fd0aa49$var$__setFunctionName(_classThis, "DropdownButton");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _boxClass_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _buttonClass_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _variant_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _size_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _caption_decorators = [
            (0, $b0lSM.observable)
        ];
        _disabled_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _show_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        $23b04808d9219184$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _boxClass_decorators, {
            kind: "accessor",
            name: "boxClass",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "boxClass" in obj;
                },
                get: function(obj) {
                    return obj.boxClass;
                },
                set: function(obj, value) {
                    obj.boxClass = value;
                }
            },
            metadata: _metadata
        }, _boxClass_initializers, _boxClass_extraInitializers);
        $23b04808d9219184$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _buttonClass_decorators, {
            kind: "accessor",
            name: "buttonClass",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "buttonClass" in obj;
                },
                get: function(obj) {
                    return obj.buttonClass;
                },
                set: function(obj, value) {
                    obj.buttonClass = value;
                }
            },
            metadata: _metadata
        }, _buttonClass_initializers, _buttonClass_extraInitializers);
        $23b04808d9219184$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _variant_decorators, {
            kind: "accessor",
            name: "variant",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "variant" in obj;
                },
                get: function(obj) {
                    return obj.variant;
                },
                set: function(obj, value) {
                    obj.variant = value;
                }
            },
            metadata: _metadata
        }, _variant_initializers, _variant_extraInitializers);
        $23b04808d9219184$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _size_decorators, {
            kind: "accessor",
            name: "size",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "size" in obj;
                },
                get: function(obj) {
                    return obj.size;
                },
                set: function(obj, value) {
                    obj.size = value;
                }
            },
            metadata: _metadata
        }, _size_initializers, _size_extraInitializers);
        $23b04808d9219184$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _caption_decorators, {
            kind: "accessor",
            name: "caption",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "caption" in obj;
                },
                get: function(obj) {
                    return obj.caption;
                },
                set: function(obj, value) {
                    obj.caption = value;
                }
            },
            metadata: _metadata
        }, _caption_initializers, _caption_extraInitializers);
        $23b04808d9219184$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _disabled_decorators, {
            kind: "accessor",
            name: "disabled",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "disabled" in obj;
                },
                get: function(obj) {
                    return obj.disabled;
                },
                set: function(obj, value) {
                    obj.disabled = value;
                }
            },
            metadata: _metadata
        }, _disabled_initializers, _disabled_extraInitializers);
        $23b04808d9219184$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _show_decorators, {
            kind: "accessor",
            name: "show",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "show" in obj;
                },
                get: function(obj) {
                    return obj.show;
                },
                set: function(obj, value) {
                    obj.show = value;
                }
            },
            metadata: _metadata
        }, _show_initializers, _show_extraInitializers);
        $23b04808d9219184$var$$ecf67e051fd0aa49$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        DropdownButton = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23b04808d9219184$var$$ecf67e051fd0aa49$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return DropdownButton = _classThis;
}();
var $23b04808d9219184$var$$ac181fb217a2566a$var$__esDecorate = function $ac181fb217a2566a$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23b04808d9219184$var$$ac181fb217a2566a$var$__runInitializers = function $ac181fb217a2566a$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23b04808d9219184$var$$ac181fb217a2566a$var$__setFunctionName = function $ac181fb217a2566a$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23b04808d9219184$var$$ac181fb217a2566a$var$__rest = function $ac181fb217a2566a$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$b0d92dbee9b5b60d = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, active = _a.active, children = _a.children, props = $23b04808d9219184$var$$ac181fb217a2566a$var$__rest(_a, [
        "className",
        "active",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("a", Object.assign({
        className: "nav-link ".concat(active ? "active" : "", " ").concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$461cb598b7fcff7b = function(_a) {
    var title = _a.title, children = _a.children, props = $23b04808d9219184$var$$ac181fb217a2566a$var$__rest(_a, [
        "title",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$181f40ec41159e56, Object.assign({
        boxClass: "nav-item",
        buttonClass: "nav-link",
        caption: title
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$39140c7d8b0ba7b3 = function() {
    var _classDecorators = [
        (0, $e67e4bd0d5ef9fd4$export$d8556a2a8f973135)({
            tagName: "bs-nav",
            mode: "open"
        })
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var Nav = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            return _super.apply(this, arguments);
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "connectedCallback",
                value: function connectedCallback() {
                    var _a;
                    var navBar = this.closest("offcanvas-navbar, .navbar");
                    if (!navBar) return this.classList.add("nav");
                    var expand = navBar.expand || ((_a = navBar.className.match(/navbar-expand(-(\S+))?/)) === null || _a === void 0 ? void 0 : _a[2]);
                    this.classList.add("navbar-nav", "align-items-center", expand && "flex-column", expand && "flex-".concat(expand, "-row"));
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $85f08a9b324875d4$exports.jsx)("slot", {});
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $23b04808d9219184$var$$ac181fb217a2566a$var$__setFunctionName(_classThis, "Nav");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $23b04808d9219184$var$$ac181fb217a2566a$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Nav = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23b04808d9219184$var$$ac181fb217a2566a$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Nav = _classThis;
}();
var $23b04808d9219184$var$$d3445d44d351b213$var$__esDecorate = function $d3445d44d351b213$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23b04808d9219184$var$$d3445d44d351b213$var$__runInitializers = function $d3445d44d351b213$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23b04808d9219184$var$$d3445d44d351b213$var$__setFunctionName = function $d3445d44d351b213$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23b04808d9219184$var$$d3445d44d351b213$var$__classPrivateFieldGet = function $d3445d44d351b213$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23b04808d9219184$var$$d3445d44d351b213$var$__classPrivateFieldSet = function $d3445d44d351b213$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $23b04808d9219184$export$3e41faf802a29e71 = function() {
    var _classDecorators = [
        (0, $e67e4bd0d5ef9fd4$export$d8556a2a8f973135)({
            tagName: "tab-pane"
        })
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var Tab = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            Object.defineProperty((0, $dOF8f._)(_this), "caption", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "connectedCallback",
                value: function connectedCallback() {
                    this.classList.add("tab-pane");
                    this.role = "tabpanel";
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $23b04808d9219184$var$$d3445d44d351b213$var$__setFunctionName(_classThis, "Tab");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $23b04808d9219184$var$$d3445d44d351b213$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Tab = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23b04808d9219184$var$$d3445d44d351b213$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Tab = _classThis;
}();
var $23b04808d9219184$export$b2539bed5023c21c = function() {
    var _Tabs_tabMeta_accessor_storage, _Tabs_currentIndex_accessor_storage;
    var _classDecorators = [
        (0, $e67e4bd0d5ef9fd4$export$d8556a2a8f973135)({
            tagName: "tabs-box",
            mode: "open"
        }),
        (0, $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _instanceExtraInitializers = [];
    var _tabMeta_decorators;
    var _tabMeta_initializers = [];
    var _tabMeta_extraInitializers = [];
    var _currentIndex_decorators;
    var _currentIndex_initializers = [];
    var _currentIndex_extraInitializers = [];
    var _handleTabClick_decorators;
    var _turnPaneTo_decorators;
    var Tabs = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            _Tabs_tabMeta_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$d3445d44d351b213$var$__runInitializers((0, $dOF8f._)(_this), _instanceExtraInitializers), $23b04808d9219184$var$$d3445d44d351b213$var$__runInitializers((0, $dOF8f._)(_this), _tabMeta_initializers, [])));
            _Tabs_currentIndex_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$d3445d44d351b213$var$__runInitializers((0, $dOF8f._)(_this), _tabMeta_extraInitializers), $23b04808d9219184$var$$d3445d44d351b213$var$__runInitializers((0, $dOF8f._)(_this), _currentIndex_initializers, 0)));
            $23b04808d9219184$var$$d3445d44d351b213$var$__runInitializers((0, $dOF8f._)(_this), _currentIndex_extraInitializers);
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "tabMeta",
                get: function get() {
                    return $23b04808d9219184$var$$d3445d44d351b213$var$__classPrivateFieldGet(this, _Tabs_tabMeta_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$d3445d44d351b213$var$__classPrivateFieldSet(this, _Tabs_tabMeta_accessor_storage, value, "f");
                }
            },
            {
                key: "currentIndex",
                get: function get() {
                    return $23b04808d9219184$var$$d3445d44d351b213$var$__classPrivateFieldGet(this, _Tabs_currentIndex_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$d3445d44d351b213$var$__classPrivateFieldSet(this, _Tabs_currentIndex_accessor_storage, value, "f");
                }
            },
            {
                key: "mountedCallback",
                value: function mountedCallback() {
                    var tabs = (0, $kVAOt._)(this.querySelectorAll("tab-pane"));
                    this.tabMeta = tabs.map(function(tab) {
                        tab.hidden = true;
                        return {
                            caption: tab.caption
                        };
                    });
                    this.turnPaneTo(this.currentIndex);
                }
            },
            {
                key: "handleTabClick",
                value: function handleTabClick(event, param) {
                    var _param_dataset = param.dataset, index = _param_dataset.index;
                    event.preventDefault();
                    event.stopPropagation();
                    this.currentIndex = +index;
                }
            },
            {
                key: "turnPaneTo",
                value: function turnPaneTo(index) {
                    var previous = this.querySelector("tab-pane.active");
                    if (previous) {
                        previous.hidden = true;
                        previous.classList.remove("active", "show");
                    }
                    var next = this.children[index];
                    next.hidden = false;
                    next.classList.add("active", "show");
                }
            },
            {
                key: "renderContent",
                value: function renderContent() {
                    var _this = this, tabMeta = _this.tabMeta, currentIndex = _this.currentIndex;
                    return (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
                        children: [
                            (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$39140c7d8b0ba7b3, {
                                className: "nav-tabs",
                                role: "tablist",
                                children: tabMeta.map(function(param, index) {
                                    var caption = param.caption;
                                    return (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$b0d92dbee9b5b60d, {
                                        role: "tab",
                                        "data-index": index,
                                        className: currentIndex === index ? "active" : "",
                                        ariaSelected: "".concat(currentIndex === index),
                                        children: caption
                                    });
                                })
                            }),
                            (0, $85f08a9b324875d4$exports.jsx)("div", {
                                className: "tab-content",
                                children: (0, $85f08a9b324875d4$exports.jsx)("slot", {})
                            })
                        ]
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
                        children: [
                            (0, $85f08a9b324875d4$exports.jsx)("link", {
                                rel: "stylesheet",
                                href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                            }),
                            this.renderContent()
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _Tabs_tabMeta_accessor_storage = new WeakMap();
    _Tabs_currentIndex_accessor_storage = new WeakMap();
    $23b04808d9219184$var$$d3445d44d351b213$var$__setFunctionName(_classThis, "Tabs");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _tabMeta_decorators = [
            (0, $b0lSM.observable)
        ];
        _currentIndex_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _handleTabClick_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af631764ddc44097)("click", ".nav-tabs > .nav-link")
        ];
        _turnPaneTo_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$7203b476385689ae)(function(param) {
                var currentIndex = param.currentIndex;
                return currentIndex;
            })
        ];
        $23b04808d9219184$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _tabMeta_decorators, {
            kind: "accessor",
            name: "tabMeta",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "tabMeta" in obj;
                },
                get: function(obj) {
                    return obj.tabMeta;
                },
                set: function(obj, value) {
                    obj.tabMeta = value;
                }
            },
            metadata: _metadata
        }, _tabMeta_initializers, _tabMeta_extraInitializers);
        $23b04808d9219184$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _currentIndex_decorators, {
            kind: "accessor",
            name: "currentIndex",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentIndex" in obj;
                },
                get: function(obj) {
                    return obj.currentIndex;
                },
                set: function(obj, value) {
                    obj.currentIndex = value;
                }
            },
            metadata: _metadata
        }, _currentIndex_initializers, _currentIndex_extraInitializers);
        $23b04808d9219184$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _handleTabClick_decorators, {
            kind: "method",
            name: "handleTabClick",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "handleTabClick" in obj;
                },
                get: function(obj) {
                    return obj.handleTabClick;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _turnPaneTo_decorators, {
            kind: "method",
            name: "turnPaneTo",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "turnPaneTo" in obj;
                },
                get: function(obj) {
                    return obj.turnPaneTo;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$d3445d44d351b213$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Tabs = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23b04808d9219184$var$$d3445d44d351b213$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Tabs = _classThis;
}();
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a9c2f09022d17944$exports, $23b04808d9219184$var$$fae440e6475ac9b3$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a9c2f09022d17944$exports, $23b04808d9219184$var$$748e31f0f7788c85$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a9c2f09022d17944$exports, $23b04808d9219184$var$$478aa14554285d4f$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a9c2f09022d17944$exports, $23b04808d9219184$var$$165c2960ea0ef6da$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a9c2f09022d17944$exports, $23b04808d9219184$var$$c630f4f8ebbb88df$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a9c2f09022d17944$exports, $23b04808d9219184$var$$d3445d44d351b213$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$a9c2f09022d17944$exports, $23b04808d9219184$var$$f7c1ec19aba15bac$exports);
var $23b04808d9219184$var$$76979d798b5a3bd5$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$76979d798b5a3bd5$exports, "FormGroup", function() {
    return $23b04808d9219184$export$2d00230e1e6f7fbc;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$76979d798b5a3bd5$exports, "FormLabel", function() {
    return $23b04808d9219184$export$842aba50ed0ce9d7;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$76979d798b5a3bd5$exports, "FloatingLabel", function() {
    return $23b04808d9219184$export$8522a2827ec13639;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$76979d798b5a3bd5$exports, "InputGroup", function() {
    return $23b04808d9219184$export$6e5a9cd40e0c9b97;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$76979d798b5a3bd5$exports, "InputGroupText", function() {
    return $23b04808d9219184$export$219ad5c362b47f2f;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$76979d798b5a3bd5$exports, "FormControl", function() {
    return $23b04808d9219184$export$fe5d99d8691b3f62;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$76979d798b5a3bd5$exports, "FormCheck", function() {
    return $23b04808d9219184$export$5cd9378d879de45f;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$76979d798b5a3bd5$exports, "FormField", function() {
    return $23b04808d9219184$export$56e87bf42978147a;
});
var $23b04808d9219184$var$$76979d798b5a3bd5$var$__rest = function $76979d798b5a3bd5$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$2d00230e1e6f7fbc = function(_a) {
    var children = _a.children, props = $23b04808d9219184$var$$76979d798b5a3bd5$var$__rest(_a, [
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({}, props, {
        children: children
    }));
};
var $23b04808d9219184$export$842aba50ed0ce9d7 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("label", Object.assign({
        className: "form-label ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$8522a2827ec13639 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, style = _a.style, label = _a.label, children = _a.children, props = $23b04808d9219184$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "style",
        "label",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsxs)("div", {
        className: "form-floating ".concat(className),
        style: style,
        children: [
            children,
            (0, $85f08a9b324875d4$exports.jsx)("label", Object.assign({}, props, {
                children: label
            }))
        ]
    });
};
var $23b04808d9219184$export$6e5a9cd40e0c9b97 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, size = _a.size, children = _a.children, props = $23b04808d9219184$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "size",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("input-group", size && "input-group-".concat(size), className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$219ad5c362b47f2f = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("span", Object.assign({
        className: "input-group-text ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$fe5d99d8691b3f62 = function(_a) {
    var tmp = _a.as, Tag = tmp === void 0 ? "input" : tmp, tmp1 = _a.className, className = tmp1 === void 0 ? "" : tmp1, htmlSize = _a.htmlSize, size = _a.size, plaintext = _a.plaintext, props = $23b04808d9219184$var$$76979d798b5a3bd5$var$__rest(_a, [
        "as",
        "className",
        "htmlSize",
        "size",
        "plaintext"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)(Tag, Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("form-control", size && "form-control-".concat(size), props.readOnly && plaintext && "form-control-plaintext", props.type === "color" && "form-control-color", className)
    }, props, {
        size: htmlSize
    }));
};
var $23b04808d9219184$export$5cd9378d879de45f = function(_a) {
    var tmp = _a.id, id = tmp === void 0 ? (0, $e5wYp.uniqueID)() : tmp, tmp1 = _a.className, className = tmp1 === void 0 ? "" : tmp1, style = _a.style, title = _a.title, type = _a.type, inline = _a.inline, reverse = _a.reverse, label = _a.label, props = $23b04808d9219184$var$$76979d798b5a3bd5$var$__rest(_a, [
        "id",
        "className",
        "style",
        "title",
        "type",
        "inline",
        "reverse",
        "label"
    ]);
    return (0, $85f08a9b324875d4$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(label && "form-check", inline && "form-check-inline", reverse && "form-check-reverse", type === "switch" && "form-switch", className),
        style: style,
        children: [
            (0, $85f08a9b324875d4$exports.jsx)("input", Object.assign({
                className: "form-check-input",
                type: type === "switch" ? "checkbox" : type,
                role: type === "switch" ? "switch" : undefined,
                id: id
            }, props)),
            label && (0, $85f08a9b324875d4$exports.jsx)("label", {
                className: "form-check-label",
                htmlFor: id,
                title: title,
                children: label
            })
        ]
    });
};
var $23b04808d9219184$export$56e87bf42978147a = function(_a) {
    var className = _a.className, label = _a.label, labelFloat = _a.labelFloat, props = $23b04808d9219184$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "label",
        "labelFloat"
    ]);
    label || (label = props.title || props.placeholder);
    var field = (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$fe5d99d8691b3f62, Object.assign({}, props));
    return labelFloat ? (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$8522a2827ec13639, {
        className: className,
        label: label,
        children: field
    }) : (0, $85f08a9b324875d4$exports.jsxs)($23b04808d9219184$export$2d00230e1e6f7fbc, {
        className: className,
        children: [
            (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$842aba50ed0ce9d7, {
                children: label
            }),
            field
        ]
    });
};
var $23b04808d9219184$var$$d6a5aaf30399725f$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$d6a5aaf30399725f$exports, "ButtonGroup", function() {
    return $23b04808d9219184$export$69b1032f2ecdf404;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$d6a5aaf30399725f$exports, "ButtonToolbar", function() {
    return $23b04808d9219184$export$478f41ba79e7b570;
});
var $23b04808d9219184$var$$d6a5aaf30399725f$var$__rest = function $d6a5aaf30399725f$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$69b1032f2ecdf404 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, vertical = _a.vertical, size = _a.size, children = _a.children, props = $23b04808d9219184$var$$d6a5aaf30399725f$var$__rest(_a, [
        "className",
        "vertical",
        "size",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("btn-group".concat(vertical ? "-vertical" : ""), size && "btn-group-".concat(size), className),
        role: "group"
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$478f41ba79e7b570 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$d6a5aaf30399725f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "btn-toolbar ".concat(className),
        role: "toolbar"
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$var$$3f0c6c9020e942c5$exports = {};
var $23b04808d9219184$var$$be58a6a40ab07fd2$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$be58a6a40ab07fd2$exports, "CarouselItem", function() {
    return $23b04808d9219184$export$42c20acb2971398c;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$be58a6a40ab07fd2$exports, "CarouselCaption", function() {
    return $23b04808d9219184$export$a81c9b47f1cf1e63;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$be58a6a40ab07fd2$exports, "Carousel", function() {
    return $23b04808d9219184$export$144901db2ea8e967;
});
var $23b04808d9219184$var$$be58a6a40ab07fd2$var$__runInitializers = function $be58a6a40ab07fd2$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23b04808d9219184$var$$be58a6a40ab07fd2$var$__esDecorate = function $be58a6a40ab07fd2$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23b04808d9219184$var$$be58a6a40ab07fd2$var$__setFunctionName = function $be58a6a40ab07fd2$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23b04808d9219184$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet = function $be58a6a40ab07fd2$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23b04808d9219184$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet = function $be58a6a40ab07fd2$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $23b04808d9219184$var$$be58a6a40ab07fd2$var$__rest = function $be58a6a40ab07fd2$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$42c20acb2971398c = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, interval = _a.interval, children = _a.children, props = $23b04808d9219184$var$$be58a6a40ab07fd2$var$__rest(_a, [
        "className",
        "interval",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "carousel-item ".concat(className)
    }, props, {
        "data-bs-interval": interval,
        children: children
    }));
};
var $23b04808d9219184$export$a81c9b47f1cf1e63 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$be58a6a40ab07fd2$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "carousel-caption ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$144901db2ea8e967 = function() {
    var _Carousel_interval_accessor_storage, _Carousel_itemMeta_accessor_storage, _Carousel_currentIndex_accessor_storage;
    var _classDecorators = [
        (0, $e67e4bd0d5ef9fd4$export$d8556a2a8f973135)({
            tagName: "carousel-box",
            mode: "open"
        }),
        (0, $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _instanceExtraInitializers = [];
    var _interval_decorators;
    var _interval_initializers = [];
    var _interval_extraInitializers = [];
    var _itemMeta_decorators;
    var _itemMeta_initializers = [];
    var _itemMeta_extraInitializers = [];
    var _currentIndex_decorators;
    var _currentIndex_initializers = [];
    var _currentIndex_extraInitializers = [];
    var _handleButtonClick_decorators;
    var _handleButtonPress_decorators;
    var _handleIndicatorsButtonClick_decorators;
    var _handleIndicatorsButtonPress_decorators;
    var _handleActiveItem_decorators;
    var Carousel = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            _Carousel_interval_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$be58a6a40ab07fd2$var$__runInitializers((0, $dOF8f._)(_this), _instanceExtraInitializers), $23b04808d9219184$var$$be58a6a40ab07fd2$var$__runInitializers((0, $dOF8f._)(_this), _interval_initializers, void 0)));
            _Carousel_itemMeta_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$be58a6a40ab07fd2$var$__runInitializers((0, $dOF8f._)(_this), _interval_extraInitializers), $23b04808d9219184$var$$be58a6a40ab07fd2$var$__runInitializers((0, $dOF8f._)(_this), _itemMeta_initializers, [])));
            _Carousel_currentIndex_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$be58a6a40ab07fd2$var$__runInitializers((0, $dOF8f._)(_this), _itemMeta_extraInitializers), $23b04808d9219184$var$$be58a6a40ab07fd2$var$__runInitializers((0, $dOF8f._)(_this), _currentIndex_initializers, 0)));
            Object.defineProperty((0, $dOF8f._)(_this), "timer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $23b04808d9219184$var$$be58a6a40ab07fd2$var$__runInitializers((0, $dOF8f._)(_this), _currentIndex_extraInitializers)
            });
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "interval",
                get: function get() {
                    return $23b04808d9219184$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet(this, _Carousel_interval_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet(this, _Carousel_interval_accessor_storage, value, "f");
                }
            },
            {
                key: "itemMeta",
                get: function get() {
                    return $23b04808d9219184$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet(this, _Carousel_itemMeta_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet(this, _Carousel_itemMeta_accessor_storage, value, "f");
                }
            },
            {
                key: "currentIndex",
                get: function get() {
                    return $23b04808d9219184$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet(this, _Carousel_currentIndex_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet(this, _Carousel_currentIndex_accessor_storage, value, "f");
                }
            },
            {
                key: "connectedCallback",
                value: function connectedCallback() {
                    var _this = this;
                    if (this.interval) this.timer || (this.timer = window.setInterval(function() {
                        return _this.turnByOffset(1);
                    }, this.interval));
                    else this.handleActiveItem(this.currentIndex);
                }
            },
            {
                key: "disconnectedCallback",
                value: function disconnectedCallback() {
                    clearInterval(this.timer);
                }
            },
            {
                key: "mountedCallback",
                value: function mountedCallback() {
                    var items = (0, $kVAOt._)(this.querySelectorAll(".carousel-item"));
                    if (this.itemMeta.length !== items.length) this.itemMeta = items.map(function(item) {
                        var _a;
                        return {
                            caption: (((_a = item.querySelector(".carousel-caption")) === null || _a === void 0 ? void 0 : _a.textContent) || item.textContent).trim()
                        };
                    });
                }
            },
            {
                key: "turnByOffset",
                value: function turnByOffset(delta) {
                    this.currentIndex = (this.currentIndex + delta) % this.itemMeta.length;
                }
            },
            {
                key: "handleButtonClick",
                value: function handleButtonClick(_, param) {
                    var dataset = param.dataset;
                    this.turnByOffset(dataset.bsSlide === "next" ? 1 : -1);
                }
            },
            {
                key: "handleButtonPress",
                value: function handleButtonPress(param, param1) {
                    var key = param.key, dataset = param1.dataset;
                    if (key === "Enter") this.turnByOffset(dataset.bsSlide === "next" ? 1 : -1);
                }
            },
            {
                key: "handleIndicatorsButtonClick",
                value: function handleIndicatorsButtonClick(_, param) {
                    var dataset = param.dataset;
                    this.currentIndex = +dataset.bsSlideTo;
                }
            },
            {
                key: "handleIndicatorsButtonPress",
                value: function handleIndicatorsButtonPress(param, param1) {
                    var key = param.key, dataset = param1.dataset;
                    if (key === "Enter") this.currentIndex = +dataset.bsSlideTo;
                }
            },
            {
                key: "handleActiveItem",
                value: function handleActiveItem(currentIndex) {
                    var _a;
                    (_a = this.querySelector(".carousel-item.active")) === null || _a === void 0 || _a.classList.remove("active");
                    this.children[currentIndex].classList.add("active");
                }
            },
            {
                key: "renderContent",
                value: function renderContent() {
                    var _this = this, itemMeta = _this.itemMeta, currentIndex = _this.currentIndex;
                    return (0, $85f08a9b324875d4$exports.jsxs)("div", {
                        className: "carousel",
                        children: [
                            (0, $85f08a9b324875d4$exports.jsx)("div", {
                                className: "carousel-indicators",
                                children: itemMeta.map(function(param, index) {
                                    var caption = param.caption;
                                    return (0, $85f08a9b324875d4$exports.jsx)("button", {
                                        type: "button",
                                        ariaLabel: caption,
                                        "data-bs-slide-to": index,
                                        className: currentIndex === index ? "active" : "",
                                        ariaCurrent: currentIndex === index ? "true" : ""
                                    });
                                })
                            }),
                            (0, $85f08a9b324875d4$exports.jsx)("div", {
                                className: "carousel-inner",
                                children: (0, $85f08a9b324875d4$exports.jsx)("slot", {})
                            }),
                            (0, $85f08a9b324875d4$exports.jsxs)("button", {
                                type: "button",
                                className: "carousel-control-prev",
                                "data-bs-slide": "prev",
                                children: [
                                    (0, $85f08a9b324875d4$exports.jsx)("span", {
                                        className: "carousel-control-prev-icon",
                                        ariaHidden: "true"
                                    }),
                                    (0, $85f08a9b324875d4$exports.jsx)("span", {
                                        className: "visually-hidden",
                                        children: "-1"
                                    })
                                ]
                            }),
                            (0, $85f08a9b324875d4$exports.jsxs)("button", {
                                type: "button",
                                className: "carousel-control-next",
                                "data-bs-slide": "next",
                                children: [
                                    (0, $85f08a9b324875d4$exports.jsx)("span", {
                                        className: "carousel-control-next-icon",
                                        ariaHidden: "true"
                                    }),
                                    (0, $85f08a9b324875d4$exports.jsx)("span", {
                                        className: "visually-hidden",
                                        children: "+1"
                                    })
                                ]
                            })
                        ]
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
                        children: [
                            (0, $85f08a9b324875d4$exports.jsx)("link", {
                                rel: "stylesheet",
                                href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                            }),
                            this.renderContent()
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _Carousel_interval_accessor_storage = new WeakMap();
    _Carousel_itemMeta_accessor_storage = new WeakMap();
    _Carousel_currentIndex_accessor_storage = new WeakMap();
    $23b04808d9219184$var$$be58a6a40ab07fd2$var$__setFunctionName(_classThis, "Carousel");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _interval_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _itemMeta_decorators = [
            (0, $b0lSM.observable)
        ];
        _currentIndex_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _handleButtonClick_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af631764ddc44097)("click", ".carousel > button")
        ];
        _handleButtonPress_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af631764ddc44097)("keyup", ".carousel > button")
        ];
        _handleIndicatorsButtonClick_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af631764ddc44097)("click", ".carousel-indicators button")
        ];
        _handleIndicatorsButtonPress_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af631764ddc44097)("keyup", ".carousel-indicators button")
        ];
        _handleActiveItem_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$7203b476385689ae)(function(param) {
                var currentIndex = param.currentIndex;
                return currentIndex;
            })
        ];
        $23b04808d9219184$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _interval_decorators, {
            kind: "accessor",
            name: "interval",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "interval" in obj;
                },
                get: function(obj) {
                    return obj.interval;
                },
                set: function(obj, value) {
                    obj.interval = value;
                }
            },
            metadata: _metadata
        }, _interval_initializers, _interval_extraInitializers);
        $23b04808d9219184$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _itemMeta_decorators, {
            kind: "accessor",
            name: "itemMeta",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "itemMeta" in obj;
                },
                get: function(obj) {
                    return obj.itemMeta;
                },
                set: function(obj, value) {
                    obj.itemMeta = value;
                }
            },
            metadata: _metadata
        }, _itemMeta_initializers, _itemMeta_extraInitializers);
        $23b04808d9219184$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _currentIndex_decorators, {
            kind: "accessor",
            name: "currentIndex",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentIndex" in obj;
                },
                get: function(obj) {
                    return obj.currentIndex;
                },
                set: function(obj, value) {
                    obj.currentIndex = value;
                }
            },
            metadata: _metadata
        }, _currentIndex_initializers, _currentIndex_extraInitializers);
        $23b04808d9219184$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleButtonClick_decorators, {
            kind: "method",
            name: "handleButtonClick",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "handleButtonClick" in obj;
                },
                get: function(obj) {
                    return obj.handleButtonClick;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleButtonPress_decorators, {
            kind: "method",
            name: "handleButtonPress",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "handleButtonPress" in obj;
                },
                get: function(obj) {
                    return obj.handleButtonPress;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleIndicatorsButtonClick_decorators, {
            kind: "method",
            name: "handleIndicatorsButtonClick",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "handleIndicatorsButtonClick" in obj;
                },
                get: function(obj) {
                    return obj.handleIndicatorsButtonClick;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleIndicatorsButtonPress_decorators, {
            kind: "method",
            name: "handleIndicatorsButtonPress",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "handleIndicatorsButtonPress" in obj;
                },
                get: function(obj) {
                    return obj.handleIndicatorsButtonPress;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleActiveItem_decorators, {
            kind: "method",
            name: "handleActiveItem",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "handleActiveItem" in obj;
                },
                get: function(obj) {
                    return obj.handleActiveItem;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$be58a6a40ab07fd2$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Carousel = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23b04808d9219184$var$$be58a6a40ab07fd2$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Carousel = _classThis;
}();
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$3f0c6c9020e942c5$exports, $23b04808d9219184$var$$6e5adc7420b5d0fd$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$3f0c6c9020e942c5$exports, $23b04808d9219184$var$$be58a6a40ab07fd2$exports);
var $23b04808d9219184$var$$07e74c2207adaaa3$exports = {};
var $23b04808d9219184$var$$d3540d749a8620d4$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$d3540d749a8620d4$exports, "Spinner", function() {
    return $23b04808d9219184$export$7f7cbe89f1eacd2;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$d3540d749a8620d4$exports, "SpinnerBox", function() {
    return $23b04808d9219184$export$d4c790f923031725;
});
var $23b04808d9219184$var$$d3540d749a8620d4$var$__rest = function $d3540d749a8620d4$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$7f7cbe89f1eacd2 = function(_a) {
    var className = _a.className, variant = _a.variant, size = _a.size, tmp = _a.animation, animation = tmp === void 0 ? "border" : tmp, tmp1 = _a.children, children = tmp1 === void 0 ? "Loading..." : tmp1, props = $23b04808d9219184$var$$d3540d749a8620d4$var$__rest(_a, [
        "className",
        "variant",
        "size",
        "animation",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("spinner-".concat(animation), size && "spinner-".concat(animation, "-").concat(size), variant && "text-".concat(variant), className),
        role: "status"
    }, props, {
        children: (0, $85f08a9b324875d4$exports.jsx)("span", {
            className: "visually-hidden",
            children: children
        })
    }));
};
var $23b04808d9219184$export$d4c790f923031725 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, cover = _a.cover, variant = _a.variant, size = _a.size, animation = _a.animation, role = _a.role, children = _a.children, props = $23b04808d9219184$var$$d3540d749a8620d4$var$__rest(_a, [
        "className",
        "cover",
        "variant",
        "size",
        "animation",
        "role",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsxs)("div", Object.assign({
        className: "position-relative ".concat(className)
    }, props, {
        children: [
            children,
            cover && (0, $85f08a9b324875d4$exports.jsx)("div", {
                className: "modal-backdrop show d-flex justify-content-center align-items-center",
                children: (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$7f7cbe89f1eacd2, {
                    variant: variant,
                    size: size,
                    animation: animation,
                    role: role,
                    ariaHidden: "true"
                })
            })
        ]
    }));
};
var $23b04808d9219184$var$$a6f317a49298db85$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$a6f317a49298db85$exports, "Tooltip", function() {
    return $23b04808d9219184$export$28c660c63b792dea;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$a6f317a49298db85$exports, "TooltipBox", function() {
    return $23b04808d9219184$export$e4d8dc88bb9cc931;
});
var $23b04808d9219184$var$$a6f317a49298db85$var$__esDecorate = function $a6f317a49298db85$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23b04808d9219184$var$$a6f317a49298db85$var$__runInitializers = function $a6f317a49298db85$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23b04808d9219184$var$$a6f317a49298db85$var$__setFunctionName = function $a6f317a49298db85$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23b04808d9219184$var$$a6f317a49298db85$var$__classPrivateFieldGet = function $a6f317a49298db85$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23b04808d9219184$var$$a6f317a49298db85$var$__classPrivateFieldSet = function $a6f317a49298db85$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $23b04808d9219184$var$$a6f317a49298db85$var$__rest = function $a6f317a49298db85$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$28c660c63b792dea = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$a6f317a49298db85$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsxs)("div", Object.assign({
        className: "tooltip bs-tooltip show position-absolute ".concat(className),
        role: "tooltip"
    }, props, {
        children: [
            (0, $85f08a9b324875d4$exports.jsx)("div", {
                className: "tooltip-arrow"
            }),
            (0, $85f08a9b324875d4$exports.jsx)("div", {
                className: "tooltip-inner",
                children: children
            })
        ]
    }));
};
var $23b04808d9219184$export$e4d8dc88bb9cc931 = function() {
    var _TooltipBox_show_accessor_storage;
    var _classDecorators = [
        (0, $e67e4bd0d5ef9fd4$export$d8556a2a8f973135)({
            tagName: "tooltip-box",
            mode: "open"
        }),
        (0, $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _show_decorators;
    var _show_initializers = [];
    var _show_extraInitializers = [];
    var TooltipBox = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            Object.defineProperty((0, $dOF8f._)(_this), "content", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _TooltipBox_show_accessor_storage.set((0, $dOF8f._)(_this), $23b04808d9219184$var$$a6f317a49298db85$var$__runInitializers((0, $dOF8f._)(_this), _show_initializers, false));
            Object.defineProperty((0, $dOF8f._)(_this), "handleToggle", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($23b04808d9219184$var$$a6f317a49298db85$var$__runInitializers((0, $dOF8f._)(_this), _show_extraInitializers), function() {
                    return _this.show = !_this.show;
                })
            });
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "show",
                get: function get() {
                    return $23b04808d9219184$var$$a6f317a49298db85$var$__classPrivateFieldGet(this, _TooltipBox_show_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$a6f317a49298db85$var$__classPrivateFieldSet(this, _TooltipBox_show_accessor_storage, value, "f");
                }
            },
            {
                key: "connectedCallback",
                value: function connectedCallback() {
                    this.style.display = "inline-block";
                    this.addEventListener("mouseenter", this.handleToggle);
                    this.addEventListener("mouseleave", this.handleToggle);
                }
            },
            {
                key: "disconnectedCallback",
                value: function disconnectedCallback() {
                    this.removeEventListener("mouseenter", this.handleToggle);
                    this.removeEventListener("mouseleave", this.handleToggle);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this, content = _this.content, show = _this.show;
                    return (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
                        children: [
                            (0, $85f08a9b324875d4$exports.jsx)("link", {
                                rel: "stylesheet",
                                href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                            }),
                            (0, $85f08a9b324875d4$exports.jsx)("slot", {}),
                            show && (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$28c660c63b792dea, {
                                children: content
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _TooltipBox_show_accessor_storage = new WeakMap();
    $23b04808d9219184$var$$a6f317a49298db85$var$__setFunctionName(_classThis, "TooltipBox");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _show_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        $23b04808d9219184$var$$a6f317a49298db85$var$__esDecorate(_classThis, null, _show_decorators, {
            kind: "accessor",
            name: "show",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "show" in obj;
                },
                get: function(obj) {
                    return obj.show;
                },
                set: function(obj, value) {
                    obj.show = value;
                }
            },
            metadata: _metadata
        }, _show_initializers, _show_extraInitializers);
        $23b04808d9219184$var$$a6f317a49298db85$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        TooltipBox = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23b04808d9219184$var$$a6f317a49298db85$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return TooltipBox = _classThis;
}();
var $23b04808d9219184$var$$99cde405e93e4bfc$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$99cde405e93e4bfc$exports, "DialogClose", function() {
    return $23b04808d9219184$export$fba2fb7cd781b7ac;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$99cde405e93e4bfc$exports, "Dialog", function() {
    return $23b04808d9219184$export$3ddf2d174ce01153;
});
var $23b04808d9219184$var$$99cde405e93e4bfc$var$__esDecorate = function $99cde405e93e4bfc$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23b04808d9219184$var$$99cde405e93e4bfc$var$__runInitializers = function $99cde405e93e4bfc$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23b04808d9219184$var$$99cde405e93e4bfc$var$__classPrivateFieldGet = function $99cde405e93e4bfc$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23b04808d9219184$var$$99cde405e93e4bfc$var$__classPrivateFieldSet = function $99cde405e93e4bfc$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $23b04808d9219184$export$fba2fb7cd781b7ac = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $aPY27._)($99cde405e93e4bfc$export$fba2fb7cd781b7ac, Error1);
    var _super = (0, $SZ4bt._)($99cde405e93e4bfc$export$fba2fb7cd781b7ac);
    function $99cde405e93e4bfc$export$fba2fb7cd781b7ac() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Dialog closed";
        (0, $cc1Ug._)(this, $99cde405e93e4bfc$export$fba2fb7cd781b7ac);
        return _super.call(this, message);
    }
    return $99cde405e93e4bfc$export$fba2fb7cd781b7ac;
}((0, $42e2719c89ddd56d$export$2466d533fda16e33)(Error));
var $23b04808d9219184$export$3ddf2d174ce01153 = function() {
    var _a, _Dialog_defer_accessor_storage;
    var _defer_decorators;
    var _defer_initializers = [];
    var _defer_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function Dialog(Factory) {
            var _this = this;
            (0, $cc1Ug._)(this, Dialog);
            _Dialog_defer_accessor_storage.set(this, $23b04808d9219184$var$$99cde405e93e4bfc$var$__runInitializers(this, _defer_initializers, void 0));
            Object.defineProperty(this, "Component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $23b04808d9219184$var$$99cde405e93e4bfc$var$__runInitializers(this, _defer_extraInitializers)
            });
            this.Component = (0, $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149)(function() {
                return (0, $85f08a9b324875d4$exports.jsx)(Factory, {
                    defer: _this.defer
                });
            });
        }
        (0, $gmv3D._)(Dialog, [
            {
                key: "defer",
                get: function get() {
                    return $23b04808d9219184$var$$99cde405e93e4bfc$var$__classPrivateFieldGet(this, _Dialog_defer_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$99cde405e93e4bfc$var$__classPrivateFieldSet(this, _Dialog_defer_accessor_storage, value, "f");
                }
            },
            {
                key: "open",
                value: function open() {
                    var _this = this;
                    this.defer = new (0, $7f023510481d8142$export$c7e91f8aec23ae14)();
                    this.defer.promise.finally(function() {
                        return _this.defer = undefined;
                    });
                    return this.defer.promise;
                }
            }
        ]);
        return Dialog;
    }(), _Dialog_defer_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _defer_decorators = [
            (0, $b0lSM.observable)
        ];
        $23b04808d9219184$var$$99cde405e93e4bfc$var$__esDecorate(_a, null, _defer_decorators, {
            kind: "accessor",
            name: "defer",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "defer" in obj;
                },
                get: function(obj) {
                    return obj.defer;
                },
                set: function(obj, value) {
                    obj.defer = value;
                }
            },
            metadata: _metadata
        }, _defer_initializers, _defer_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $23b04808d9219184$var$$ed39adb4ffdd84c9$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ed39adb4ffdd84c9$exports, "Modal", function() {
    return $23b04808d9219184$export$2b77a92f1a5ad772;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ed39adb4ffdd84c9$exports, "ModalHeader", function() {
    return $23b04808d9219184$export$f50a68e3694789ee;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ed39adb4ffdd84c9$exports, "ModalTitle", function() {
    return $23b04808d9219184$export$b26fae16ba5468aa;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ed39adb4ffdd84c9$exports, "ModalBody", function() {
    return $23b04808d9219184$export$cb540d8b0ef7906c;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$ed39adb4ffdd84c9$exports, "ModalFooter", function() {
    return $23b04808d9219184$export$519437715052e656;
});
var $23b04808d9219184$var$$ed39adb4ffdd84c9$var$__rest = function $ed39adb4ffdd84c9$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $23b04808d9219184$var$$ed39adb4ffdd84c9$var$emitHide(event) {
    if (event.type === "keyup" ? event.key === "Escape" : event.type === "click" && event.currentTarget.className === "btn-close") event.currentTarget.closest(".modal").dispatchEvent(new CustomEvent("hide"));
}
var $23b04808d9219184$export$2b77a92f1a5ad772 = function(_a) {
    var className = _a.className, backdrop = _a.backdrop, size = _a.size, fullscreen = _a.fullscreen, centered = _a.centered, scrollable = _a.scrollable, animation = _a.animation, show = _a.show, ref = _a.ref, children = _a.children, props = $23b04808d9219184$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "backdrop",
        "size",
        "fullscreen",
        "centered",
        "scrollable",
        "animation",
        "show",
        "ref",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("modal", {
            fade: animation,
            show: show
        }, className),
        "data-bs-backdrop": backdrop != null ? backdrop + "" : undefined,
        tabIndex: -1,
        ariaHidden: !show + "",
        ref: function(node) {
            var _$_a, _b;
            return node ? (_$_a = globalThis.addEventListener) === null || _$_a === void 0 ? void 0 : _$_a.call(globalThis, "keyup", $23b04808d9219184$var$$ed39adb4ffdd84c9$var$emitHide) : (_b = globalThis.removeEventListener) === null || _b === void 0 ? void 0 : _b.call(globalThis, "keyup", $23b04808d9219184$var$$ed39adb4ffdd84c9$var$emitHide);
        }
    }, props, {
        children: (0, $85f08a9b324875d4$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("modal-dialog", size && "modal-".concat(size), fullscreen && "modal-fullscreen".concat(fullscreen === true ? "" : "-".concat(fullscreen)), centered && "modal-dialog-centered", scrollable && "modal-dialog-scrollable"),
            children: (0, $85f08a9b324875d4$exports.jsx)("div", {
                className: "modal-content",
                children: children
            })
        })
    }));
};
var $23b04808d9219184$export$f50a68e3694789ee = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, closeButton = _a.closeButton, props = $23b04808d9219184$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children",
        "closeButton"
    ]);
    return (0, $85f08a9b324875d4$exports.jsxs)("div", Object.assign({
        className: "modal-header ".concat(className)
    }, props, {
        children: [
            children,
            closeButton && (0, $85f08a9b324875d4$exports.jsx)("button", {
                type: "button",
                className: "btn-close",
                ariaLabel: "Close",
                onClick: $23b04808d9219184$var$$ed39adb4ffdd84c9$var$emitHide
            })
        ]
    }));
};
var $23b04808d9219184$export$b26fae16ba5468aa = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "fs-5" : tmp, children = _a.children, props = $23b04808d9219184$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("h1", Object.assign({
        className: "modal-title ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$cb540d8b0ef7906c = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "modal-body ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$519437715052e656 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("div", Object.assign({
        className: "modal-footer ".concat(className)
    }, props, {
        children: children
    }));
};
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$07e74c2207adaaa3$exports, $23b04808d9219184$var$$d3540d749a8620d4$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$07e74c2207adaaa3$exports, $23b04808d9219184$var$$a6f317a49298db85$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$07e74c2207adaaa3$exports, $23b04808d9219184$var$$99cde405e93e4bfc$exports);
$23b04808d9219184$var$$parcel$exportWildcard($23b04808d9219184$var$$07e74c2207adaaa3$exports, $23b04808d9219184$var$$ed39adb4ffdd84c9$exports);
var $23b04808d9219184$var$$97590922d21716c6$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$97590922d21716c6$exports, "NavbarBrand", function() {
    return $23b04808d9219184$export$2df9f3e5f6d355f6;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$97590922d21716c6$exports, "NavbarToggle", function() {
    return $23b04808d9219184$export$e018030c18c7f90a;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$97590922d21716c6$exports, "Navbar", function() {
    return $23b04808d9219184$export$42cfbb80f7861e77;
});
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$97590922d21716c6$exports, "OffcanvasNavbar", function() {
    return $23b04808d9219184$export$d31319d8cbfdaf50;
});
var $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate = function $97590922d21716c6$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers = function $97590922d21716c6$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23b04808d9219184$var$$97590922d21716c6$var$__setFunctionName = function $97590922d21716c6$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet = function $97590922d21716c6$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet = function $97590922d21716c6$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $23b04808d9219184$var$$97590922d21716c6$var$__rest = function $97590922d21716c6$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23b04808d9219184$export$2df9f3e5f6d355f6 = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, children = _a.children, props = $23b04808d9219184$var$$97590922d21716c6$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("a", Object.assign({
        className: "navbar-brand ".concat(className)
    }, props, {
        children: children
    }));
};
var $23b04808d9219184$export$e018030c18c7f90a = function(_a) {
    var tmp = _a.className, className = tmp === void 0 ? "" : tmp, type = _a.type, children = _a.children, props = $23b04808d9219184$var$$97590922d21716c6$var$__rest(_a, [
        "className",
        "type",
        "children"
    ]);
    return (0, $85f08a9b324875d4$exports.jsx)("button", Object.assign({
        className: "navbar-toggler ".concat(className),
        type: "button"
    }, props, {
        children: (0, $85f08a9b324875d4$exports.jsx)("span", {
            className: "navbar-toggler-icon"
        })
    }));
};
var $23b04808d9219184$export$42cfbb80f7861e77 = function(param) {
    var tmp = param.variant, variant = tmp === void 0 ? "light" : tmp, tmp1 = param.bg, bg = tmp1 === void 0 ? "body-tertiary" : tmp1, fixed = param.fixed, sticky = param.sticky, expand = param.expand, children = param.children;
    return (0, $85f08a9b324875d4$exports.jsx)("nav", {
        className: "navbar bg-".concat(bg, " ").concat(fixed ? "fixed-".concat(fixed) : "", " ").concat(sticky ? "sticky-".concat(sticky) : "", " ").concat(expand ? "navbar-expand".concat(expand === true ? "" : "-".concat(expand)) : ""),
        "data-bs-theme": variant,
        children: children
    });
};
var $23b04808d9219184$export$d31319d8cbfdaf50 = function() {
    var _OffcanvasNavbar_variant_accessor_storage, _OffcanvasNavbar_bg_accessor_storage, _OffcanvasNavbar_expand_accessor_storage, _OffcanvasNavbar_fixed_accessor_storage, _OffcanvasNavbar_sticky_accessor_storage, _OffcanvasNavbar_fluid_accessor_storage, _OffcanvasNavbar_title_accessor_storage, _OffcanvasNavbar_brand_accessor_storage, _OffcanvasNavbar_open_accessor_storage, _OffcanvasNavbar_closeButton_accessor_storage;
    var _classDecorators = [
        (0, $e67e4bd0d5ef9fd4$export$d8556a2a8f973135)({
            tagName: "offcanvas-navbar",
            mode: "open"
        }),
        (0, $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _variant_decorators;
    var _variant_initializers = [];
    var _variant_extraInitializers = [];
    var _bg_decorators;
    var _bg_initializers = [];
    var _bg_extraInitializers = [];
    var _expand_decorators;
    var _expand_initializers = [];
    var _expand_extraInitializers = [];
    var _fixed_decorators;
    var _fixed_initializers = [];
    var _fixed_extraInitializers = [];
    var _sticky_decorators;
    var _sticky_initializers = [];
    var _sticky_extraInitializers = [];
    var _fluid_decorators;
    var _fluid_initializers = [];
    var _fluid_extraInitializers = [];
    var _title_decorators;
    var _title_initializers = [];
    var _title_extraInitializers = [];
    var _brand_decorators;
    var _brand_initializers = [];
    var _brand_extraInitializers = [];
    var _open_decorators;
    var _open_initializers = [];
    var _open_extraInitializers = [];
    var _closeButton_decorators;
    var _closeButton_initializers = [];
    var _closeButton_extraInitializers = [];
    var OffcanvasNavbar = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            _OffcanvasNavbar_variant_accessor_storage.set((0, $dOF8f._)(_this), $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _variant_initializers, void 0));
            _OffcanvasNavbar_bg_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _variant_extraInitializers), $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _bg_initializers, void 0)));
            _OffcanvasNavbar_expand_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _bg_extraInitializers), $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _expand_initializers, void 0)));
            _OffcanvasNavbar_fixed_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _expand_extraInitializers), $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _fixed_initializers, void 0)));
            _OffcanvasNavbar_sticky_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _fixed_extraInitializers), $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _sticky_initializers, void 0)));
            _OffcanvasNavbar_fluid_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _sticky_extraInitializers), $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _fluid_initializers, void 0)));
            _OffcanvasNavbar_title_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _fluid_extraInitializers), $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _title_initializers, void 0)));
            Object.defineProperty((0, $dOF8f._)(_this), "titleId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _title_extraInitializers), (0, $e5wYp.uniqueID)())
            });
            _OffcanvasNavbar_brand_accessor_storage.set((0, $dOF8f._)(_this), $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _brand_initializers, void 0));
            Object.defineProperty((0, $dOF8f._)(_this), "offcanvasId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _brand_extraInitializers), (0, $e5wYp.uniqueID)())
            });
            _OffcanvasNavbar_open_accessor_storage.set((0, $dOF8f._)(_this), $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _open_initializers, false));
            _OffcanvasNavbar_closeButton_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _open_extraInitializers), $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _closeButton_initializers, true)));
            Object.defineProperty((0, $dOF8f._)(_this), "close", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($23b04808d9219184$var$$97590922d21716c6$var$__runInitializers((0, $dOF8f._)(_this), _closeButton_extraInitializers), function(event) {
                    if (event instanceof KeyboardEvent && ![
                        "Escape",
                        "Enter"
                    ].includes(event.key)) return;
                    _this.open = false;
                })
            });
            Object.defineProperty((0, $dOF8f._)(_this), "handleLink", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (0, $e5wYp.delegate)("a[href].nav-link", _this.close)
            });
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "variant",
                get: function get() {
                    return $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_variant_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_variant_accessor_storage, value, "f");
                }
            },
            {
                key: "bg",
                get: function get() {
                    return $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_bg_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_bg_accessor_storage, value, "f");
                }
            },
            {
                key: "expand",
                get: function get() {
                    return $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_expand_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_expand_accessor_storage, value, "f");
                }
            },
            {
                key: "fixed",
                get: function get() {
                    return $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_fixed_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_fixed_accessor_storage, value, "f");
                }
            },
            {
                key: "sticky",
                get: function get() {
                    return $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_sticky_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_sticky_accessor_storage, value, "f");
                }
            },
            {
                key: "fluid",
                get: function get() {
                    return $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_fluid_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_fluid_accessor_storage, value, "f");
                }
            },
            {
                key: "title",
                get: function get() {
                    return $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_title_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_title_accessor_storage, value, "f");
                }
            },
            {
                key: "brand",
                get: function get() {
                    return $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_brand_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_brand_accessor_storage, value, "f");
                }
            },
            {
                key: "open",
                get: function get() {
                    return $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_open_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_open_accessor_storage, value, "f");
                }
            },
            {
                key: "closeButton",
                get: function get() {
                    return $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_closeButton_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_closeButton_accessor_storage, value, "f");
                }
            },
            {
                key: "connectedCallback",
                value: function connectedCallback() {
                    var _a;
                    (_a = globalThis.addEventListener) === null || _a === void 0 || _a.call(globalThis, "keyup", this.close, true);
                    this.addEventListener("click", this.handleLink);
                }
            },
            {
                key: "disconnectedCallback",
                value: function disconnectedCallback() {
                    var _a;
                    (_a = globalThis.removeEventListener) === null || _a === void 0 || _a.call(globalThis, "keyup", this.close, true);
                    this.addEventListener("click", this.handleLink);
                }
            },
            {
                key: "renderContent",
                value: function renderContent() {
                    var _this = this;
                    var _this1 = this, variant = _this1.variant, bg = _this1.bg, expand = _this1.expand, fixed = _this1.fixed, sticky = _this1.sticky, fluid = _this1.fluid, brand = _this1.brand, _this2 = this, title = _this2.title, titleId = _this2.titleId, offcanvasId = _this2.offcanvasId, open = _this2.open, closeButton = _this2.closeButton;
                    return (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$42cfbb80f7861e77, {
                        variant: variant,
                        bg: bg,
                        expand: expand,
                        fixed: fixed,
                        sticky: sticky,
                        children: (0, $85f08a9b324875d4$exports.jsxs)($23b04808d9219184$export$42a852a2b6b56249, {
                            fluid: fluid,
                            children: [
                                brand || title,
                                (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$e018030c18c7f90a, {
                                    "aria-controls": offcanvasId,
                                    ariaLabel: "Toggle navigation",
                                    onClick: function() {
                                        return _this.open = true;
                                    }
                                }),
                                (0, $85f08a9b324875d4$exports.jsxs)($23b04808d9219184$export$591ca0244c9dfcd4, {
                                    id: offcanvasId,
                                    "aria-labelledby": titleId,
                                    show: open,
                                    onHide: this.close,
                                    children: [
                                        (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$b6c1518fb8dc5e75, {
                                            closeButton: closeButton,
                                            onHide: function() {
                                                return _this.open = false;
                                            },
                                            children: (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$1b33297d19c3da30, {
                                                id: titleId,
                                                children: brand || title
                                            })
                                        }),
                                        (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$c324d20ecc5b7dee, {
                                            children: (0, $85f08a9b324875d4$exports.jsx)("slot", {})
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
                        children: [
                            (0, $85f08a9b324875d4$exports.jsx)("link", {
                                rel: "stylesheet",
                                href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                            }),
                            this.renderContent()
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _OffcanvasNavbar_variant_accessor_storage = new WeakMap();
    _OffcanvasNavbar_bg_accessor_storage = new WeakMap();
    _OffcanvasNavbar_expand_accessor_storage = new WeakMap();
    _OffcanvasNavbar_fixed_accessor_storage = new WeakMap();
    _OffcanvasNavbar_sticky_accessor_storage = new WeakMap();
    _OffcanvasNavbar_fluid_accessor_storage = new WeakMap();
    _OffcanvasNavbar_title_accessor_storage = new WeakMap();
    _OffcanvasNavbar_brand_accessor_storage = new WeakMap();
    _OffcanvasNavbar_open_accessor_storage = new WeakMap();
    _OffcanvasNavbar_closeButton_accessor_storage = new WeakMap();
    $23b04808d9219184$var$$97590922d21716c6$var$__setFunctionName(_classThis, "OffcanvasNavbar");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _variant_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _bg_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _expand_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _fixed_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _sticky_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _fluid_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _title_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _brand_decorators = [
            (0, $b0lSM.observable)
        ];
        _open_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _closeButton_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _variant_decorators, {
            kind: "accessor",
            name: "variant",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "variant" in obj;
                },
                get: function(obj) {
                    return obj.variant;
                },
                set: function(obj, value) {
                    obj.variant = value;
                }
            },
            metadata: _metadata
        }, _variant_initializers, _variant_extraInitializers);
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _bg_decorators, {
            kind: "accessor",
            name: "bg",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "bg" in obj;
                },
                get: function(obj) {
                    return obj.bg;
                },
                set: function(obj, value) {
                    obj.bg = value;
                }
            },
            metadata: _metadata
        }, _bg_initializers, _bg_extraInitializers);
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _expand_decorators, {
            kind: "accessor",
            name: "expand",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "expand" in obj;
                },
                get: function(obj) {
                    return obj.expand;
                },
                set: function(obj, value) {
                    obj.expand = value;
                }
            },
            metadata: _metadata
        }, _expand_initializers, _expand_extraInitializers);
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _fixed_decorators, {
            kind: "accessor",
            name: "fixed",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "fixed" in obj;
                },
                get: function(obj) {
                    return obj.fixed;
                },
                set: function(obj, value) {
                    obj.fixed = value;
                }
            },
            metadata: _metadata
        }, _fixed_initializers, _fixed_extraInitializers);
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _sticky_decorators, {
            kind: "accessor",
            name: "sticky",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "sticky" in obj;
                },
                get: function(obj) {
                    return obj.sticky;
                },
                set: function(obj, value) {
                    obj.sticky = value;
                }
            },
            metadata: _metadata
        }, _sticky_initializers, _sticky_extraInitializers);
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _fluid_decorators, {
            kind: "accessor",
            name: "fluid",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "fluid" in obj;
                },
                get: function(obj) {
                    return obj.fluid;
                },
                set: function(obj, value) {
                    obj.fluid = value;
                }
            },
            metadata: _metadata
        }, _fluid_initializers, _fluid_extraInitializers);
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _title_decorators, {
            kind: "accessor",
            name: "title",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "title" in obj;
                },
                get: function(obj) {
                    return obj.title;
                },
                set: function(obj, value) {
                    obj.title = value;
                }
            },
            metadata: _metadata
        }, _title_initializers, _title_extraInitializers);
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _brand_decorators, {
            kind: "accessor",
            name: "brand",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "brand" in obj;
                },
                get: function(obj) {
                    return obj.brand;
                },
                set: function(obj, value) {
                    obj.brand = value;
                }
            },
            metadata: _metadata
        }, _brand_initializers, _brand_extraInitializers);
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _open_decorators, {
            kind: "accessor",
            name: "open",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "open" in obj;
                },
                get: function(obj) {
                    return obj.open;
                },
                set: function(obj, value) {
                    obj.open = value;
                }
            },
            metadata: _metadata
        }, _open_initializers, _open_extraInitializers);
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _closeButton_decorators, {
            kind: "accessor",
            name: "closeButton",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "closeButton" in obj;
                },
                get: function(obj) {
                    return obj.closeButton;
                },
                set: function(obj, value) {
                    obj.closeButton = value;
                }
            },
            metadata: _metadata
        }, _closeButton_initializers, _closeButton_extraInitializers);
        $23b04808d9219184$var$$97590922d21716c6$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        OffcanvasNavbar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23b04808d9219184$var$$97590922d21716c6$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return OffcanvasNavbar = _classThis;
}();
var $23b04808d9219184$var$$0ebd9548c1f64027$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$0ebd9548c1f64027$exports, "CountDown", function() {
    return $23b04808d9219184$export$ddd3857461e99bb8;
});
var $23b04808d9219184$var$$0ebd9548c1f64027$var$__runInitializers = function $0ebd9548c1f64027$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23b04808d9219184$var$$0ebd9548c1f64027$var$__esDecorate = function $0ebd9548c1f64027$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23b04808d9219184$var$$0ebd9548c1f64027$var$__setFunctionName = function $0ebd9548c1f64027$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23b04808d9219184$var$$0ebd9548c1f64027$var$__classPrivateFieldGet = function $0ebd9548c1f64027$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23b04808d9219184$var$$0ebd9548c1f64027$var$__classPrivateFieldSet = function $0ebd9548c1f64027$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $23b04808d9219184$var$$0ebd9548c1f64027$var$colors = Object.keys($23b04808d9219184$export$96e9906d6d93a972).filter(function(color) {
    return color !== "tertiary";
}).slice(0, 4);
var $23b04808d9219184$export$ddd3857461e99bb8 = function() {
    var _CountDown_endTime_accessor_storage, _CountDown_rest_accessor_storage, _CountDown_units_accessor_storage;
    var _classDecorators = [
        (0, $e67e4bd0d5ef9fd4$export$d8556a2a8f973135)({
            tagName: "count-down"
        }),
        (0, $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _instanceExtraInitializers = [];
    var _endTime_decorators;
    var _endTime_initializers = [];
    var _endTime_extraInitializers = [];
    var _rest_decorators;
    var _rest_initializers = [];
    var _rest_extraInitializers = [];
    var _units_decorators;
    var _units_initializers = [];
    var _units_extraInitializers = [];
    var _get_timeSections_decorators;
    var CountDown = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            _CountDown_endTime_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$0ebd9548c1f64027$var$__runInitializers((0, $dOF8f._)(_this), _instanceExtraInitializers), $23b04808d9219184$var$$0ebd9548c1f64027$var$__runInitializers((0, $dOF8f._)(_this), _endTime_initializers, Date.now())));
            _CountDown_rest_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$0ebd9548c1f64027$var$__runInitializers((0, $dOF8f._)(_this), _endTime_extraInitializers), $23b04808d9219184$var$$0ebd9548c1f64027$var$__runInitializers((0, $dOF8f._)(_this), _rest_initializers, 0)));
            _CountDown_units_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$0ebd9548c1f64027$var$__runInitializers((0, $dOF8f._)(_this), _rest_extraInitializers), $23b04808d9219184$var$$0ebd9548c1f64027$var$__runInitializers((0, $dOF8f._)(_this), _units_initializers, [
                {
                    scale: 24,
                    label: "D"
                },
                {
                    scale: 60,
                    label: "h"
                },
                {
                    scale: 60,
                    label: "m"
                },
                {
                    scale: 1000,
                    label: "s"
                }
            ])));
            Object.defineProperty((0, $dOF8f._)(_this), "timer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $23b04808d9219184$var$$0ebd9548c1f64027$var$__runInitializers((0, $dOF8f._)(_this), _units_extraInitializers)
            });
            Object.defineProperty((0, $dOF8f._)(_this), "tick", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    var rest = _this.endTime - Date.now();
                    if (rest > 0) {
                        _this.rest = rest;
                        if (!_this.timer) _this.timer = self.setInterval(_this.tick, 1000);
                    } else if (_this.timer) clearInterval(_this.timer);
                }
            });
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "endTime",
                get: function get() {
                    return $23b04808d9219184$var$$0ebd9548c1f64027$var$__classPrivateFieldGet(this, _CountDown_endTime_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$0ebd9548c1f64027$var$__classPrivateFieldSet(this, _CountDown_endTime_accessor_storage, value, "f");
                }
            },
            {
                key: "rest",
                get: function get() {
                    return $23b04808d9219184$var$$0ebd9548c1f64027$var$__classPrivateFieldGet(this, _CountDown_rest_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$0ebd9548c1f64027$var$__classPrivateFieldSet(this, _CountDown_rest_accessor_storage, value, "f");
                }
            },
            {
                key: "units",
                get: function get() {
                    return $23b04808d9219184$var$$0ebd9548c1f64027$var$__classPrivateFieldGet(this, _CountDown_units_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$0ebd9548c1f64027$var$__classPrivateFieldSet(this, _CountDown_units_accessor_storage, value, "f");
                }
            },
            {
                key: "timeSections",
                get: function get() {
                    var _this = this, rest = _this.rest;
                    return this.units.reduce(function(list, param, index, units) {
                        var label = param.label;
                        var scale = units.slice(index).map(function(param) {
                            var scale = param.scale;
                            return scale;
                        }).reduce(function(sum, scale) {
                            return sum * scale;
                        }, 1);
                        var value = ~~(rest / scale);
                        rest -= value * scale;
                        list.push({
                            value: value,
                            label: label
                        });
                        return list;
                    }, []);
                }
            },
            {
                key: "mountedCallback",
                value: function mountedCallback() {
                    if (typeof this.endTime !== "number") this.endTime = new Date(this.endTime).valueOf();
                    this.tick();
                }
            },
            {
                key: "disconnectedCallback",
                value: function disconnectedCallback() {
                    clearInterval(this.timer);
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $85f08a9b324875d4$exports.jsx)("ol", {
                        className: "list-inline text-white",
                        children: this.timeSections.map(function(param, index) {
                            var value = param.value, label = param.label;
                            return (0, $85f08a9b324875d4$exports.jsx)("li", {
                                className: "list-inline-item fs-1 bg-".concat($23b04808d9219184$var$$0ebd9548c1f64027$var$colors[index], " d-inline-flex align-items-center justify-content-center rounded-4"),
                                style: {
                                    width: "5.5rem",
                                    height: "5.5rem"
                                },
                                children: (0, $85f08a9b324875d4$exports.jsxs)("small", {
                                    children: [
                                        (value + "").padStart(2, "0"),
                                        (0, $85f08a9b324875d4$exports.jsx)("sub", {
                                            children: label
                                        })
                                    ]
                                })
                            }, label);
                        })
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _CountDown_endTime_accessor_storage = new WeakMap();
    _CountDown_rest_accessor_storage = new WeakMap();
    _CountDown_units_accessor_storage = new WeakMap();
    $23b04808d9219184$var$$0ebd9548c1f64027$var$__setFunctionName(_classThis, "CountDown");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _endTime_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _rest_decorators = [
            (0, $b0lSM.observable)
        ];
        _units_decorators = [
            (0, $b0lSM.observable)
        ];
        _get_timeSections_decorators = [
            (0, $b0lSM.computed)
        ];
        $23b04808d9219184$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _endTime_decorators, {
            kind: "accessor",
            name: "endTime",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "endTime" in obj;
                },
                get: function(obj) {
                    return obj.endTime;
                },
                set: function(obj, value) {
                    obj.endTime = value;
                }
            },
            metadata: _metadata
        }, _endTime_initializers, _endTime_extraInitializers);
        $23b04808d9219184$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _rest_decorators, {
            kind: "accessor",
            name: "rest",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "rest" in obj;
                },
                get: function(obj) {
                    return obj.rest;
                },
                set: function(obj, value) {
                    obj.rest = value;
                }
            },
            metadata: _metadata
        }, _rest_initializers, _rest_extraInitializers);
        $23b04808d9219184$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _units_decorators, {
            kind: "accessor",
            name: "units",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "units" in obj;
                },
                get: function(obj) {
                    return obj.units;
                },
                set: function(obj, value) {
                    obj.units = value;
                }
            },
            metadata: _metadata
        }, _units_initializers, _units_extraInitializers);
        $23b04808d9219184$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _get_timeSections_decorators, {
            kind: "getter",
            name: "timeSections",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "timeSections" in obj;
                },
                get: function(obj) {
                    return obj.timeSections;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$0ebd9548c1f64027$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CountDown = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23b04808d9219184$var$$0ebd9548c1f64027$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CountDown = _classThis;
}();
var $23b04808d9219184$var$$833abb125114b381$exports = {};
$23b04808d9219184$var$$parcel$export($23b04808d9219184$var$$833abb125114b381$exports, "MonthCalendar", function() {
    return $23b04808d9219184$export$d7a7c85c0f5afc4a;
});
var $23b04808d9219184$var$$833abb125114b381$var$__runInitializers = function $833abb125114b381$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23b04808d9219184$var$$833abb125114b381$var$__esDecorate = function $833abb125114b381$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23b04808d9219184$var$$833abb125114b381$var$__setFunctionName = function $833abb125114b381$var$__setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8OALW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23b04808d9219184$var$$833abb125114b381$var$__classPrivateFieldGet = function $833abb125114b381$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23b04808d9219184$var$$833abb125114b381$var$__classPrivateFieldSet = function $833abb125114b381$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $23b04808d9219184$export$d7a7c85c0f5afc4a = function() {
    var _MonthCalendar_variant_accessor_storage, _MonthCalendar_locale_accessor_storage, _MonthCalendar_value_accessor_storage, _MonthCalendar_currentDate_accessor_storage;
    var _classDecorators = [
        (0, $e67e4bd0d5ef9fd4$export$d8556a2a8f973135)({
            tagName: "month-calendar"
        }),
        (0, $e67e4bd0d5ef9fd4$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _instanceExtraInitializers = [];
    var _variant_decorators;
    var _variant_initializers = [];
    var _variant_extraInitializers = [];
    var _locale_decorators;
    var _locale_initializers = [];
    var _locale_extraInitializers = [];
    var _value_decorators;
    var _value_initializers = [];
    var _value_extraInitializers = [];
    var _get_weekFormatter_decorators;
    var _currentDate_decorators;
    var _currentDate_initializers = [];
    var _currentDate_extraInitializers = [];
    var _get_dateGrid_decorators;
    var MonthCalendar = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $aPY27._)(_classThis, _classSuper);
        var _super = (0, $SZ4bt._)(_classThis);
        function _classThis() {
            (0, $cc1Ug._)(this, _classThis);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            _MonthCalendar_variant_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$833abb125114b381$var$__runInitializers((0, $dOF8f._)(_this), _instanceExtraInitializers), $23b04808d9219184$var$$833abb125114b381$var$__runInitializers((0, $dOF8f._)(_this), _variant_initializers, "primary")));
            _MonthCalendar_locale_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$833abb125114b381$var$__runInitializers((0, $dOF8f._)(_this), _variant_extraInitializers), $23b04808d9219184$var$$833abb125114b381$var$__runInitializers((0, $dOF8f._)(_this), _locale_initializers, void 0)));
            _MonthCalendar_value_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$833abb125114b381$var$__runInitializers((0, $dOF8f._)(_this), _locale_extraInitializers), $23b04808d9219184$var$$833abb125114b381$var$__runInitializers((0, $dOF8f._)(_this), _value_initializers, [])));
            _MonthCalendar_currentDate_accessor_storage.set((0, $dOF8f._)(_this), ($23b04808d9219184$var$$833abb125114b381$var$__runInitializers((0, $dOF8f._)(_this), _value_extraInitializers), $23b04808d9219184$var$$833abb125114b381$var$__runInitializers((0, $dOF8f._)(_this), _currentDate_initializers, new Date())));
            Object.defineProperty((0, $dOF8f._)(_this), "renderDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($23b04808d9219184$var$$833abb125114b381$var$__runInitializers((0, $dOF8f._)(_this), _currentDate_extraInitializers), function(date) {
                    var _$_assert_this_initialized = (0, $dOF8f._)(_this), value = _$_assert_this_initialized.value, dateText = (0, $e5wYp.formatDate)(date, "YYYY-MM-DD");
                    var list = value === null || value === void 0 ? void 0 : value.filter(function(param) {
                        var _$date = param.date;
                        return (0, $e5wYp.formatDate)(_$date, "YYYY-MM-DD") === dateText;
                    });
                    return (0, $85f08a9b324875d4$exports.jsxs)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))({
                            "opacity-50": date.getMonth() !== _this.currentDate.getMonth(),
                            "fw-bold": dateText === (0, $e5wYp.formatDate)(new Date(), "YYYY-MM-DD")
                        }),
                        children: [
                            (0, $85f08a9b324875d4$exports.jsx)("time", {
                                className: "d-block",
                                dateTime: date.toJSON(),
                                children: date.getDate()
                            }),
                            list === null || list === void 0 ? void 0 : list.map(function(item) {
                                return typeof item.content === "object" ? item.content : (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$37acb3580601e69a, {
                                    className: "d-inline-block text-decoration-none w-100 text-truncate",
                                    href: item.link,
                                    onClick: function() {
                                        return _this.emit("select", item);
                                    },
                                    children: item.content
                                });
                            })
                        ]
                    }, date + "");
                })
            });
            return _this;
        }
        (0, $gmv3D._)(_classThis, [
            {
                key: "variant",
                get: function get() {
                    return $23b04808d9219184$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_variant_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_variant_accessor_storage, value, "f");
                }
            },
            {
                key: "locale",
                get: function get() {
                    return $23b04808d9219184$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_locale_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_locale_accessor_storage, value, "f");
                }
            },
            {
                key: "value",
                get: function get() {
                    return $23b04808d9219184$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_value_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_value_accessor_storage, value, "f");
                }
            },
            {
                key: "weekFormatter",
                get: function get() {
                    var _a;
                    var _this = this, tmp = _this.locale, locale = tmp === void 0 ? (_a = globalThis.navigator) === null || _a === void 0 ? void 0 : _a.language : tmp;
                    return new Intl.DateTimeFormat(locale, {
                        weekday: "long"
                    });
                }
            },
            {
                key: "currentDate",
                get: function get() {
                    return $23b04808d9219184$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_currentDate_accessor_storage, "f");
                },
                set: function set(value) {
                    $23b04808d9219184$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_currentDate_accessor_storage, value, "f");
                }
            },
            {
                key: "dateGrid",
                get: function get() {
                    var startDate = new Date(this.currentDate);
                    startDate.setDate(1);
                    startDate = new Date(+startDate - startDate.getDay() * (0, $e5wYp.Day));
                    var dateList = Array.from(new Array(42), function(_, index) {
                        return new Date(+startDate + index * (0, $e5wYp.Day));
                    });
                    return (0, $e5wYp.splitArray)(dateList, 7);
                }
            },
            {
                key: "changeMonth",
                value: function changeMonth(delta) {
                    this.currentDate = (0, $e5wYp.changeMonth)(this.currentDate, delta);
                    this.emit("change", this.currentDate);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    var _this1 = this, style = _this1.style, variant = _this1.variant, weekFormatter = _this1.weekFormatter, currentDate = _this1.currentDate, dateGrid = _this1.dateGrid;
                    return (0, $85f08a9b324875d4$exports.jsxs)($23b04808d9219184$export$54ec01a60f47d33d, {
                        style: Object.assign({
                            tableLayout: "fixed"
                        }, style),
                        children: [
                            (0, $85f08a9b324875d4$exports.jsx)("caption", {
                                children: (0, $85f08a9b324875d4$exports.jsxs)("div", {
                                    className: "d-flex justify-content-between align-items-center",
                                    children: [
                                        (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$353f5b6fc5456de1, {
                                            variant: variant,
                                            onClick: function() {
                                                return _this.changeMonth(-1);
                                            },
                                            children: "<"
                                        }),
                                        (0, $e5wYp.formatDate)(currentDate, "YYYY-MM"),
                                        (0, $85f08a9b324875d4$exports.jsx)($23b04808d9219184$export$353f5b6fc5456de1, {
                                            variant: variant,
                                            onClick: function() {
                                                return _this.changeMonth(1);
                                            },
                                            children: ">"
                                        })
                                    ]
                                })
                            }),
                            (0, $85f08a9b324875d4$exports.jsx)("thead", {
                                children: (0, $85f08a9b324875d4$exports.jsx)("tr", {
                                    children: dateGrid[0].map(function(date, index, param) {
                                        var length = param.length;
                                        return (0, $85f08a9b324875d4$exports.jsx)("td", {
                                            className: "bg-".concat(variant, " text-white"),
                                            style: {
                                                width: "calc(100% / ".concat(length, ")")
                                            },
                                            children: weekFormatter.format(date)
                                        }, index);
                                    })
                                })
                            }),
                            (0, $85f08a9b324875d4$exports.jsx)("tbody", {
                                children: dateGrid.map(function(days) {
                                    return (0, $85f08a9b324875d4$exports.jsx)("tr", {
                                        children: days.map(_this.renderDate)
                                    }, days[0] + "");
                                })
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _MonthCalendar_variant_accessor_storage = new WeakMap();
    _MonthCalendar_locale_accessor_storage = new WeakMap();
    _MonthCalendar_value_accessor_storage = new WeakMap();
    _MonthCalendar_currentDate_accessor_storage = new WeakMap();
    $23b04808d9219184$var$$833abb125114b381$var$__setFunctionName(_classThis, "MonthCalendar");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _variant_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _locale_decorators = [
            (0, $e67e4bd0d5ef9fd4$export$af4b9a83f4b00434),
            (0, $b0lSM.observable)
        ];
        _value_decorators = [
            (0, $b0lSM.observable)
        ];
        _get_weekFormatter_decorators = [
            (0, $b0lSM.computed)
        ];
        _currentDate_decorators = [
            (0, $b0lSM.observable)
        ];
        _get_dateGrid_decorators = [
            (0, $b0lSM.computed)
        ];
        $23b04808d9219184$var$$833abb125114b381$var$__esDecorate(_classThis, null, _variant_decorators, {
            kind: "accessor",
            name: "variant",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "variant" in obj;
                },
                get: function(obj) {
                    return obj.variant;
                },
                set: function(obj, value) {
                    obj.variant = value;
                }
            },
            metadata: _metadata
        }, _variant_initializers, _variant_extraInitializers);
        $23b04808d9219184$var$$833abb125114b381$var$__esDecorate(_classThis, null, _locale_decorators, {
            kind: "accessor",
            name: "locale",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "locale" in obj;
                },
                get: function(obj) {
                    return obj.locale;
                },
                set: function(obj, value) {
                    obj.locale = value;
                }
            },
            metadata: _metadata
        }, _locale_initializers, _locale_extraInitializers);
        $23b04808d9219184$var$$833abb125114b381$var$__esDecorate(_classThis, null, _value_decorators, {
            kind: "accessor",
            name: "value",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "value" in obj;
                },
                get: function(obj) {
                    return obj.value;
                },
                set: function(obj, value) {
                    obj.value = value;
                }
            },
            metadata: _metadata
        }, _value_initializers, _value_extraInitializers);
        $23b04808d9219184$var$$833abb125114b381$var$__esDecorate(_classThis, null, _get_weekFormatter_decorators, {
            kind: "getter",
            name: "weekFormatter",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "weekFormatter" in obj;
                },
                get: function(obj) {
                    return obj.weekFormatter;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$833abb125114b381$var$__esDecorate(_classThis, null, _currentDate_decorators, {
            kind: "accessor",
            name: "currentDate",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentDate" in obj;
                },
                get: function(obj) {
                    return obj.currentDate;
                },
                set: function(obj, value) {
                    obj.currentDate = value;
                }
            },
            metadata: _metadata
        }, _currentDate_initializers, _currentDate_extraInitializers);
        $23b04808d9219184$var$$833abb125114b381$var$__esDecorate(_classThis, null, _get_dateGrid_decorators, {
            kind: "getter",
            name: "dateGrid",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "dateGrid" in obj;
                },
                get: function(obj) {
                    return obj.dateGrid;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $23b04808d9219184$var$$833abb125114b381$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        MonthCalendar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23b04808d9219184$var$$833abb125114b381$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return MonthCalendar = _classThis;
}();




var $55233808982a09db$var$menu = [
    {
        title: "\u8BFE\u7A0B\u7B80\u4ECB",
        href: "#intro"
    },
    {
        title: "\u5BFC\u5E08",
        href: "#teachers"
    },
    {
        title: "\u7CBE\u5F69\u6D3B\u52A8",
        href: "#events"
    },
    {
        title: "\u660E\u661F\u5B66\u5458",
        href: "#students"
    },
    {
        title: "\u8BFE\u7A0B\u4ECB\u7ECD",
        href: "#gallery"
    },
    {
        title: "\u5173\u4E8E\u6211\u4EEC & \u62A5\u540D\u54A8\u8BE2",
        href: "#contact"
    }
];
var $55233808982a09db$export$8b543871300e74c2 = function() {
    return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$42cfbb80f7861e77), {
        expand: "lg",
        fixed: "top",
        className: "scrolling-navbar",
        children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $23b04808d9219184$export$42a852a2b6b56249), {
            children: [
                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$2df9f3e5f6d355f6), {
                    href: ".",
                    children: "3E\u5973\u5B50\u5546\u5B66\u9662"
                }),
                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$e018030c18c7f90a), {}),
                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $23b04808d9219184$export$78768a9af065a7b), {
                    className: "navbar-collapse",
                    id: "Nav",
                    children: [
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$39140c7d8b0ba7b3), {
                            className: "navbar-nav me-auto",
                            children: $55233808982a09db$var$menu.map(function(param) {
                                var title = param.title, href = param.href;
                                return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$b0d92dbee9b5b60d), {
                                    href: href,
                                    children: title
                                }, title);
                            })
                        }),
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $23b04808d9219184$export$39140c7d8b0ba7b3), {
                            className: "navbar-nav nav-flex-icons",
                            children: [
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$b0d92dbee9b5b60d), {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI4MzY0NDQxMg==&scene=126&bizpsid=0#wechat_redirect",
                                    children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$9151c10c0bcf31d3), {
                                        group: "brands",
                                        name: "weixin"
                                    })
                                }),
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$b0d92dbee9b5b60d), {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "nav-link",
                                    href: "https://www.weibo.com/u/6055886285?refer_flag=1001030103_",
                                    children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$9151c10c0bcf31d3), {
                                        group: "brands",
                                        name: "weibo"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};




var $14e051c89426eaa7$export$b18cc124316cb143 = function(param) {
    var name = param.name, avatar = param.avatar, title = param.title, desc = param.desc;
    return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $23b04808d9219184$export$60332b2344f7fe41), {
        className: "card-cascade",
        style: {
            minWidth: "30%"
        },
        children: [
            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("div", {
                className: "view overlay z-depth-1-half",
                children: [
                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$3e431a229df88919), {
                        fluid: true,
                        src: avatar,
                        alt: name
                    }),
                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("div", {
                        className: "mask rgba-black-strong"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $23b04808d9219184$export$851de33184ecdac4), {
                children: [
                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $23b04808d9219184$export$474db65c3c394e1c), {
                        className: "my-3 font-weight-bold d-flex justify-content-between",
                        children: [
                            name,
                            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI4MzY0NDQxMg==&scene=126&bizpsid=0#wechat_redirect",
                                children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$9151c10c0bcf31d3), {
                                    group: "brands",
                                    name: "weixin"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("p", {
                        className: "grey-text",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("p", {
                        className: "grey-text",
                        children: desc
                    })
                ]
            })
        ]
    });
};




var $52bcee5fccbf6a83$export$51c7cbcc07082a77 = function(param) {
    var name = param.name, avatar = param.avatar, title = param.title;
    return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $23b04808d9219184$export$60332b2344f7fe41), {
        className: "card-cascade mb-1",
        children: [
            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$3e431a229df88919), {
                fluid: true,
                src: avatar,
                alt: name
            }),
            name && /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$474db65c3c394e1c), {
                className: "my-4 font-weight-bold",
                children: name
            }),
            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$851de33184ecdac4), {
                children: title && /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("ul", {
                    className: "text-start",
                    children: title.map(function(text) {
                        return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("li", {
                            children: text
                        }, text);
                    })
                })
            })
        ]
    });
};


var $c4d294cf45062f74$export$2e2bcd8739ae039 = [
    {
        time: "6\u670815\u65E5 \u5468\u516D 9:00-12:00",
        teacher: {
            name: "\u51AF\u5CA9",
            title: "\u6D77\u5DDD\u767E\u7EB3\u5546\u4E1A\u7BA1\u7406\u6709\u9650\u516C\u53F8 \u8054\u5408\u521B\u59CB\u4EBA"
        },
        title: "\u5546\u4E1A\u601D\u7EF4 \u4E0E \u5973\u6027\u521B\u4E1A",
        type: "\u7EBF\u4E0B \u6C99\u9F99",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "6\u670815\u65E5 \u5468\u516D 14:00-17:00",
        teacher: {
            name: "TommyDu",
            title: " TOMMY & BROTHER \u521B\u59CB\u4EBA"
        },
        title: "\u5546\u4E1A\u6A21\u5F0F",
        type: "\u7EBF\u4E0B \u6C99\u9F99",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "6\u670819\u65E5 \u5468\u4E09 19:00-21:30",
        teacher: {
            name: "\u8D75\u660E\u6708",
            title: "\u8FBE\u5F8B\u5E08\u4E8B\u52A1\u6240 \u534E\u5609\u5F8B\u5E08\u56E2\u961F \u8054\u5408\u521B\u59CB\u4EBA"
        },
        title: "\u521B\u4E1A\u516C\u53F8 \u7684 \u6CD5\u5F8B\u98CE\u9669\u9632\u63A7",
        type: "\u7EBF\u4E0B \u6C99\u9F99",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "6\u670822\u65E5 \u5468\u516D 9:00-12:00",
        teacher: {
            name: "\u90B1\u6653\u8679",
            title: " PMInternational  \u603B\u88C1"
        },
        title: "\u4E2A\u4EBA\u5929\u8D4B \u53D1\u73B0\u4E0E\u53D1\u6325 \uFF08\u4E0A\uFF09",
        type: "\u7EBF\u4E0B \u6C99\u9F99",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "6\u670822\u65E5 \u5468\u516D 14:00-17:00",
        teacher: {
            name: "\u90B1\u6653\u8679",
            title: " PMInternational  \u603B\u88C1"
        },
        title: "\uFF08\u9009\u4FEE\uFF09 \u4E2A\u4EBA\u5929\u8D4B \u53D1\u73B0\u4E0E\u53D1\u6325 \uFF08\u4E0B\uFF09",
        type: "\u7EBF\u4E0B \u6C99\u9F99",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "6\u670826\u65E5 \u5468\u4E09 19:00-21:30",
        teacher: {
            name: "\u5F20\u68A6\u4F73",
            title: " \u300A\u62C6\u89E3\u300B  \u4F5C\u8005"
        },
        title: "\u7ED3\u6784\u601D\u8003 \u4E0E \u5546\u4E1A\u6A21\u5F0F\u8BBA\u8BC1",
        type: "\u7EBF\u4E0B  \u6C99\u9F99",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "6\u670830\u65E5 \u5468\u65E5 9:00-12:00",
        teacher: {
            name: "\u8096\u9F99",
            title: "\u963F\u4E48 \u521B\u59CB\u4EBA"
        },
        title: "\u4ECE\u54C1\u724C\u6CE8\u518C\u5230 \u9500\u552E\u4E0A\u4EBF\u7684\u5751\u548C\u65B9\u6CD5",
        type: "\u7EBF\u4E0B \u6C99\u9F99",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "6\u670830\u65E5 \u5468\u65E5 14:00-17:00",
        teacher: {
            name: "Mercury",
            title: "M Studio \u82B1\u4E0E\u793C\u7269 \u521B\u59CB\u4EBA"
        },
        title: "\u521D\u521B\u516C\u53F8\u54C1\u724C\u5982\u4F55\u4EE5\u5C0F\u535A\u5927",
        type: "\u7EBF\u4E0B \u6C99\u9F99",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u67083\u65E5 \u5468\u4E09 19:00-21:30",
        teacher: {
            name: "\u9648\u79CB\u6656",
            title: "\u4E45\u8C26\u6559\u80B2\u521B\u59CB\u4EBA"
        },
        title: "\u54C1\u724C\u5982\u4F55 \u8F93\u51FA",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u67087\u65E5 \u5468\u65E5 9:00-12:00",
        teacher: {
            name: "\u6731\u7EEF",
            title: "\u7ACB\u7F8E\u76AE\u80A4\u7BA1\u7406\u673A\u6784 \u4E3B\u7406\u4EBA"
        },
        title: "\u5982\u4F55\u6709\u6548 \u5F00\u53D1\u548C \u7BA1\u7406\u5BA2\u6237 \uFF08\u4E0A\uFF09",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u67087\u65E5 \u5468\u65E5 14:00-17:30",
        teacher: {
            name: "\u6731\u7EEF",
            title: "\u7ACB\u7F8E\u76AE\u80A4\u7BA1\u7406\u673A\u6784 \u4E3B\u7406\u4EBA"
        },
        title: "\uFF08\u9009\u4FEE\uFF09 \u5982\u4F55\u6709\u6548 \u5F00\u53D1\u548C \u7BA1\u7406\u5BA2\u6237 \uFF08\u4E0B\uFF09",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u670810\u65E5 \u5468\u4E09 19:00-21:30",
        teacher: {
            name: "\u5468\u9896",
            title: "\u6210\u90FD\u4E91\u4E2D\u5C71\u8C37\u519C\u4E1A\u79D1\u6280\u6709\u9650\u516C\u53F8\u521B\u59CB\u4EBA"
        },
        title: "\u5982\u4F55\u901A\u8FC7\u54C1\u724C\u5347\u7EA7\u5B9E\u73B0\u4E1A\u7EE9\u589E\u957F",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u670814\u65E5 \u5468\u65E5 9:00-12:00",
        teacher: {
            name: "\u5434\u96C5\u9601",
            title: "\u4FCA\u8BDA\u4F20\u5A92 \u9AD8\u7EA7\u5408\u4F19\u4EBA"
        },
        title: "\u5982\u4F55\u6253\u9020\u5BA2\u6237\u7684 \u6781\u81F4\u4F53\u9A8C",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u670814\u65E5 \u5468\u65E5 14:00-17:00",
        teacher: {
            name: "\u674E\u5B81\u5DDD",
            title: "AK\u5B66\u9662 \u521B\u59CB\u4EBA"
        },
        title: "\u6280\u672F\u5982\u4F55\u4E3A\u521B\u4E1A\u63D0\u4F9B\u52A9\u529B",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u670817\u65E5\u5468\u4E09 19:00-21:30",
        teacher: {
            name: "\u66F9\u9038\u97F5",
            title: "pinkLab \u521B\u59CB\u4EBA"
        },
        title: "\u5982\u4F55\u6253\u9020\u4E00\u4E2A\u5927\u4F17\u70B9\u8BC4\u5168\u57CE\u7B2C1\u7684\u5B9E\u4F53\u5E97",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u670821\u65E5 \u5468\u65E5 9:00-12:00",
        teacher: {
            name: "\u738B\u5A77",
            title: "\u6C47\u667A\u5E7F\u901A\u8D22\u52A1\u54A8\u8BE2 \u521B\u59CB\u4EBA"
        },
        title: "\u8D22\u52A1\u6D41\u7A0B\u89C4\u8303\u5B9E\u64CD",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u670821\u65E5 \u5468\u65E5 14:00-17:00",
        teacher: {
            name: "\u738B\u5A77",
            title: "\u6C47\u667A\u5E7F\u901A\u8D22\u52A1\u54A8\u8BE2 \u521B\u59CB\u4EBA"
        },
        title: "\u7A0E\u52A1\u57FA\u672C\u5E38\u8BC6",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u670824\u65E5 \u5468\u4E09 19:00-21:30",
        teacher: {
            name: "\u718A\u7476",
            title: "51\u793E\u4FDD \u6210\u90FD\u5206\u516C\u53F8 \u603B\u7ECF\u7406"
        },
        title: "\u4EBA\u529B\u89C4\u5212 \u4E0E \u7EE9\u6548\u7BA1\u7406",
        type: "\u7EBF\u4E0B \u6C99\u9F99",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u670828\u65E5 \u5468\u65E5 9:00-12:00",
        teacher: {
            name: "\u9E7F\u96EF\u7ACB",
            title: "\u4E2D\u56FD\u5E78\u798F\u6559\u7EC3\u8054\u76DF \u53D1\u8D77\u4EBA"
        },
        title: "\u5982\u4F55\u8FDB\u884C\u6709\u6548\u6C9F\u901A\uFF0C \u964D\u4F4E\u4F01\u4E1A\u5185\u8017",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "7\u670828\u65E5 \u5468\u65E5 14:00-17:00",
        title: "\u8425\u9500\u9879\u76EE",
        type: "\u7EBF\u4E0B \u5B9E\u64CD\u6F14\u7EC3",
        address: "\u5C0F\u7EC4\u81EA\u9009\u5546\u5708"
    },
    {
        time: "7\u670831\u65E5 \u5468\u4E09 19:00-21:30",
        teacher: {
            name: "\u738B\u4FE1\u6C11",
            title: "\u58F9\u67D2\u7396\u634C\u521B\u65B0\u521B\u4E1A\u6295\u8D44\u4E2D\u5FC3 \u521B\u59CB\u4EBA"
        },
        title: "\u5982\u4F55\u64A9\u4E0A\u6295\u8D44\u4EBA",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "8\u67084\u65E5 \u5468\u65E5 9:00-17:00",
        teacher: {
            name: "\u5C0F\u4F51",
            title: "\u84DD\u8BA1\u5212\u521B\u59CB\u4EBA"
        },
        title: "PPT\u7B56\u5212\u4E0E\u5236\u4F5C",
        type: "\u7EBF\u4E0B \u57F9\u8BAD",
        address: "\u83C1\u84C9\u6C473A\u5EA79\u697C\u8DEF\u6F14\u5385"
    },
    {
        time: "8\u670818\u65E5",
        title: "\u7B2C6\u671F\u521B\u4E1A\u5973\u6027\u8BAD\u7EC3\u8425\u6BD5\u4E1A\u5178\u793C",
        type: "\u6BD5\u4E1A\u5178\u793C",
        address: "\u5F85\u5B9A"
    }
];


var $4aa285fbb26a1380$exports = {};

$4aa285fbb26a1380$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u9648\u79CB\u6656.211cfbfe.jpg";


var $e8a2920011f36aab$exports = {};

$e8a2920011f36aab$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u90B1\u6653\u8679.9b2b60ce.jpg";


var $cd2bd9fbc2de7e75$exports = {};

$cd2bd9fbc2de7e75$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u5468\u9896.d18d1cd6.jpg";


var $5be3b97800a036da$exports = {};

$5be3b97800a036da$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u8D75\u660E\u6708.4ed3dfa3.jpg";


var $9fb1ebdda9964bdb$exports = {};

$9fb1ebdda9964bdb$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u718A\u742A.35c62f0c.jpg";


var $9654d1275e758ebd$exports = {};

$9654d1275e758ebd$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u6731\u7EEF.c1534fb2.jpg";


var $4031faa820a4824e$export$2e2bcd8739ae039 = [
    {
        name: "\u9648\u79CB\u6656",
        avatar: new URL($4aa285fbb26a1380$exports) + "",
        title: "\u6210\u90FD\u4E45\u8C26\u6559\u80B2 \u521B\u59CB\u4EBA",
        desc: "\u8EAB\u4E3A4\u5C81\u5B69\u5B50\u5988\u5988\u7684\u5979\uFF0C\u6DF1\u77E5\u5B69\u5B50\u771F\u771F\u9700\u8981\u7684\u662F\u4EC0\u4E48\uFF0C\u4E8E\u662F\u521B\u529E\u4E86\u4E45\u8C26\u6559\u80B2\u3002 \u4E3B\u8425\u4E1A\u52A1\u662F\u4E3A1.5-6\u5C81\u5C0F\u670B\u53CB\u63D0\u4F9B\u671D\u4E5D\u665A\u4E94\u5168\u65E5\u6258\u80B2\u670D\u52A1\uFF0C\u65E8\u5728\u5E2E\u52A9\u66F4\u591A\u7684\u5E74\u8F7B\u4EBA\u65E2\u80FD\u5E73\u8861\u5DE5\u4F5C\u4E0E\u5BB6\u5EAD\uFF0C \u4E5F\u80FD\u8BA9\u5C0F\u670B\u53CB\u5F97\u5230\u4E13\u4E1A\u7684\u6559\u80B2\u5F15\u5BFC\u53CA\u62A4\u3002\u5728\u7B2C2\u671F\u8BAD\u7EC3\u7ED3\u675F\u540E\u4E45\u8C26\u6559\u80B2\u7684\u53D1\u5C55\u66F4\u662F\u7A33\u4E2D\u6C42\u80DC\uFF0C \u75311\u5BB6\u793E\u533A\u5E97\u53D1\u5C55\u52305\u5BB6\u6258\u80B2\u4E2D\u5FC3\u3002"
    },
    {
        name: "\u90B1\u6653\u8679",
        avatar: new URL($e8a2920011f36aab$exports) + "",
        title: "PM International \u603B\u88C1",
        desc: "\u5979\u662F\u4E00\u4E2A\u5B66\u9738\uFF0C2010\u5E74\u52A0\u62FF\u5927\u6ED1\u94C1\u5362\u5927\u5B66\u7CBE\u7B97\u672C\u79D1\u6BD5\u4E1A\uFF0C2011\u5E74\u4ECE\u7F8E\u56FD\u5BC6\u897F\u6839\u5927\u5B66\u91D1\u878D\u5DE5\u7A0B\u7814\u7A76\u751F\u6BD5\u4E1A\u3002 \u6BD5\u4E1A\u8FC7\u540E\u5979\u5728\u534E\u5C14\u8857\u505A\u8D77\u4E86\u7CBE\u7B97\u5E08\uFF0C\u518D\u540E\u6765\u5979\u63A5\u89E6\u5230\u5FB7\u56FD\u8425\u517B\u54C1\u2014PM International\uFF0C\u5E76\u6210\u4E3A\u4E86\u6708\u9500\u767E\u4E07\u7684\u603B\u88C1\u3002 \u5728\u7B2C4\u671F\u8BAD\u7EC3\u8425\u7ED3\u675F\u540E\uFF0C3E\u5973\u5B50\u5546\u5B66\u9662\u4E5F\u548C\u90B1\u6653\u8679\u6709\u4E86\u8FDB\u4E00\u6B65\u7684\u5408\u4F5C\u3002\u8363\u5347\u81F3\u5BFC\u5E08\u56E2\u961F\uFF0C \u5C06\u4ECE\u7B2C5\u671F\u5F00\u59CB\u8FDB\u884C\u4E2A\u4EBA\u5929\u8D4B\u53D1\u6325\u65B9\u9762\u7684\u8BFE\u9898\u5206\u4EAB\u3002"
    },
    {
        name: "\u5468\u9896",
        avatar: new URL($cd2bd9fbc2de7e75$exports) + "",
        title: "\u6210\u90FD\u4E91\u4E2D\u8C37\u519C\u4E1A\u79D1\u6280\u6709\u9650\u516C\u53F8 \u521B\u59CB\u4EBA",
        desc: "\u4ECE\u65F6\u5C1A\u7F16\u8F91\u5230\u519C\u4EA7\u54C1\u54C1\u724C\u521B\u59CB\u4EBA\uFF0C\u4ECE\u5149\u9C9C\u4EAE\u4E3D\u7684\u804C\u573A\u5230\u9762\u671D\u9EC4\u571F\u80CC\u671D\u5929\uFF0C \u5468\u9896\u8BF42\u5E74\u534A\u519C\u534A\u57CE\u7684\u7406\u60F3\u751F\u6D3B \uFF0C\u91CE\u5FC3\u6210\u5C31\u4E0D\u4E86\u4F60\uFF0C\u4F46\u662F\u7231\u597D\u53EF\u4EE5\u3002 \u57282\u5E74\u534A\u7684\u65F6\u95F4\u91CC\u5468\u9896\u6253\u9020\u4E86\u4E00\u4E2A\u6C34\u679C\u4E2D\u7684\u7F51\u7EA2\u54C1\u724C\u2014 Hi Sweety\u751C\u871C\u7814\u7A76\u6240\u3002 \u5728\u8BAD\u7EC3\u8425\u5B66\u4E60\u8FC7\u540E\uFF0C\u5468\u9896\u5C06\u54C1\u724C\u8FDB\u884C\u4E86\u5347\u7EA7\uFF0C\u4ECE\u4EA7\u54C1\u5230\u5305\u88C5\u90FD\u91CD\u65B0\u8FDB\u884C\u4E86\u68B3\u7406\uFF0C \u6548\u679C\u4E5F\u662F\u5341\u5206\u7684\u663E\u8457\uFF0C\u6708\u9500\u8D85\u8FC7\u767E\u4E07\u3002"
    },
    {
        name: "\u8D75\u660E\u6708",
        avatar: new URL($5be3b97800a036da$exports) + "",
        title: "\u534E\u5609\u5F8B\u5E08\u4E8B\u52A1\u6240 \u8054\u5408\u521B\u59CB\u4EBA\n\n",
        desc: "\u5979\u4E0D\u4EC5\u6709\u7740\u8FC7\u786C\u7684\u4E13\u4E1A\u77E5\u8BC6\uFF0C\u66F4\u6709\u7740\u5F3A\u70C8\u7684\u793E\u4F1A\u8D23\u4EFB\u548C\u62C5\u5F53\uFF0C\u5728\u4E3A\u5973\u6027\u8D62\u53D6\u66F4\u591A\u7684\u6743\u76CA\u4E0A\u505A\u4E86\u5F88\u591A\u52AA\u529B\u3002 \u5728\u8BAD\u7EC3\u7ED3\u675F\u540E\uFF0C\u8D75\u660E\u6708\u548C3E\u5973\u5B50\u5546\u5B66\u9662\u8054\u5408\u6253\u9020\u4E86\u4E00\u7CFB\u5217\u5173\u4E8E\u5973\u6027\u7684\u6CD5\u5F8B\u8BFE\u5802\u3002"
    },
    {
        name: "\u718A\u742A",
        avatar: new URL($9fb1ebdda9964bdb$exports) + "",
        title: "Jbear\u5973\u88C5\u54C1\u724C \u521B\u59CB\u4EBA",
        desc: "\u56E0\u4E3A\u70ED\u7231\u65F6\u5C1A\u548C\u670D\u88C5\u642D\u914D\uFF0C\u718A\u742A2014\u5E74\u5F00\u59CB\u5728\u793E\u4EA4\u5E73\u53F0\u5206\u4EAB\u7A7F\u642D\uFF0C\u5E76\u521B\u7ACBJBear\u5973\u88C5\u54C1\u724C\u3002\u7C89\u4E1D\u7D2F\u8BA1\u8D85\u8FC720\u4E07\u7684J.Bear\u4E00\u76F4\u8FFD\u6C42\u7B80\u7EA6\u3001\u5C0F\u4F17\u3001\u8F7B\u719F\u3001\u5B9E\u7528\u7684\u7A7F\u8863\u98CE\u683C\uFF0C\u5E26\u6765\u517C\u5177\u65F6\u9AE6\u4E0E\u5B9E\u7528\u7684\u5973\u88C5\uFF0C\u7B80\u5355\u67D4\u548C\uFF0C\u8868\u8FBE\u72EC\u7ACB\u4E0E\u81EA\u4FE1\u7684\u6001\u5EA6\uFF0C\u52B1\u5FD7\u6253\u9020\u4E92\u8054\u7F51\u7279\u8272\u5973\u88C5\u54C1\u724C\u3002\u5728\u8BAD\u7EC3\u8425\u5B66\u4E60\u8FC7\u540E\uFF0CJ.bear\u5973\u88C5\u5C06\u4EBA\u3001\u8D22\u3001\u7269\u7B49\u65B9\u9762\u7684\u77E5\u8BC6\u8FDB\u884C\u6709\u6548\u8FD0\u7528\uFF0C\u5728\u77ED\u77ED\u4E00\u5E74\u65F6\u95F4\u5185\u9500\u552E\u989D\u589E\u957F\u8FD150%\u3002\u540C\u65F6\u4E5F\u8BA4\u8BC6\u4E86\u5F88\u591A\u4E00\u8D77\u521B\u4E1A\u7684\u5C0F\u4F19\u4F34\uFF0C\u8BA9\u6211\u7684\u521B\u4E1A\u8DEF\u4E0D\u518D\u5B64\u5355\u3002"
    },
    {
        name: "\u6731\u7EEF",
        avatar: new URL($9654d1275e758ebd$exports) + "",
        title: "\u7ACB\u7F8E\u76AE\u80A4\u7BA1\u7406\u7ED3\u6784 \u4E3B\u7406\u4EBA",
        desc: "\u5728\u5962\u4F88\u54C1\u54C1\u724C\u5DE5\u4F5C\u591A\u5E74\u7684\u5979\u8F9E\u804C\u5F00\u59CB\u521B\u4E1A\uFF0C\u521B\u529E\u4E86\u7ACB\u7F8E\u76AE\u80A4\u7BA1\u7406\u673A\u6784\u3002 \u5728\u5F00\u59CB\u521B\u7ACB\u4E0D\u4E45\u6731\u7EEF\u8FDB\u51653E\u5973\u5B50\u5546\u5B66\u9662\u5B66\u4E60\uFF0C\u5728\u8FD9\u4E2A\u8FC7\u7A0B\u4E2D\u5979\u5728\u54C1\u724C\u8F93\u51FA\uFF0C\u5E02\u573A\u5408\u4F5C\u65B9\u9762\u90FD\u6709\u6548\u7684\u589E\u957F\u3002 \u56E0\u4E3A\u5728\u5962\u4F88\u54C1\u54C1\u724C\u5DE5\u4F5C\u8FC7\u5F88\u957F\u65F6\u95F4\u5E76\u4E14\u957F\u671F\u62FF\u5230\u9500\u51A0\uFF0C\u6240\u4EE5\u6731\u7EEF\u5728\u5BA2\u6237\u7BA1\u7406\u65B9\u9762\u6709\u7740\u5341\u5206\u4E30\u5BCC\u7684\u7ECF\u9A8C\uFF0C \u5728\u7B2C4\u671F\u8BAD\u7EC3\u8425\u7ED3\u675F\u4EE5\u540E\u4E5F\u4E0E3E\u5973\u5B50\u5546\u5B66\u9662\u6709\u4E86\u8FDB\u4E00\u6B65\u5408\u4F5C\uFF0C\u8363\u5347\u81F3\u5BFC\u5E08\u3002"
    }
];


var $76f1402ece6b7c99$exports = {};

$76f1402ece6b7c99$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "course_intro.2e9c693e.jpeg";


var $323e553ad7e69717$export$ebbbf54bd737ba84 = {
    name: "\u9002 \u5408 \u4EBA \u7FA4",
    avatar: new URL($76f1402ece6b7c99$exports) + "",
    title: [
        "\u6709\u660E\u786E\u521B\u4E1A\u6253\u7B97\u7684\u5973\u6027",
        "\u5973\u6027\u521D\u521B\u4E1A\u8005\uFF08\u521B\u4E1A\u9879\u76EE\u4E0D\u6EE13\u5E74\uFF09"
    ]
};
var $172b41e6f538cfc4$exports = {};

$172b41e6f538cfc4$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u9E7F\u96EF\u7ACB.18c67b42.png";


var $8fef29b7849c4600$exports = {};

$8fef29b7849c4600$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u5C0F\u4F51.0421422c.png";


var $0985194ce38de3fd$exports = {};

$0985194ce38de3fd$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u51AF\u5CA9.7ea3c995.png";


var $d14943ba37a7117b$exports = {};

$d14943ba37a7117b$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u738B\u5A77.c56e1dcc.png";


var $05bbd8bae743ff9b$exports = {};

$05bbd8bae743ff9b$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "Mercury.4d8472f7.png";


var $16e4f6d06c1d0725$exports = {};

$16e4f6d06c1d0725$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "Tommy_Du.55892a4c.png";


var $323e553ad7e69717$export$2e2bcd8739ae039 = [
    {
        teachers: [
            $323e553ad7e69717$export$ebbbf54bd737ba84,
            {
                name: "\u9E7F\u96EF\u7ACB",
                avatar: new URL($172b41e6f538cfc4$exports) + "",
                title: [
                    "\u4E2D\u56FD\u5E78\u798F\u6559\u7EC3\u8054\u76DF \u53D1\u8D77\u4EBA",
                    "\u7F8E\u56FD\u804C\u4E1A\u57F9\u8BAD\u8BA4\u8BC1\u534F\u4F1A \u57F9\u8BAD\u5E08",
                    "\u7545\u9500\u4E66\u4F5C\u5BB6"
                ]
            },
            {
                name: "\u5C0F\u4F51",
                avatar: new URL($8fef29b7849c4600$exports) + "",
                title: [
                    "\u6210\u90FD\u84DD\u8BA1\u5212\u6F14\u793A\u8BBE\u8BA1\u6709\u9650\u516C\u53F8 \u9879\u76EE\u603B\u76D1"
                ]
            }
        ]
    },
    {
        teachers: [
            $323e553ad7e69717$export$ebbbf54bd737ba84,
            {
                name: "\u51AF\u5CA9",
                avatar: new URL($0985194ce38de3fd$exports) + "",
                title: [
                    "\u6210\u90FD\u6D77\u5DDD\u767E\u7EB3\u5546\u4E1A\u7BA1\u7406\u6709\u9650\u516C\u53F8 \u8054\u5408\u521B\u59CB\u4EBA",
                    "\u6C5F\u6E56\u706B\u9505 \u521B\u59CB\u4EBA"
                ]
            },
            {
                name: "\u738B\u5A77",
                avatar: new URL($d14943ba37a7117b$exports) + "",
                title: [
                    "\u6C47\u667A\u5E7F\u901A\u8D22\u52A1\u54A8\u8BE2 \u521B\u59CB\u4EBA"
                ]
            }
        ]
    },
    {
        teachers: [
            $323e553ad7e69717$export$ebbbf54bd737ba84,
            {
                name: "Mercury",
                avatar: new URL($05bbd8bae743ff9b$exports) + "",
                title: [
                    "M Studio\u82B1\u4E0E\u793C\u7269 \u521B\u59CB\u4EBA",
                    "\u5168\u7403\u6700\u5927\u5A92\u4ECB\u96C6\u56E2\u7FA4\u9091\u4E2D\u56FD \u5A92\u4F53\u7B56\u5212\u603B\u76D1",
                    "\u7FA4\u9091\u4E9A\u592A\u533A30\u4F4D30\u5C81\u4EE5\u4E0B\u5E74\u8F7B\u9886\u5BFC\u8005\u4E4B\u4E00"
                ]
            },
            {
                name: "Tommy Du",
                avatar: new URL($16e4f6d06c1d0725$exports) + "",
                title: [
                    "Tommy & Brothers \u9AD8\u7EA7\u5B9A\u5236 \u521B\u59CB\u4EBA",
                    "Zegna \u5927\u533A\u7ECF\u7406",
                    "Stefano Ricci \u5927\u4E2D\u534E\u533A \u603B\u76D1"
                ]
            }
        ]
    }
];


var $013b33932f289845$exports = {};

$013b33932f289845$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u5B98\u7F51-\u62DB\u52DF.dbd535b2.jpg";


var $1ef1ce7d728c2513$exports = {};

$1ef1ce7d728c2513$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u5B98\u7F51banner\u521B\u59CB\u4EBA.7b897ff9.jpg";


var $8f96dd7e7cf9dc9f$exports = {};

$8f96dd7e7cf9dc9f$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "\u5B98\u7F51\u96C6\u9526.747b004a.jpeg";


var $b1027c6b1eea2817$var$events = [
    {
        image: new URL($013b33932f289845$exports) + "",
        link: "https://na6pe3xlrb1jajy5.mikecrm.com/q19wZQs"
    },
    {
        image: new URL($1ef1ce7d728c2513$exports) + "",
        link: "https://www.baidu.com/s?wd=\u674E\u8BB8\u73CA\u73CA"
    },
    {
        image: new URL($8f96dd7e7cf9dc9f$exports) + "",
        link: "https://mp.weixin.qq.com/s/xfqLOw6o8h6slB8bXV2T2w"
    }
];
var $99c00b30a2c4d053$exports = {};

$99c00b30a2c4d053$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "poster.6b689ac9.jpeg";


var $709c2fd329428b94$exports = {};

$709c2fd329428b94$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "12.16\u81F3\u52C7\u65B0\u751F.434937a3.ogg";


var $26c8e11d247471f9$exports = {};

$26c8e11d247471f9$exports = (parcelRequire("99xe3")).getBundleURL("bzIO2") + "as_qrcode.14881807.jpeg";


var $b1027c6b1eea2817$export$6a3e0e8de7fede64 = function() {
    return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $85f08a9b324875d4$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $55233808982a09db$export$8b543871300e74c2), {}),
            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("header", {
                id: "intro",
                className: "view",
                children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("div", {
                    className: "mask rgba-black-strong",
                    children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$42a852a2b6b56249), {
                        fluid: true,
                        className: "d-flex align-items-center justify-content-center h-100",
                        children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("div", {
                            className: "row d-flex justify-content-center text-center",
                            children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("div", {
                                className: "col-md-10",
                                children: [
                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("h2", {
                                        className: "display-4 font-weight-bold white-text pt-5 mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("span", {
                                                className: "font-weight-normal",
                                                style: {
                                                    fontSize: "xx-large"
                                                },
                                                children: "\u521D\u521B\u5973\u6027"
                                            }),
                                            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("br", {}),
                                            "\u8BAD\u7EC3\u8425"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("hr", {
                                        className: "hr-light"
                                    }),
                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("h4", {
                                        className: "white-text my-4 text-end",
                                        children: "\u901A\u8FC7\u7EBF\u4E0B\u4E3A\u671F2\u4E2A\u6708\u7684\u77ED\u671F\u8BAD\u7EC3\u8425\uFF0C\u4E0E\u540E\u671F\u966A\u4F34\u5F0F\u7684\u521B\u4E1A\u5708\u5C42\u7EC4\u7EC7\u3001 \u4E2A\u4EBA\u54A8\u8BE2\u670D\u52A1\u7684\u65B9\u5F0F\uFF0C\u63D0\u9AD8\u5973\u6027\u521B\u4E1A\u8005\u7684\u7EFC\u5408\u80FD\u529B\u3002"
                                    }),
                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("a", {
                                        href: "#contact",
                                        children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $23b04808d9219184$export$353f5b6fc5456de1), {
                                            variant: "outline-white",
                                            children: [
                                                "\u4E86\u89E3\u66F4\u591A",
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$9151c10c0bcf31d3), {
                                                    group: "solid",
                                                    name: "award",
                                                    className: "ms-2"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("main", {
                className: "mt-5",
                children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $23b04808d9219184$export$42a852a2b6b56249), {
                    children: [
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("section", {
                            id: "courses",
                            className: "text-center",
                            children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)((0, $23b04808d9219184$export$54ec01a60f47d33d), {
                                responsive: true,
                                striped: true,
                                bordered: true,
                                className: "table-fixed text-center",
                                children: [
                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("thead", {
                                        className: "warning-color-dark text-white",
                                        children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("th", {
                                                    scope: "col",
                                                    children: "\u65F6\u95F4"
                                                }),
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("th", {
                                                    scope: "col",
                                                    children: "\u5BFC\u5E08"
                                                }),
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("th", {
                                                    scope: "col",
                                                    children: "\u8BFE\u9898"
                                                }),
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("th", {
                                                    scope: "col",
                                                    children: "\u7C7B\u578B"
                                                }),
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("th", {
                                                    scope: "col",
                                                    children: "\u5730\u5740"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("tbody", {
                                        children: (0, $c4d294cf45062f74$export$2e2bcd8739ae039).map(function(param) {
                                            var title = param.title, type = param.type, teacher = param.teacher, time = param.time, address = param.address;
                                            return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("td", {
                                                        children: time
                                                    }),
                                                    teacher && /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("ul", {
                                                            className: "list-unstyled",
                                                            children: [
                                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("li", {
                                                                    children: teacher.name
                                                                }),
                                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("li", {
                                                                    children: teacher.title
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("td", {
                                                        colSpan: teacher ? 1 : 2,
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("td", {
                                                        children: type
                                                    }),
                                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("td", {
                                                        children: address
                                                    })
                                                ]
                                            }, title);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("section", {
                            id: "teachers",
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("h2", {
                                    className: "mb-5 font-weight-bold",
                                    children: "\u91D1\u724C\u5BFC\u5E08\u9635\u5BB9"
                                }),
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("div", {
                                    className: "row d-flex justify-content-center mb-4",
                                    children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("p", {
                                        className: "col-md-8 grey-text",
                                        children: "3E\u5973\u5B50\u5546\u5B66\u9662\u7684\u5BFC\u5E08\u5747\u6765\u81EA\u672C\u571F\u5404\u884C\u4E1A\u62E5\u6709\u4E30\u5BCC\u521B\u6295\u7ECF\u9A8C\u7684\u7CBE\u82F1\uFF0C\u5E73\u5747\u76F8\u5173\u4ECE\u4E1A\u884C\u4E1A\u572810\u5E74\u4EE5\u4E0A\u3002 \u4ED6\u4EEC\u57283E\u5973\u5B50\u5546\u5B66\u9662\u7684\u4EBA\u3001\u8D22\u3001\u52A1\u7CFB\u7EDF\u8BFE\u7A0B\u4F53\u7CFB\u8BBE\u7F6E\u4E4B\u4E0B\uFF0C\u4EE5\u8F93\u51FA\u5E26\u52A8\u8F93\u5165\u7684\u7406\u5FF5\uFF0C\u5C06\u5404\u81EA\u64C5\u957F\u9886\u57DF\u7684\u601D\u7EF4\u6A21\u5F0F\u3001 \u5B9E\u6218\u7ECF\u9A8C\u6307\u5BFC\u521B\u4E1A\u5973\u6027\u8FB9\u5B66\u8FB9\u7EC3\uFF0C\u66F4\u5FEB\u66F4\u6709\u6548\u7684\u5E2E\u52A9\u5927\u5BB6\u5438\u6536\u548C\u6210\u957F\uFF0C\u4FC3\u8FDB\u9879\u76EE\u7684\u53D1\u5C55\u548C\u76C8\u5229\u3002"
                                    })
                                }),
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$144901db2ea8e967), {
                                        className: "col-md-12",
                                        interval: 3000,
                                        children: (0, $323e553ad7e69717$export$2e2bcd8739ae039).map(function(param) {
                                            var _$teachers = param.teachers;
                                            return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$42c20acb2971398c), {
                                                children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("div", {
                                                    className: "d-flex gap-3",
                                                    children: _$teachers.map(function(teacher) {
                                                        return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $52bcee5fccbf6a83$export$51c7cbcc07082a77), (0, $f9EKS._)({}, teacher));
                                                    })
                                                })
                                            });
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("hr", {
                            className: "my-5"
                        }),
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("section", {
                            id: "events",
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("h2", {
                                    className: "mb-5 font-weight-bold ",
                                    children: "\u7CBE\u5F69\u6D3B\u52A8"
                                }),
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("video", {
                                    className: "video-fluid z-depth-1 object-fit-cover",
                                    loop: true,
                                    controls: true,
                                    autoplay: true,
                                    poster: new URL($99c00b30a2c4d053$exports) + "",
                                    children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("source", {
                                        src: new URL($709c2fd329428b94$exports) + "",
                                        type: "video/ogg"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("hr", {
                            className: "my-5"
                        }),
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("section", {
                            id: "students",
                            children: [
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("h2", {
                                    className: "mb-5 font-weight-bold text-center",
                                    children: "\u660E\u661F\u5B66\u5458"
                                }),
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("ul", {
                                    className: "list-unstyled row g-4",
                                    children: (0, $4031faa820a4824e$export$2e2bcd8739ae039).map(function(student) {
                                        return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("li", {
                                            className: "col-lg-4 col-md-12",
                                            children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $14e051c89426eaa7$export$b18cc124316cb143), (0, $f9EKS._)({}, student))
                                        }, student.name);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("hr", {
                            className: "my-5"
                        }),
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("section", {
                            id: "gallery",
                            children: [
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("h2", {
                                    className: "mb-5 font-weight-bold text-center",
                                    children: "\u8BFE\u7A0B\u4ECB\u7ECD"
                                }),
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("div", {
                                            className: "col-md-6 mb-4",
                                            children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$144901db2ea8e967), {
                                                children: $b1027c6b1eea2817$var$events.map(function(param) {
                                                    var link = param.link, image = param.image;
                                                    return /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$42c20acb2971398c), {
                                                        children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("a", {
                                                            href: link,
                                                            children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$3e431a229df88919), {
                                                                className: "d-block w-100",
                                                                src: image
                                                            })
                                                        })
                                                    }, link);
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("a", {
                                                    href: "",
                                                    className: "teal-text",
                                                    children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("h6", {
                                                        className: "pb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$9151c10c0bcf31d3), {
                                                                group: "solid",
                                                                name: "school"
                                                            }),
                                                            "\u521D\u521B\u5973\u6027\u8BAD\u7EC3\u8425"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("h4", {
                                                    className: "mb-3 font-weight-bold",
                                                    children: "\u4F60\u5C06\u83B7\u5F97"
                                                }),
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("p", {
                                                    children: [
                                                        "\u57FA\u4E8E\u4EBA\u3001\u8D22\u3001\u52A1\uFF0C\u4ECE0\u52301\u7CFB\u7EDF\u7684\u521B\u4E1A\u9879\u76EE\u68B3\u7406",
                                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("br", {}),
                                                        "\u63D0\u5347\u5BF9\u4E2A\u4EBA\u548C\u521B\u4E1A\u8BA4\u77E5\uFF0C\u5168\u5C40\u89C2\u521B\u4E1A",
                                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("br", {}),
                                                        "\u5C11\u8D70\u5F2F\u8DEF\uFF0C\u964D\u4F4E\u7ECF\u9A8C\u4E0D\u8DB3\u5E26\u6765\u7684\u65F6\u95F4\u548C\u8D44\u91D1\u6210\u672C",
                                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("br", {}),
                                                        "\u786E\u5B9A\u4E2A\u4EBA\u521B\u4E1A\u4F18\u52BF\uFF0C\u63D0\u5347\u4E2A\u4EBA\u7EFC\u5408\u5B9E\u529B",
                                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("br", {}),
                                                        "\u6E05\u6670\u7684\u54C1\u724C\u5B9A\u4F4D\u548C\u63A8\u5E7F\u601D\u8DEF",
                                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("br", {}),
                                                        "\u5EFA\u7ACB\u5546\u4E1A\u95ED\u73AF\uFF0C\u66F4\u5FEB\u5B9E\u73B0\u76C8\u5229",
                                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("br", {}),
                                                        "\u4E2A\u4EBA\u9B45\u529B\u548C\u521B\u4E1A\u9879\u76EE\uFF0C\u57281000\u4EBA\u5927\u4F1A\u4E0A\u7684\u5C55\u793A\u673A\u4F1A",
                                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("br", {}),
                                                        "\u5FD7\u540C\u9053\u5408\u7684\u4F19\u4F34\uFF0C\u8BA9\u6210\u957F\u8DEF\u4E0A\u4E0D\u5B64\u5355"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("hr", {
                            className: "my-5"
                        }),
                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("section", {
                            id: "contact",
                            children: [
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("h2", {
                                    className: "mb-5 font-weight-bold text-center",
                                    children: "\u8054\u7CFB\u6211\u4EEC"
                                }),
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("div", {
                                            className: "col-lg-5 col-md-12 text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("h4", {
                                                    children: "\u54A8\u8BE2\u5C0F\u52A9\u624B\u83B7\u5F97\u4E86\u89E3\u66F4\u591A"
                                                }),
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$3e431a229df88919), {
                                                    src: new URL($26c8e11d247471f9$exports) + "",
                                                    fluid: true,
                                                    className: "h-75"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("div", {
                                            className: "col-lg-7 col-md-12",
                                            children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("iframe", {
                                                className: "z-depth-1-half w-100 mb-5",
                                                style: {
                                                    height: "400px"
                                                },
                                                src: "https://uri.amap.com/marker?src=3e-wbc&callnative=1&position=104.062617, 30.539173&name=3E\u5973\u5B50\u5546\u5B66\u9662"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("div", {
                                    className: "row text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("p", {
                                            className: "col-lg-4 col-md-12 mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$9151c10c0bcf31d3), {
                                                    group: "solid",
                                                    name: "map",
                                                    className: "me-2 grey-text"
                                                }),
                                                "\u6210\u90FD \u56DB\u5DDD \u4E2D\u56FD"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("p", {
                                            className: "col-lg-4 col-md-6 mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$9151c10c0bcf31d3), {
                                                    group: "solid",
                                                    name: "building",
                                                    className: "me-2 grey-text"
                                                }),
                                                "\u5468\u4E00 - \u5468\u4E94, 10:00-19:00"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("p", {
                                            className: "col-lg-4 col-md-6 mb-3",
                                            children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsxs)("a", {
                                                href: "tel:+8617308077367",
                                                children: [
                                                    /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $23b04808d9219184$export$9151c10c0bcf31d3), {
                                                        group: "solid",
                                                        name: "phone",
                                                        className: "me-2 grey-text"
                                                    }),
                                                    "+86 173 0807 7367"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("div", {
                                    className: "row text-center",
                                    children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("div", {
                                        className: "col-lg-4 col-md-6 mb-3",
                                        children: /*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)("a", {
                                            href: "http://www.beian.miit.gov.cn",
                                            children: "\u8700ICP\u590719022231\u53F7"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


(0, $e5wYp.documentReady).then(function() {
    return new (0, $e43ab9b9c825724a$exports.DOMRenderer)().render(/*#__PURE__*/ (0, $85f08a9b324875d4$exports.jsx)((0, $b1027c6b1eea2817$export$6a3e0e8de7fede64), {}));
});

})();
//# sourceMappingURL=index.f0825904.js.map
